import React from "react";
import { IconValuesProps } from "../../../../shared/models/component/base.model";

export const RightArrow = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0760223 10.0403L12.7141 10.0403L6.9091 15.8453L8.38371 17.3096L16.6914 9.00188L8.38372 0.694185L6.91949 2.15842L12.7141 7.96342L0.0760226 7.96342L0.0760223 10.0403Z"
      fill="currentColor"
    />
  </svg>
);
export const ForwardArrow = () => (
  <svg
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.163933 11.1729C-0.0347738 10.9781 -0.0528383 10.6733 0.10974 10.4585L0.163933 10.397L4.64894 6.00033L0.163933 1.60368C-0.0347738 1.40888 -0.0528383 1.10405 0.10974 0.889242L0.163933 0.827702C0.362639 0.632902 0.673582 0.615193 0.892695 0.774575L0.95547 0.827702L5.83607 5.61234C6.03477 5.80714 6.05284 6.11197 5.89026 6.32677L5.83607 6.38831L0.95547 11.1729C0.736893 11.3872 0.38251 11.3872 0.163933 11.1729Z"
      fill="currentColor"
    />
  </svg>
);

export const UserIcon = ({
  width = "24",
  height = "24",
  strokeColor = "currentColor",
  strokeWidth = "1.5",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 20V19.25C20 16.9028 18.0972 15 15.75 15H8.25C5.90279 15 4 16.9028 4 19.25V20"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="7"
      r="4"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BuildingIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4943 19.0027V22.0039"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="18.002"
      y="11.9998"
      width="5.00208"
      height="7.00292"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.49826 20.0029V22.0038"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.49609 17.0017H12.4986"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.49609 14.0005H12.4986"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.49609 10.9992H12.4986"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5028 11.9997V4.99675C20.5028 4.44424 20.0549 3.99634 19.5024 3.99634H9.99846C9.44595 3.99634 8.99805 4.44424 8.99805 4.99675V7.998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99609 22.0039V8.99846C3.99609 8.44595 4.444 7.99805 4.99651 7.99805H14.0003C14.5528 7.99805 15.0007 8.44595 15.0007 8.99846V22.0039"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.99414 22.0039H23.0025"
      stroke="currentColo"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 8.25H3V4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9999 12C20.9999 7.029 16.9709 3 11.9999 3C8.36993 3 5.24893 5.154 3.82593 8.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 15.75H21V19.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12C3 16.971 7.029 21 12 21C15.63 21 18.751 18.846 20.174 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VerifyConfirmationIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 52C42.1503 52 52 42.1503 52 30C52 17.8497 42.1503 8 30 8C17.8497 8 8 17.8497 8 30C8 42.1503 17.8497 52 30 52Z"
      fill="#387C88"
    />
    <path
      d="M25.9898 40.0804L19.3699 31.4519L23.2196 28.4169L26.3541 32.5022L36.9441 21.1711L40.4853 24.5717L25.9898 40.0804Z"
      fill="white"
    />
    <circle cx="30" cy="30" r="29" stroke="#387C88" strokeWidth="2" />
  </svg>
);

export const TermsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="9"
      y="11.5"
      width="6"
      height="4"
      rx="1.25"
      stroke="#387C88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 11.5V10.25C13.75 9.2835 12.9665 8.5 12 8.5V8.5C11.0335 8.5 10.25 9.2835 10.25 10.25V11.5"
      stroke="#387C88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 13.0209C20 16.7956 15.3552 19.5997 13.1401 20.7255C12.4255 21.0909 11.579 21.0916 10.8636 20.7275C8.65012 19.6027 4 16.7918 4 13.0209V7.56938C4.00735 7.05853 4.39423 6.63324 4.9021 6.5777C7.02402 6.41646 9.05835 5.66412 10.7746 4.40594C11.5019 3.86469 12.4981 3.86469 13.2254 4.40594C14.9416 5.66412 16.9759 6.41646 19.0979 6.5777C19.6057 6.63322 19.9926 7.05852 20 7.56938V13.0209Z"
      stroke="#387C88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5582 14.5577C14.9186 15.6361 13.6764 16.2036 12.4426 15.9811C11.2087 15.7585 10.243 14.7928 10.0205 13.559C9.79795 12.3251 10.3654 11.0829 11.4438 10.4434"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9966 17.9961C17.2719 19.3043 15.1649 20.0094 13.0001 20.0028C9.41297 20.0667 6.09862 18.0953 4.44251 14.9127C3.84761 13.7069 3.84761 12.2929 4.44251 11.0871C5.27076 9.43773 6.59106 8.08646 8.2208 7.22021"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4275 15.1345C21.4677 15.0585 21.5199 14.9903 21.5578 14.9128C22.1527 13.707 22.1527 12.293 21.5578 11.0872C19.9017 7.90465 16.5873 5.93323 13.0002 5.99711C12.7753 5.99711 12.5567 6.02712 12.3347 6.04175"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0039 21.0037L4.99683 3.99658"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6875 7.85938H4.56672L10.5934 1.83266L9.0625 0.3125L0.4375 8.9375L9.0625 17.5625L10.5827 16.0423L4.56672 10.0156H17.6875V7.85938Z"
      fill="black"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="12px"
    height="12px"
    viewBox="0 0 122.875 122.648"
    enableBackground="new 0 0 122.875 122.648"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.993,47.079c7.683-0.059,13.898,6.12,13.882,13.805 c-0.018,7.683-6.26,13.959-13.942,14.019L75.24,75.138l-0.235,33.73c-0.063,7.619-6.338,13.789-14.014,13.78 c-7.678-0.01-13.848-6.197-13.785-13.818l0.233-33.497l-33.558,0.235C6.2,75.628-0.016,69.448,0,61.764 c0.018-7.683,6.261-13.959,13.943-14.018l33.692-0.236l0.236-33.73C47.935,6.161,54.209-0.009,61.885,0 c7.678,0.009,13.848,6.197,13.784,13.818l-0.233,33.497L108.993,47.079L108.993,47.079z"
      />
    </g>
  </svg>
);

export const SpinIcon = () => (
  <svg
    className="h-full w-ful text-inherit animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const HumbergIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1H12" stroke="currentColor" strokeWidth="1.5" />
    <path d="M0 6H12" stroke="currentColor" strokeWidth="1.5" />
    <path d="M0 11H12" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const FilterIcon = ({
  width = "14",
  height = "13",
  strokeColor = "currentColor",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58794 9.51655H1.16235"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4078 9.51657C12.4078 10.7095 11.4407 11.6766 10.2478 11.6766C9.05483 11.6766 8.08777 10.7095 8.08777 9.51657C8.08777 8.32274 9.05483 7.35657 10.2478 7.35657C11.4407 7.35657 12.4078 8.32274 12.4078 9.51657Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.98181 3.69655H12.4083"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16199 3.69656C1.16199 4.89038 2.12905 5.85656 3.32199 5.85656C4.51493 5.85656 5.48199 4.89038 5.48199 3.69656C5.48199 2.50362 4.51493 1.53656 3.32199 1.53656C2.12905 1.53656 1.16199 2.50362 1.16199 3.69656Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightAlignedArrow = () => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.12109 1L5.36373 5.24264L1.12109 9.48528" stroke="#898B97" />
  </svg>
);

export const InvoiceIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="11" fill="#387C88" fillOpacity="0.15" />
    <path
      d="M15.2551 7.79092L12.6401 5.17596C12.343 4.8799 11.9452 4.71436 11.5278 4.71436L7.85707 4.71436C6.9891 4.71436 6.28564 5.41782 6.28564 6.28578L6.2858 15.7144C6.2858 16.5823 6.98926 17.2858 7.85723 17.2858H14.1428C15.0108 17.2858 15.7142 16.5823 15.7142 15.7144V8.90074C15.7142 8.48333 15.5497 8.08556 15.2551 7.79092ZM11.7856 5.55114C11.8956 5.58959 11.9984 5.64558 12.0832 5.73036L14.6982 8.34531C14.7836 8.42931 14.8401 8.53244 14.8769 8.64293H12.1785C11.9624 8.64293 11.7856 8.46614 11.7856 8.25007V5.55114ZM14.9285 15.7144C14.9285 16.1475 14.5759 16.5001 14.1428 16.5001H7.85707C7.42395 16.5001 7.07136 16.1475 7.07136 15.7144V6.28579C7.07136 5.85266 7.42395 5.50007 7.85707 5.50007H10.9999V8.25007C10.9999 8.90074 11.5278 9.42864 12.1785 9.42864H14.9285V15.7144ZM8.64279 11.3929C8.64279 11.609 8.81957 11.7858 9.03564 11.7858H12.9642C13.1803 11.7858 13.3571 11.609 13.3571 11.3929C13.3571 11.1769 13.1803 11.0001 12.9642 11.0001H9.03564C8.81957 11.0001 8.64279 11.1769 8.64279 11.3929ZM12.9642 12.5715H9.03564C8.81957 12.5715 8.64279 12.7483 8.64279 12.9644C8.64279 13.1804 8.81957 13.3572 9.03564 13.3572H12.9642C13.1812 13.3572 13.3571 13.1813 13.3571 12.9644C13.3571 12.7474 13.1803 12.5715 12.9642 12.5715ZM12.9642 14.1429H9.03564C8.81957 14.1429 8.64279 14.3197 8.64279 14.5358C8.64279 14.7519 8.81957 14.9286 9.03564 14.9286H12.9642C13.1812 14.9286 13.3571 14.7527 13.3571 14.5358C13.3571 14.3188 13.1803 14.1429 12.9642 14.1429Z"
      fill="#387C88"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.94167 0.495947L7.50417 1.05845C7.83333 1.38345 7.83333 1.91261 7.50417 2.23761L1.99167 7.75011H0.25V6.00845L4.58333 1.67095L5.7625 0.495947C6.0875 0.170947 6.61667 0.170947 6.94167 0.495947ZM1.08333 6.91678L1.67083 6.94178L5.7625 2.84595L5.175 2.25845L1.08333 6.35011V6.91678Z"
      fill="currentColor"
    />
  </svg>
);

export const TickIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2L5.42857 12L2 8"
      stroke="#03CC7A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57685 5.05241C7.4897 5.05241 7.41897 5.12314 7.4196 5.21029C7.4196 5.29744 7.49033 5.36817 7.57748 5.36817C7.66463 5.36817 7.73536 5.29744 7.73536 5.21029C7.73536 5.12314 7.66463 5.05241 7.57685 5.05241"
      stroke="#606266"
      strokeWidth="1.18411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57825 13.262V13.262C4.43894 13.262 1.89453 10.7176 1.89453 7.57825V7.57825C1.89453 4.43894 4.43894 1.89453 7.57825 1.89453V1.89453C10.7176 1.89453 13.262 4.43894 13.262 7.57825V7.57825C13.262 10.7176 10.7176 13.262 7.57825 13.262Z"
      stroke="#606266"
      strokeWidth="1.18411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.57748 7.57812V10.7357"
      stroke="#606266"
      strokeWidth="1.18411"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4156 3.91563L8.0875 0.587503C7.70937 0.21069 7.20312 3.125e-06 6.67188 3.125e-06L2 0C0.895313 0 0 0.895312 0 2L0.000203125 14C0.000203125 15.1047 0.895516 16 2.0002 16H10C11.1047 16 12 15.1047 12 14V5.32812C12 4.79688 11.7906 4.29063 11.4156 3.91563ZM7 1.065C7.13991 1.11394 7.27081 1.18519 7.37875 1.2931L10.7069 4.62122C10.8156 4.72813 10.8875 4.85938 10.9344 5H7.5C7.225 5 7 4.775 7 4.5V1.065ZM11 14C11 14.5512 10.5512 15 10 15H2C1.44875 15 1 14.5512 1 14V2C1 1.44875 1.44875 1 2 1H6V4.5C6 5.32813 6.67188 6 7.5 6H11V14ZM3 8.5C3 8.775 3.225 9 3.5 9H8.5C8.775 9 9 8.775 9 8.5C9 8.225 8.775 8 8.5 8H3.5C3.225 8 3 8.225 3 8.5ZM8.5 10H3.5C3.225 10 3 10.225 3 10.5C3 10.775 3.225 11 3.5 11H8.5C8.77619 11 9 10.7761 9 10.5C9 10.2239 8.775 10 8.5 10ZM8.5 12H3.5C3.225 12 3 12.225 3 12.5C3 12.775 3.225 13 3.5 13H8.5C8.77619 13 9 12.7761 9 12.5C9 12.2239 8.775 12 8.5 12Z"
      fill="#387C88"
    />
  </svg>
);

export const OfficeIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 3.34375V4.59375C6 4.80084 5.83209 4.96875 5.625 4.96875H4.375C4.16791 4.96875 4 4.80084 4 4.59375V3.34375C4 3.13666 4.16791 2.96875 4.375 2.96875H5.625C5.83209 2.96875 6 3.13666 6 3.34375ZM9.625 2.96875H8.375C8.16791 2.96875 8 3.13666 8 3.34375V4.59375C8 4.80084 8.16791 4.96875 8.375 4.96875H9.625C9.83209 4.96875 10 4.80084 10 4.59375V3.34375C10 3.13666 9.83209 2.96875 9.625 2.96875ZM5.625 5.96875H4.375C4.16791 5.96875 4 6.13666 4 6.34375V7.59375C4 7.80084 4.16791 7.96875 4.375 7.96875H5.625C5.83209 7.96875 6 7.80084 6 7.59375V6.34375C6 6.13666 5.83209 5.96875 5.625 5.96875ZM9.625 5.96875H8.375C8.16791 5.96875 8 6.13666 8 6.34375V7.59375C8 7.80084 8.16791 7.96875 8.375 7.96875H9.625C9.83209 7.96875 10 7.80084 10 7.59375V6.34375C10 6.13666 9.83209 5.96875 9.625 5.96875ZM5.625 8.96875H4.375C4.16791 8.96875 4 9.13666 4 9.34375V10.5938C4 10.8008 4.16791 10.9688 4.375 10.9688H5.625C5.83209 10.9688 6 10.8008 6 10.5938V9.34375C6 9.13666 5.83209 8.96875 5.625 8.96875ZM9.625 8.96875H8.375C8.16791 8.96875 8 9.13666 8 9.34375V10.5938C8 10.8008 8.16791 10.9688 8.375 10.9688H9.625C9.83209 10.9688 10 10.8008 10 10.5938V9.34375C10 9.13666 9.83209 8.96875 9.625 8.96875ZM14 15.375V16H0V15.375C0 15.1679 0.167906 15 0.375 15H1V0.75C1 0.335781 1.33578 0 1.75 0H12.25C12.6642 0 13 0.335781 13 0.75V15H13.625C13.8321 15 14 15.1679 14 15.375ZM12 15V1H2V15H6V12.3438C6 12.1367 6.16791 11.9688 6.375 11.9688H7.625C7.83209 11.9688 8 12.1367 8 12.3438V15H12Z"
      fill="#387C88"
    />
  </svg>
);
export const DollarIcon = () => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.424 14.16C4.20267 14.16 3.18933 13.8987 2.384 13.376C1.584 12.848 1.10667 12.0693 0.952 11.04L2.504 10.944C2.67467 11.5947 3.016 12.0827 3.528 12.408C4.04 12.7333 4.66933 12.896 5.416 12.896C5.864 12.896 6.28267 12.8187 6.672 12.664C7.06667 12.5093 7.384 12.2933 7.624 12.016C7.86933 11.7387 7.992 11.4107 7.992 11.032C7.992 10.5253 7.84 10.12 7.536 9.816C7.23733 9.512 6.76 9.272 6.104 9.096L4.112 8.576C3.25333 8.35733 2.57333 8.01333 2.072 7.544C1.57067 7.07467 1.31733 6.44533 1.312 5.656C1.30667 4.98933 1.48 4.40267 1.832 3.896C2.18933 3.38933 2.68 2.99467 3.304 2.712C3.93333 2.42933 4.65867 2.288 5.48 2.288C6.26933 2.288 6.94933 2.44 7.52 2.744C8.096 3.04267 8.54133 3.44 8.856 3.936C9.176 4.432 9.34667 4.97333 9.368 5.56L7.864 5.64C7.74667 4.952 7.49333 4.432 7.104 4.08C6.72 3.72267 6.17867 3.544 5.48 3.544C5.14933 3.544 4.82933 3.58667 4.52 3.672C4.216 3.752 3.94133 3.87467 3.696 4.04C3.456 4.20533 3.264 4.41067 3.12 4.656C2.976 4.90133 2.904 5.18667 2.904 5.512C2.904 5.928 3.05067 6.25867 3.344 6.504C3.63733 6.744 4.16533 6.98133 4.928 7.216L6.848 7.76C7.82933 8.032 8.528 8.456 8.944 9.032C9.36533 9.60267 9.576 10.264 9.576 11.016C9.576 11.6293 9.40267 12.1733 9.056 12.648C8.70933 13.1173 8.22133 13.488 7.592 13.76C6.968 14.0267 6.24533 14.16 5.424 14.16ZM4.8 0.704H6.168V2.768H4.8V0.704ZM4.704 13.608H6.072V15.672H4.704V13.608Z"
      fill="#697386"
    />
  </svg>
);

export const LongReceiptIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1875 2.18793L11.25 1.25043L10.3125 2.18793L9.375 1.25043L8.4375 2.18793L7.5 1.25043L6.5625 2.18793L5.625 1.25043L4.6875 2.18793L3.75 1.25043V10.0004H1.875V11.8754C1.875 12.9129 2.7125 13.7504 3.75 13.7504H11.25C12.2875 13.7504 13.125 12.9129 13.125 11.8754V1.25043L12.1875 2.18793ZM9.375 12.5004H3.75C3.40625 12.5004 3.125 12.2192 3.125 11.8754V11.2504H9.375V12.5004ZM11.875 11.8754C11.875 12.2192 11.5938 12.5004 11.25 12.5004C10.9062 12.5004 10.625 12.2192 10.625 11.8754V10.0004H5V3.12543H11.875V11.8754Z"
      fill="#141518"
    />
    <path d="M9.375 4.37543H5.625V5.62543H9.375V4.37543Z" fill="#141518" />
    <path d="M11.25 4.37543H10V5.62543H11.25V4.37543Z" fill="#141518" />
    <path d="M9.375 6.25043H5.625V7.50043H9.375V6.25043Z" fill="#141518" />
    <path d="M11.25 6.25043H10V7.50043H11.25V6.25043Z" fill="#141518" />
  </svg>
);

export const DollarWithBoarderIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.16667C10.2165 1.16667 12.8333 3.7835 12.8333 7C12.8333 10.2165 10.2165 12.8333 7 12.8333C3.7835 12.8333 1.16667 10.2165 1.16667 7C1.16667 3.7835 3.7835 1.16667 7 1.16667ZM7 0C3.13425 0 0 3.13425 0 7C0 10.8657 3.13425 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13425 10.8657 0 7 0ZM9.33333 8.21508C9.33333 6.96383 8.03133 6.61558 7.03325 6.14658C6.42717 5.83158 6.50358 5.07967 7.37217 5.02892C7.854 4.99975 8.34925 5.14267 8.79725 5.30017L9.00842 4.33942C8.47933 4.17842 8.00567 4.10492 7.58333 4.09383V3.5H7V4.12242C5.86542 4.27817 5.25933 4.98983 5.25933 5.78492C5.25933 7.20708 6.92008 7.42408 7.46317 7.67667C8.204 8.008 8.06692 8.6975 7.39667 8.84975C6.81508 8.98158 6.07308 8.75175 5.51542 8.53475L5.25 9.49375C5.7715 9.76325 6.39625 9.90675 7 9.91783V10.5H7.58333V9.88575C8.54992 9.75042 9.3345 9.21725 9.33333 8.21508Z"
      fill="#141518"
    />
  </svg>
);

export const CorrectIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.16667C10.2165 1.16667 12.8333 3.7835 12.8333 7C12.8333 10.2165 10.2165 12.8333 7 12.8333C3.7835 12.8333 1.16667 10.2165 1.16667 7C1.16667 3.7835 3.7835 1.16667 7 1.16667ZM7 0C3.13425 0 0 3.13425 0 7C0 10.8657 3.13425 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13425 10.8657 0 7 0ZM10.6458 5.18642L9.81692 4.3645L6.25567 7.99167L4.46017 6.27842L3.64583 7.11608L6.27083 9.6355L10.6458 5.18642Z"
      fill="#141518"
    />
  </svg>
);

export const MoveIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 7L6.41667 8.80833L10.5 4.08333L5.74233 7.392L3.227 6.69083L12.1882 2.21083L9.87 10.71L7.6825 8.76225L6.41667 10.4685V10.0199L5.25 9.69325V14L7.85925 10.4819L10.5 12.8333L14 0L0 7Z"
      fill="#141518"
    />
  </svg>
);

export const InvoicePayup = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 6 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.89957 2.77778L3.37179 0.25V0.261667H0.902344V7.78083H3.43012V5.30556H5.89957V2.77778ZM3.43207 2.77778V5.30556L0.904288 2.77778H3.43207Z"
      fill="white"
    />
  </svg>
);

export const LeftArrow = () => (
  <svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00814 2.40888L2.41683 8.0002L8.00814 13.5915C8.39903 13.9824 8.39903 14.6161 8.00814 15.007C7.61726 15.3979 6.98351 15.3979 6.59262 15.007L0.292893 8.7073C-0.0976311 8.31678 -0.0976311 7.68361 0.292893 7.29309L6.59262 0.99336C6.98351 0.602474 7.61726 0.602474 8.00814 0.99336C8.39903 1.38425 8.39903 2.018 8.00814 2.40888Z"
      fill="#4F566B"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 8.25V10.5H1.5V8.25H0V10.5C0 11.325 0.675 12 1.5 12H10.5C11.325 12 12 11.325 12 10.5V8.25H10.5ZM2.25 3.75L3.3075 4.8075L5.25 2.8725V9H6.75V2.8725L8.6925 4.8075L9.75 3.75L6 0L2.25 3.75Z"
      fill="currentColor"
    />
  </svg>
);

export const DropDownIcon = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.9999 1.81262L6.69339 4.50611C6.98655 4.79927 7.46187 4.79927 7.75503 4.50611C8.04819 4.21294 8.04819 3.73763 7.75503 3.44447L4.53023 0.21967C4.23734 -0.0732233 3.76247 -0.0732233 3.46957 0.21967L0.244776 3.44447C-0.0483887 3.73763 -0.0483887 4.21294 0.244776 4.50611C0.53794 4.79927 1.01325 4.79927 1.30642 4.50611L3.9999 1.81262Z"
      fill="currentColor"
    />
    <path
      d="M7.75503 7.49389C7.46187 7.20073 6.98655 7.20073 6.69339 7.49389L3.9999 10.1874L1.30642 7.49389C1.01325 7.20073 0.53794 7.20073 0.244776 7.49389C-0.0483887 7.78706 -0.0483887 8.26237 0.244776 8.55553L3.46957 11.7803C3.76247 12.0732 4.23734 12.0732 4.53023 11.7803L7.75503 8.55553C8.04819 8.26237 8.04819 7.78706 7.75503 7.49389Z"
      fill="currentColor"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0H2ZM9 7V1.5L14.5 7H9Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIconLarge = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
      fill="#49454F"
    />
  </svg>
);

export const CheckboxTickIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 12.5C0.966667 12.5 0.652667 12.3696 0.391333 12.1087C0.130444 11.8473 0 11.5333 0 11.1667V1.83333C0 1.46667 0.130444 1.15267 0.391333 0.891333C0.652667 0.630444 0.966667 0.5 1.33333 0.5H10.6667C11.0333 0.5 11.3473 0.630444 11.6087 0.891333C11.8696 1.15267 12 1.46667 12 1.83333V11.1667C12 11.5333 11.8696 11.8473 11.6087 12.1087C11.3473 12.3696 11.0333 12.5 10.6667 12.5H1.33333ZM1.33333 11.1667H10.6667V1.83333H1.33333V11.1667ZM5.06667 9.3L9.76667 4.6L8.83333 3.66667L5.06667 7.43333L3.16667 5.53333L2.23333 6.46667L5.06667 9.3Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const AccordionArrow = () => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.827052 0.163932C1.02185 -0.0347747 1.32668 -0.0528392 1.54149 0.109739L1.60303 0.163932L5.99967 4.64894L10.3963 0.163933C10.5911 -0.0347739 10.896 -0.0528384 11.1108 0.10974L11.1723 0.163933C11.3671 0.362639 11.3848 0.673582 11.2254 0.892695L11.1723 0.95547L6.38766 5.83607C6.19286 6.03477 5.88803 6.05284 5.67323 5.89026L5.61169 5.83607L0.827052 0.955469C0.612772 0.736892 0.612772 0.382509 0.827052 0.163932Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIconLined = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.53 0.294941L9.205 0.969941C9.6 1.35994 9.6 1.99494 9.205 2.38494L2.59 8.99994H0.5V6.90994L5.7 1.70494L7.115 0.294941C7.505 -0.0950586 8.14 -0.0950586 8.53 0.294941ZM1.5 7.99994L2.205 8.02994L7.115 3.11494L6.41 2.40994L1.5 7.31994V7.99994Z"
      fill="currentColor"
    />
  </svg>
);

export const TickIconCircle = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2874 27.5492C20.2874 27.5569 20.2811 27.5631 20.2734 27.5631C20.2657 27.5631 20.2595 27.5569 20.2595 27.5492C20.2595 27.5415 20.2657 27.5352 20.2734 27.5352C20.2811 27.5352 20.2874 27.5415 20.2874 27.5492Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.2683 27.8155C19.2683 27.8232 19.262 27.8295 19.2543 27.8295C19.2466 27.8295 19.2404 27.8232 19.2404 27.8155C19.2404 27.8078 19.2466 27.8016 19.2543 27.8016C19.262 27.8016 19.2683 27.8078 19.2683 27.8155Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.3876 27.5492C19.3876 27.5569 19.3813 27.5631 19.3736 27.5631C19.3659 27.5631 19.3597 27.5569 19.3597 27.5492C19.3597 27.5415 19.3659 27.5352 19.3736 27.5352C19.3813 27.5352 19.3876 27.5415 19.3876 27.5492Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.2315 27.6227C19.2315 27.6304 19.2253 27.6366 19.2176 27.6366C19.2099 27.6366 19.2036 27.6304 19.2036 27.6227C19.2036 27.6149 19.2099 27.6087 19.2176 27.6087C19.2253 27.6087 19.2315 27.6149 19.2315 27.6227Z"
      fill="#387C88"
    />
    <path
      d="M20.2966 27.7236C20.2966 27.7313 20.2903 27.7376 20.2826 27.7376C20.2749 27.7376 20.2687 27.7313 20.2687 27.7236C20.2687 27.7159 20.2749 27.7097 20.2826 27.7097C20.2903 27.7097 20.2966 27.7159 20.2966 27.7236Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.8191 27.4206C19.8191 27.4283 19.8129 27.4345 19.8052 27.4345C19.7975 27.4345 19.7912 27.4283 19.7912 27.4206C19.7912 27.4129 19.7975 27.4066 19.8052 27.4066C19.8129 27.4066 19.8191 27.4129 19.8191 27.4206Z"
      fill="#387C88"
    />
    <path
      d="M18.9744 27.8246C18.9744 27.8323 18.9682 27.8386 18.9605 27.8386C18.9528 27.8386 18.9465 27.8323 18.9465 27.8246C18.9465 27.8169 18.9528 27.8107 18.9605 27.8107C18.9682 27.8107 18.9744 27.8169 18.9744 27.8246Z"
      fill="#387C88"
    />
    <path
      d="M20.1221 27.439C20.1221 27.4467 20.1159 27.453 20.1082 27.453C20.1005 27.453 20.0942 27.4467 20.0942 27.439C20.0942 27.4313 20.1005 27.425 20.1082 27.425C20.1159 27.425 20.1221 27.4313 20.1221 27.439Z"
      fill="#DFE6FE"
    />
    <path
      d="M20.1772 27.6227C20.1772 27.6304 20.171 27.6366 20.1632 27.6366C20.1555 27.6366 20.1493 27.6304 20.1493 27.6227C20.1493 27.6149 20.1555 27.6087 20.1632 27.6087C20.171 27.6087 20.1772 27.6149 20.1772 27.6227Z"
      fill="#387C88"
    />
    <path
      d="M20.3241 28.045C20.3241 28.0527 20.3179 28.059 20.3102 28.059C20.3025 28.059 20.2962 28.0527 20.2962 28.045C20.2962 28.0373 20.3025 28.0311 20.3102 28.0311C20.3179 28.0311 20.3241 28.0373 20.3241 28.045Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.9842 27.4717C19.9842 27.4794 19.978 27.4857 19.9703 27.4857C19.9626 27.4857 19.9563 27.4794 19.9563 27.4717C19.9563 27.464 19.9626 27.4578 19.9703 27.4578C19.978 27.4578 19.9842 27.464 19.9842 27.4717Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.1764 28.0909C19.1764 28.0986 19.1702 28.1048 19.1625 28.1048C19.1547 28.1048 19.1485 28.0986 19.1485 28.0909C19.1485 28.0831 19.1547 28.0769 19.1625 28.0769C19.1702 28.0769 19.1764 28.0831 19.1764 28.0909Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.1301 27.7142C19.1301 27.7269 19.1199 27.7372 19.1072 27.7372C19.0945 27.7372 19.0842 27.7269 19.0842 27.7142C19.0842 27.7016 19.0945 27.6913 19.1072 27.6913C19.1199 27.6913 19.1301 27.7016 19.1301 27.7142Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.2036 27.9163C19.2036 27.9289 19.1933 27.9392 19.1806 27.9392C19.1679 27.9392 19.1577 27.9289 19.1577 27.9163C19.1577 27.9036 19.1679 27.8933 19.1806 27.8933C19.1933 27.8933 19.2036 27.9036 19.2036 27.9163Z"
      fill="#387C88"
    />
    <path
      d="M19.9473 27.3378C19.9473 27.3505 19.9371 27.3607 19.9244 27.3607C19.9117 27.3607 19.9014 27.3505 19.9014 27.3378C19.9014 27.3251 19.9117 27.3148 19.9244 27.3148C19.9371 27.3148 19.9473 27.3251 19.9473 27.3378Z"
      fill="#DFE6FE"
    />
    <path
      d="M19.6259 27.4114C19.6259 27.4241 19.6157 27.4343 19.603 27.4343C19.5903 27.4343 19.58 27.4241 19.58 27.4114C19.58 27.3987 19.5903 27.3884 19.603 27.3884C19.6157 27.3884 19.6259 27.3987 19.6259 27.4114Z"
      fill="#DFE6FE"
    />
    <path
      d="M20.2489 28.1315C20.2489 28.1442 20.2386 28.1544 20.226 28.1544C20.2133 28.1544 20.203 28.1442 20.203 28.1315C20.203 28.1188 20.2133 28.1085 20.226 28.1085C20.2386 28.1085 20.2489 28.1188 20.2489 28.1315Z"
      fill="#DFE6FE"
    />
    <path
      d="M20.4339 27.8336C20.4339 27.8463 20.4236 27.8566 20.411 27.8566C20.3983 27.8566 20.388 27.8463 20.388 27.8336C20.388 27.8209 20.3983 27.8107 20.411 27.8107C20.4236 27.8107 20.4339 27.8209 20.4339 27.8336Z"
      fill="#387C88"
    />
    <path
      d="M19.3597 27.4114C19.3597 27.4241 19.3494 27.4343 19.3367 27.4343C19.3241 27.4343 19.3138 27.4241 19.3138 27.4114C19.3138 27.3987 19.3241 27.3884 19.3367 27.3884C19.3494 27.3884 19.3597 27.3987 19.3597 27.4114Z"
      fill="#387C88"
    />
    <path
      d="M20.2962 27.8611C20.2962 27.8738 20.2859 27.8841 20.2733 27.8841C20.2606 27.8841 20.2503 27.8738 20.2503 27.8611C20.2503 27.8485 20.2606 27.8382 20.2733 27.8382C20.2859 27.8382 20.2962 27.8485 20.2962 27.8611Z"
      fill="#DFE6FE"
    />
    <path
      d="M40 20C40 31.0458 31.0458 40 20 40C8.95416 40 0 31.0458 0 20C0 8.95416 8.95416 0 20 0C31.0458 0 40 8.95416 40 20Z"
      fill="#DFE6FE"
    />
    <path
      d="M35.7957 9.82153C36.0403 9.82153 36.239 10.0202 36.239 10.2648C36.239 10.5094 36.0403 10.7081 35.7957 10.7081C35.551 10.7081 35.3524 10.5094 35.3524 10.2648C35.3524 10.0202 35.551 9.82153 35.7957 9.82153Z"
      fill="#DFE6FE"
    />
    <path
      d="M10.9092 18.356L17.8874 25.3343C17.8874 25.3343 26.7328 16.8165 29.091 14.5455"
      stroke="#387C88"
      strokeWidth="2.58427"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const TickIconWhite = () => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57427 0.165338C7.76537 0.303749 7.80708 0.569496 7.66743 0.7589L3.74975 5.6556C3.51088 5.97957 3.03295 6.00669 2.75834 5.71184L0.363657 3.14066C0.203114 2.96828 0.213959 2.69956 0.387882 2.54044C0.561804 2.38132 0.832943 2.39207 0.993486 2.56445L3.21144 4.94587L6.97538 0.25767C7.11503 0.0682652 7.38316 0.0269268 7.57427 0.165338Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57427 0.165338C7.76537 0.303749 7.80708 0.569496 7.66743 0.7589L3.74975 5.6556C3.51088 5.97957 3.03295 6.00669 2.75834 5.71184L0.363657 3.14066C0.203114 2.96828 0.213959 2.69956 0.387882 2.54044C0.561804 2.38132 0.832943 2.39207 0.993486 2.56445L3.21144 4.94587L6.97538 0.25767C7.11503 0.0682652 7.38316 0.0269268 7.57427 0.165338Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57427 0.165338C7.76537 0.303749 7.80708 0.569496 7.66743 0.7589L3.74975 5.6556C3.51088 5.97957 3.03295 6.00669 2.75834 5.71184L0.363657 3.14066C0.203114 2.96828 0.213959 2.69956 0.387882 2.54044C0.561804 2.38132 0.832943 2.39207 0.993486 2.56445L3.21144 4.94587L6.97538 0.25767C7.11503 0.0682652 7.38316 0.0269268 7.57427 0.165338Z"
      fill="white"
      fillOpacity="0.05"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4.66667C8 6.50762 6.50762 8 4.66667 8C2.82572 8 1.33333 6.50762 1.33333 4.66667C1.33333 2.82572 2.82572 1.33333 4.66667 1.33333C6.50762 1.33333 8 2.82572 8 4.66667ZM7.06267 8.67211C6.36229 9.09197 5.54267 9.33333 4.66667 9.33333C2.08934 9.33333 0 7.244 0 4.66667C0 2.08934 2.08934 0 4.66667 0C7.244 0 9.33333 2.08934 9.33333 4.66667C9.33333 5.88508 8.8664 6.99443 8.10172 7.82554L10.8047 10.5286C11.0651 10.7889 11.0651 11.2111 10.8047 11.4714C10.5444 11.7318 10.1223 11.7318 9.86193 11.4714L7.06267 8.67211Z"
      fill="#1A1F36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4.66667C8 6.50762 6.50762 8 4.66667 8C2.82572 8 1.33333 6.50762 1.33333 4.66667C1.33333 2.82572 2.82572 1.33333 4.66667 1.33333C6.50762 1.33333 8 2.82572 8 4.66667ZM7.06267 8.67211C6.36229 9.09197 5.54267 9.33333 4.66667 9.33333C2.08934 9.33333 0 7.244 0 4.66667C0 2.08934 2.08934 0 4.66667 0C7.244 0 9.33333 2.08934 9.33333 4.66667C9.33333 5.88508 8.8664 6.99443 8.10172 7.82554L10.8047 10.5286C11.0651 10.7889 11.0651 11.2111 10.8047 11.4714C10.5444 11.7318 10.1223 11.7318 9.86193 11.4714L7.06267 8.67211Z"
      fill="#203EDF"
      fillOpacity="0.3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4.66667C8 6.50762 6.50762 8 4.66667 8C2.82572 8 1.33333 6.50762 1.33333 4.66667C1.33333 2.82572 2.82572 1.33333 4.66667 1.33333C6.50762 1.33333 8 2.82572 8 4.66667ZM7.06267 8.67211C6.36229 9.09197 5.54267 9.33333 4.66667 9.33333C2.08934 9.33333 0 7.244 0 4.66667C0 2.08934 2.08934 0 4.66667 0C7.244 0 9.33333 2.08934 9.33333 4.66667C9.33333 5.88508 8.8664 6.99443 8.10172 7.82554L10.8047 10.5286C11.0651 10.7889 11.0651 11.2111 10.8047 11.4714C10.5444 11.7318 10.1223 11.7318 9.86193 11.4714L7.06267 8.67211Z"
      fill="white"
      fillOpacity="0.05"
    />
  </svg>
);

export const SortingIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 1.125C6.70711 1.125 6.875 1.29289 6.875 1.5V10.5C6.875 10.7071 6.70711 10.875 6.5 10.875C6.29289 10.875 6.125 10.7071 6.125 10.5V1.5C6.125 1.29289 6.29289 1.125 6.5 1.125Z"
      fill="curentColor"
      stroke="curentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.23483 1.23483C6.38128 1.08839 6.61872 1.08839 6.76517 1.23483L9.76516 4.23483C9.91161 4.38128 9.91161 4.61872 9.76516 4.76517C9.61872 4.91161 9.38128 4.91161 9.23484 4.76517L6.5 2.03033L3.76517 4.76517C3.61872 4.91161 3.38128 4.91161 3.23483 4.76517C3.08839 4.61872 3.08839 4.38128 3.23483 4.23483L6.23483 1.23483Z"
      fill="curentColor"
      stroke="curentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortingIconDSC = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 10.875C6.29289 10.875 6.125 10.7071 6.125 10.5L6.125 1.5C6.125 1.29289 6.29289 1.125 6.5 1.125C6.70711 1.125 6.875 1.29289 6.875 1.5L6.875 10.5C6.875 10.7071 6.70711 10.875 6.5 10.875Z"
      fill="curentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76517 10.7652C6.61872 10.9116 6.38128 10.9116 6.23483 10.7652L3.23484 7.76517C3.08839 7.61872 3.08839 7.38128 3.23484 7.23483C3.38128 7.08839 3.61872 7.08839 3.76516 7.23483L6.5 9.96967L9.23483 7.23483C9.38128 7.08839 9.61872 7.08839 9.76517 7.23483C9.91161 7.38128 9.91161 7.61872 9.76517 7.76517L6.76517 10.7652Z"
      fill="curentColor"
    />
  </svg>
);

export const DatePicker = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4 1.33325V3.99992"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.59999 1.33325V3.99992"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.59998 6.00008H13.4"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2 2.66675H3.79998C3.13698 2.66675 2.59998 3.26341 2.59998 4.00008V12.6667C2.59998 13.4034 3.13698 14.0001 3.79998 14.0001H12.2C12.863 14.0001 13.4 13.4034 13.4 12.6667V4.00008C13.4 3.26341 12.863 2.66675 12.2 2.66675Z"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00778 8.486C4.92498 8.486 4.85778 8.56067 4.85838 8.65267C4.85838 8.74467 4.92558 8.81934 5.00838 8.81934C5.09118 8.81934 5.15838 8.74467 5.15838 8.65267C5.15838 8.56067 5.09118 8.486 5.00778 8.486"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00778 8.486C7.92498 8.486 7.85778 8.56067 7.85838 8.65267C7.85838 8.74467 7.92558 8.81934 8.00838 8.81934C8.09118 8.81934 8.15838 8.74467 8.15838 8.65267C8.15838 8.56067 8.09118 8.486 8.00778 8.486"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0078 8.486C10.925 8.486 10.8578 8.56067 10.8584 8.65267C10.8584 8.74467 10.9256 8.81934 11.0084 8.81934C11.0912 8.81934 11.1584 8.74467 11.1584 8.65267C11.1584 8.56067 11.0912 8.486 11.0078 8.486"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00778 11.1528C4.92498 11.1528 4.85778 11.2274 4.85838 11.3194C4.85838 11.4114 4.92558 11.4861 5.00838 11.4861C5.09118 11.4861 5.15838 11.4114 5.15838 11.3194C5.15838 11.2274 5.09118 11.1528 5.00778 11.1528"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00778 11.1528C7.92498 11.1528 7.85778 11.2274 7.85838 11.3194C7.85838 11.4114 7.92558 11.4861 8.00838 11.4861C8.09118 11.4861 8.15838 11.4114 8.15838 11.3194C8.15838 11.2274 8.09118 11.1528 8.00778 11.1528"
      stroke="#1A1F36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CameraIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 2H1.5V1.25H3.75V2ZM11.9475 2L12.5565 2.91425C13.1138 3.7505 14.0468 4.25 15.0525 4.25H16.5V14H1.5V4.25H4.4475C5.45325 4.25 6.38625 3.7505 6.9435 2.91425L7.5525 2H11.9475ZM12.75 0.5H6.75L5.6955 2.08175C5.41725 2.4995 4.94925 2.75 4.4475 2.75H0V15.5H18V2.75H15.0525C14.5507 2.75 14.0828 2.4995 13.8045 2.08175L12.75 0.5ZM4.5 6.5C4.5 6.086 4.16475 5.75 3.75 5.75C3.33525 5.75 3 6.086 3 6.5C3 6.914 3.33525 7.25 3.75 7.25C4.16475 7.25 4.5 6.914 4.5 6.5ZM9.75 6.5C10.9905 6.5 12 7.5095 12 8.75C12 9.9905 10.9905 11 9.75 11C8.5095 11 7.5 9.9905 7.5 8.75C7.5 7.5095 8.5095 6.5 9.75 6.5ZM9.75 5C7.67925 5 6 6.67925 6 8.75C6 10.8208 7.67925 12.5 9.75 12.5C11.8208 12.5 13.5 10.8208 13.5 8.75C13.5 6.67925 11.8208 5 9.75 5Z"
      fill="currentColor"
    />
  </svg>
);

export const WarningIcon = ({
  width = "12",
  height = "12",
  fillColor = "currentColor",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58657 0.981064L11.8123 9.43256C12.2505 10.3089 11.8953 11.3745 11.0189 11.8127C10.7726 11.9359 10.501 12 10.2256 12H1.77406C0.794273 12 0 11.2057 0 10.2259C0 9.95053 0.0641235 9.6789 0.187292 9.43256L4.41304 0.981064C4.85121 0.104717 5.91684 -0.250492 6.79319 0.187681C7.13652 0.359345 7.41491 0.637735 7.58657 0.981064ZM6 7.875C5.37868 7.875 4.875 8.37868 4.875 9C4.875 9.62132 5.37868 10.125 6 10.125C6.62132 10.125 7.125 9.62132 7.125 9C7.125 8.37868 6.62132 7.875 6 7.875ZM6 6.75C6.41421 6.75 6.75 6.51015 6.75 6.21429V3.53571C6.75 3.23985 6.41421 3 6 3C5.58579 3 5.25 3.23985 5.25 3.53571V6.21429C5.25 6.51015 5.58579 6.75 6 6.75Z"
      fill={fillColor}
    />
  </svg>
);

export const MessageBoxDangerIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666626 14.3333H15.3333L7.99996 1.66667L0.666626 14.3333ZM8.66663 12.3333H7.33329V11H8.66663V12.3333ZM8.66663 9.66667H7.33329V7H8.66663V9.66667Z"
      fill="#A4233F"
    />
  </svg>
);

export const MessageBoxGoIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM10.9353 4.37081C10.5936 4.0291 10.0396 4.0291 9.69786 4.37081L6.125 7.95006L4.55622 6.38128C4.21451 6.03957 3.66049 6.03957 3.31878 6.38128C2.97707 6.72299 2.97707 7.27701 3.31878 7.61872L5.50628 9.80622C5.84799 10.1479 6.40201 10.1479 6.74372 9.80622L10.9353 5.60824C11.277 5.26654 11.277 4.71252 10.9353 4.37081Z"
      fill="#357219"
    />
  </svg>
);

export const MessageBoxWarningIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.53565 12.8323C1.14968 13.499 1.63074 14.3333 2.40107 14.3333H13.5988C14.3692 14.3333 14.8502 13.499 14.4643 12.8323L8.86539 3.1615C8.48022 2.49622 7.5197 2.49621 7.13453 3.1615L1.53565 12.8323ZM8.66663 11.6667C8.66663 12.0349 8.36815 12.3333 7.99996 12.3333C7.63177 12.3333 7.33329 12.0349 7.33329 11.6667C7.33329 11.2985 7.63177 11 7.99996 11C8.36815 11 8.66663 11.2985 8.66663 11.6667ZM8.66663 9C8.66663 9.36819 8.36815 9.66667 7.99996 9.66667C7.63177 9.66667 7.33329 9.36819 7.33329 9V7.66667C7.33329 7.29848 7.63177 7 7.99996 7C8.36815 7 8.66663 7.29848 8.66663 7.66667V9Z"
      fill="#E49900"
    />
  </svg>
);

export const NeturalIcon = ({
  width = "16",
  height = "16",
  fillColor = "#7E8085",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00134 1.33667C11.68 1.33667 14.6667 4.32334 14.6667 8.00134C14.6667 11.68 11.68 14.6667 8.00134 14.6667C4.32334 14.6667 1.33667 11.68 1.33667 8.00134C1.33667 4.32334 4.32334 1.33667 8.00134 1.33667ZM8.00134 6.67C7.72534 6.67 7.50134 6.894 7.50134 7.17V10.8367C7.50134 11.1127 7.72534 11.3367 8.00134 11.3367C8.27734 11.3367 8.50134 11.1127 8.50134 10.8367V7.17C8.50134 6.894 8.27734 6.67 8.00134 6.67ZM8 4.67C7.632 4.67 7.33334 4.96867 7.33334 5.33667C7.33334 5.70467 7.632 6.00334 8 6.00334C8.368 6.00334 8.66667 5.70467 8.66667 5.33667C8.66667 4.96867 8.368 4.67 8 4.67Z"
      fill={fillColor}
    />
  </svg>
);

export const PersonIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16675 4.33333C5.16675 2.76853 6.43527 1.5 8.00008 1.5C9.56489 1.5 10.8334 2.76853 10.8334 4.33333C10.8334 5.89814 9.56489 7.16667 8.00008 7.16667C6.43527 7.16667 5.16675 5.89814 5.16675 4.33333ZM8.00008 2.5C6.98756 2.5 6.16675 3.32081 6.16675 4.33333C6.16675 5.34586 6.98756 6.16667 8.00008 6.16667C9.01261 6.16667 9.83341 5.34586 9.83341 4.33333C9.83341 3.32081 9.0126 2.5 8.00008 2.5Z"
      fill="#606266"
      stroke="#606266"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.24467 8.83301H9.75533C10.4834 8.833 11.0604 8.833 11.5255 8.871C12.0011 8.90985 12.4035 8.99092 12.771 9.17813C13.3668 9.48174 13.8513 9.9662 14.1549 10.562C14.3421 10.9295 14.4232 11.3319 14.462 11.8075C14.5 12.2726 14.5 12.8496 14.5 13.5777V13.9997C14.5 14.2758 14.2761 14.4997 14 14.4997H2C1.72386 14.4997 1.5 14.2758 1.5 13.9997L1.5 13.5777C1.5 12.8496 1.49999 12.2726 1.53799 11.8075C1.57685 11.3319 1.65792 10.9295 1.84515 10.562C2.14874 9.9662 2.63318 9.48174 3.22904 9.17814C3.59649 8.99093 3.99891 8.90985 4.4745 8.871C4.93958 8.833 5.51657 8.833 6.24467 8.83301ZM3.68302 10.0692C3.27534 10.2769 2.94388 10.6083 2.73615 11.016C2.63273 11.219 2.56848 11.4752 2.53467 11.8889C2.50192 12.2898 2.5001 12.797 2.50001 13.4997H13.5C13.4999 12.797 13.4981 12.2898 13.4653 11.8889C13.4315 11.4752 13.3673 11.219 13.2639 11.016C13.0561 10.6084 12.7247 10.2769 12.317 10.0692M3.68302 10.0692C3.886 9.96573 4.14218 9.90148 4.55593 9.86768C4.97551 9.8334 5.51168 9.83301 6.26667 9.83301H9.73333C10.4883 9.83301 11.0245 9.8334 11.4441 9.86768C11.8578 9.90148 12.114 9.96573 12.317 10.0692"
      fill="#606266"
    />
    <path
      d="M1.84515 10.562C1.65792 10.9295 1.57685 11.3319 1.53799 11.8075C1.49999 12.2726 1.5 12.8496 1.5 13.5777L1.5 13.9997C1.5 14.2758 1.72386 14.4997 2 14.4997H14C14.2761 14.4997 14.5 14.2758 14.5 13.9997V13.5777C14.5 12.8496 14.5 12.2726 14.462 11.8075C14.4232 11.3319 14.3421 10.9295 14.1549 10.562C13.8513 9.9662 13.3668 9.48174 12.771 9.17813C12.4035 8.99092 12.0011 8.90985 11.5255 8.871C11.0604 8.833 10.4834 8.833 9.75533 8.83301H6.24467C5.51657 8.833 4.93958 8.833 4.4745 8.871C3.99891 8.90985 3.59649 8.99093 3.22904 9.17814C2.63318 9.48174 2.14874 9.9662 1.84515 10.562ZM1.84515 10.562L2.29065 10.789M3.68302 10.0692C3.27534 10.2769 2.94388 10.6083 2.73615 11.016C2.63273 11.219 2.56848 11.4752 2.53467 11.8889C2.50192 12.2898 2.5001 12.797 2.50001 13.4997H13.5C13.4999 12.797 13.4981 12.2898 13.4653 11.8889C13.4315 11.4752 13.3673 11.219 13.2639 11.016C13.0561 10.6084 12.7247 10.2769 12.317 10.0692M3.68302 10.0692H12.317M3.68302 10.0692C3.886 9.96573 4.14218 9.90148 4.55593 9.86768C4.97551 9.8334 5.51168 9.83301 6.26667 9.83301H9.73333C10.4883 9.83301 11.0245 9.8334 11.4441 9.86768C11.8578 9.90148 12.114 9.96573 12.317 10.0692"
      stroke="#606266"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IdentityIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66699 3.16699C5.83857 3.16699 5.16699 3.83857 5.16699 4.66699V4.83366H11.167V4.66699C11.167 3.83857 10.4954 3.16699 9.66699 3.16699H6.66699ZM4.16699 4.66699C4.16699 3.28628 5.28628 2.16699 6.66699 2.16699H9.66699C11.0477 2.16699 12.167 3.28628 12.167 4.66699V5.33366C12.167 5.6098 11.9431 5.83366 11.667 5.83366H4.66699C4.39085 5.83366 4.16699 5.6098 4.16699 5.33366V4.66699Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.0253 7.93891C1.14666 7.84416 1.3049 7.8106 1.45428 7.84794L7.95924 9.47417C7.98572 9.4808 8.01352 9.48083 8.04 9.4742L14.5451 7.84794C14.6944 7.8106 14.8527 7.84416 14.974 7.93891C15.0954 8.03366 15.1663 8.17904 15.1663 8.33301V12.6663C15.1663 13.3107 14.644 13.833 13.9997 13.833H1.99967C1.35535 13.833 0.833008 13.3107 0.833008 12.6663V8.33301C0.833008 8.17904 0.903943 8.03366 1.0253 7.93891ZM1.83301 8.9734V12.6663C1.83301 12.7584 1.90762 12.833 1.99967 12.833H13.9997C14.0917 12.833 14.1663 12.7584 14.1663 12.6663V8.9734L8.28275 10.4443C8.28271 10.4443 8.28279 10.4443 8.28275 10.4443C8.09696 10.4908 7.90249 10.4908 7.71671 10.4443C7.71667 10.4443 7.71674 10.4443 7.71671 10.4443L1.83301 8.9734Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833008 5.99967C0.833008 5.35533 1.35535 4.83301 1.99967 4.83301H13.9997C14.644 4.83301 15.1663 5.35533 15.1663 5.99967V8.99967C15.1663 9.27582 14.9425 9.49967 14.6663 9.49967C14.3902 9.49967 14.1663 9.27582 14.1663 8.99967V5.99967C14.1663 5.90762 14.0917 5.83301 13.9997 5.83301H1.99967C1.90762 5.83301 1.83301 5.90762 1.83301 5.99967V8.99967C1.83301 9.27582 1.60915 9.49967 1.33301 9.49967C1.05687 9.49967 0.833008 9.27582 0.833008 8.99967V5.99967Z"
      fill="#387C88"
    />
    <path
      d="M8.83366 7.66634C8.83366 8.12657 8.46056 8.49967 8.00033 8.49967C7.54009 8.49967 7.16699 8.12657 7.16699 7.66634C7.16699 7.20611 7.54009 6.83301 8.00033 6.83301C8.46056 6.83301 8.83366 7.20611 8.83366 7.66634Z"
      fill="#387C88"
    />
  </svg>
);

export const PeopleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16699 4.33333C5.16699 2.76853 6.43552 1.5 8.00033 1.5C9.56513 1.5 10.8337 2.76853 10.8337 4.33333C10.8337 5.89814 9.56513 7.16667 8.00033 7.16667C6.43552 7.16667 5.16699 5.89814 5.16699 4.33333ZM8.00033 2.5C6.9878 2.5 6.16699 3.32081 6.16699 4.33333C6.16699 5.34586 6.9878 6.16667 8.00033 6.16667C9.01285 6.16667 9.83366 5.34586 9.83366 4.33333C9.83366 3.32081 9.01285 2.5 8.00033 2.5Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41009 2.13196C4.56807 2.35845 4.51254 2.67013 4.28605 2.82811C3.80986 3.16025 3.5 3.71052 3.5 4.33312C3.5 4.99941 3.85515 5.58326 4.38886 5.90486C4.62538 6.04738 4.70158 6.35465 4.55906 6.59118C4.41654 6.8277 4.10927 6.9039 3.87274 6.76138C3.05125 6.26637 2.5 5.36436 2.5 4.33312C2.5 3.36985 2.98114 2.51907 3.71395 2.00792C3.94044 1.84994 4.25211 1.90548 4.41009 2.13196Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.59 2.13196C11.7479 1.90548 12.0596 1.84994 12.2861 2.00792C13.0189 2.51907 13.5 3.36985 13.5 4.33312C13.5 5.29635 13.0189 6.14718 12.2861 6.65832C12.0596 6.81629 11.7479 6.76075 11.5899 6.53426C11.432 6.30777 11.4875 5.9961 11.714 5.83812C12.1902 5.50599 12.5 4.95569 12.5 4.33312C12.5 3.71052 12.1902 3.16025 11.714 2.82811C11.4875 2.67013 11.432 2.35845 11.59 2.13196Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.98174 8.83301H8.01826C8.62404 8.83301 9.10416 8.833 9.49312 8.85954C9.89046 8.88665 10.2291 8.94313 10.5452 9.07407C11.3211 9.39545 11.9376 10.0119 12.2589 10.7878C12.3899 11.104 12.4464 11.4426 12.4735 11.8399C12.5 12.2288 12.5 12.709 12.5 13.3148V13.9997C12.5 14.2758 12.2761 14.4997 12 14.4997H4C3.72386 14.4997 3.5 14.2758 3.5 13.9997L3.5 13.3148C3.5 12.709 3.5 12.2288 3.52654 11.8399C3.55365 11.4425 3.61012 11.1039 3.74106 10.7878C4.06244 10.0119 4.6789 9.39545 5.45482 9.07407M7.98174 8.83301C7.37596 8.83301 6.89584 8.833 6.50688 8.85954L7.98174 8.83301ZM6.50688 8.85954C6.10954 8.88665 5.77093 8.94313 5.45482 9.07407L6.50688 8.85954ZM6.57496 9.85722C6.22853 9.88086 6.01147 9.92589 5.83751 9.99794C5.30664 10.2178 4.88483 10.6396 4.66494 11.1705C4.59289 11.3445 4.54785 11.5615 4.52422 11.908C4.50027 12.2589 4.5 12.7049 4.5 13.333V13.4997H11.5V13.333C11.5 12.7049 11.4997 12.2589 11.4758 11.908C11.4521 11.5615 11.4071 11.3445 11.3351 11.1705C11.1152 10.6396 10.6934 10.2178 10.1625 9.99795C9.98855 9.92589 9.77147 9.88086 9.42504 9.85722C9.07412 9.83328 8.62809 9.83301 8 9.83301C7.37191 9.83301 6.92588 9.83328 6.57496 9.85722Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7655 9.39713C12.8909 9.15109 13.192 9.05326 13.438 9.17863C14.0339 9.48223 14.5183 9.96669 14.8219 10.5625C15.0092 10.93 15.0902 11.3324 15.1291 11.808C15.1671 12.2731 15.1671 12.8501 15.1671 13.5782V14.0002C15.1671 14.2763 14.9432 14.5002 14.6671 14.5002C14.3909 14.5002 14.1671 14.2763 14.1671 14.0002V13.6002C14.1671 12.8452 14.1667 12.309 14.1324 11.8894C14.0986 11.4757 14.0344 11.2195 13.9309 11.0165M12.7655 9.39713C12.6402 9.64318 12.738 9.94426 12.984 10.0696L12.7655 9.39713ZM12.984 10.0696C13.1938 10.1765 13.3834 10.3161 13.5463 10.4821C13.7001 10.6386 13.8301 10.8186 13.9309 11.0165"
      fill="#387C88"
    />
    <path
      d="M13.5463 10.4821L12.7655 9.39713L12.984 10.0696C13.1938 10.1765 13.3834 10.3161 13.5463 10.4821Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.23453 9.39713C3.3599 9.64317 3.26207 9.94426 3.01603 10.0696C2.60835 10.2774 2.27689 10.6088 2.06916 11.0165C1.96574 11.2195 1.90148 11.4757 1.86768 11.8894C1.8334 12.309 1.83301 12.8452 1.83301 13.6002V14.0002C1.83301 14.2763 1.60915 14.5002 1.33301 14.5002C1.05687 14.5002 0.833008 14.2763 0.833008 14.0002L0.833008 13.5782C0.833004 12.8501 0.833001 12.2731 0.871 11.808C0.909857 11.3324 0.990929 10.93 1.17815 10.5625C1.48175 9.96669 1.96618 9.48223 2.56203 9.17863C2.80808 9.05326 3.10916 9.15109 3.23453 9.39713Z"
      fill="#387C88"
    />
  </svg>
);

export const MoneyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H13C13.8284 1.5 14.5 2.17158 14.5 3V13C14.5 13.8284 13.8284 14.5 13 14.5H3C2.17158 14.5 1.5 13.8284 1.5 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2762 2.72385 13.5 3 13.5H13C13.2762 13.5 13.5 13.2762 13.5 13V3C13.5 2.72385 13.2762 2.5 13 2.5H3Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6872 5.97945C11.8825 6.17472 11.8825 6.4913 11.6872 6.68656L9.02055 9.35323C8.91035 9.46342 8.75508 9.51593 8.60063 9.49525C8.44617 9.47457 8.31019 9.38305 8.23287 9.24774L7.22432 7.48278L5.02055 9.68656C4.82528 9.88182 4.5087 9.88182 4.31344 9.68656C4.11818 9.4913 4.11818 9.17472 4.31344 8.97945L6.98011 6.31279C7.0903 6.20259 7.24557 6.15008 7.40003 6.17077C7.55448 6.19145 7.69046 6.28297 7.76778 6.41827L8.77633 8.18323L10.9801 5.97945C11.1754 5.78419 11.492 5.78419 11.6872 5.97945Z"
      fill="#387C88"
    />
  </svg>
);

export const SingleUser = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16699 4.33333C5.16699 2.76853 6.43552 1.5 8.00033 1.5C9.56513 1.5 10.8337 2.76853 10.8337 4.33333C10.8337 5.89814 9.56513 7.16667 8.00033 7.16667C6.43552 7.16667 5.16699 5.89814 5.16699 4.33333ZM8.00033 2.5C6.9878 2.5 6.16699 3.32081 6.16699 4.33333C6.16699 5.34586 6.9878 6.16667 8.00033 6.16667C9.01285 6.16667 9.83366 5.34586 9.83366 4.33333C9.83366 3.32081 9.01285 2.5 8.00033 2.5Z"
      fill="#387C88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.24467 8.83301H9.75533C10.4834 8.833 11.0604 8.833 11.5255 8.871C12.0011 8.90985 12.4035 8.99092 12.771 9.17813C13.3668 9.48174 13.8513 9.9662 14.1549 10.562C14.3421 10.9295 14.4232 11.3319 14.462 11.8075C14.5 12.2726 14.5 12.8496 14.5 13.5777V13.9997C14.5 14.2758 14.2761 14.4997 14 14.4997H2C1.72386 14.4997 1.5 14.2758 1.5 13.9997L1.5 13.5777C1.5 12.8496 1.49999 12.2726 1.53799 11.8075C1.57685 11.3319 1.65792 10.9295 1.84515 10.562C2.14874 9.9662 2.63318 9.48174 3.22904 9.17814C3.59649 8.99093 3.99891 8.90985 4.4745 8.871C4.93958 8.833 5.51657 8.833 6.24467 8.83301ZM3.68302 10.0692C3.27534 10.2769 2.94388 10.6083 2.73615 11.016C2.63273 11.219 2.56848 11.4752 2.53467 11.8889C2.50192 12.2898 2.5001 12.797 2.50001 13.4997H13.5C13.4999 12.797 13.4981 12.2898 13.4653 11.8889C13.4315 11.4752 13.3673 11.219 13.2639 11.016C13.0561 10.6084 12.7247 10.2769 12.317 10.0692M3.68302 10.0692C3.886 9.96573 4.14218 9.90148 4.55593 9.86768C4.97551 9.8334 5.51168 9.83301 6.26667 9.83301H9.73333C10.4883 9.83301 11.0245 9.8334 11.4441 9.86768C11.8578 9.90148 12.114 9.96573 12.317 10.0692"
      fill="#387C88"
    />
  </svg>
);

export const InfoRoundedIcon = ({
  width = "18",
  height = "18",
  fillColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 13.1355 13.1355 16.5 9 16.5C4.8645 16.5 1.5 13.1355 1.5 9C1.5 4.8645 4.8645 1.5 9 1.5ZM9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM9.9375 12.75C9.9375 13.2675 9.51825 13.6875 9 13.6875C8.48325 13.6875 8.0625 13.2675 8.0625 12.75C8.0625 12.2325 8.48325 11.8125 9 11.8125C9.51825 11.8125 9.9375 12.2325 9.9375 12.75ZM10.9823 5.2515C10.5262 4.7895 9.846 4.53525 9.069 4.53525C7.434 4.53525 6.3765 5.69775 6.3765 7.49775H7.88475C7.88475 6.38325 8.5065 5.988 9.03825 5.988C9.51375 5.988 10.0185 6.30375 10.0612 6.9075C10.1077 7.54275 9.76875 7.86525 9.33975 8.27325C8.28075 9.2805 8.26125 9.768 8.26575 10.8742H9.7695C9.75975 10.3762 9.792 9.972 10.4708 9.24075C10.9785 8.69325 11.61 8.01225 11.6227 6.97425C11.631 6.28125 11.4097 5.685 10.9823 5.2515Z"
      fill={fillColor}
    />
  </svg>
);

export const EasyConnection = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.36318 1.3765C7.47106 1.17055 7.68434 1.0415 7.91683 1.0415H15.4168C15.6561 1.0415 15.8744 1.1781 15.979 1.39329C16.0835 1.60849 16.0561 1.8645 15.9083 2.05264L12.1194 6.87484H17.0835C17.3317 6.87484 17.5565 7.02176 17.656 7.24917C17.7556 7.47657 17.7111 7.74135 17.5427 7.92376L7.54275 18.7571C7.34808 18.968 7.03479 19.0192 6.7831 18.8812C6.53142 18.7433 6.40603 18.4517 6.47907 18.1741L8.35608 11.0415H3.3335C3.11479 11.0415 2.91199 10.9272 2.79876 10.7401C2.68554 10.5529 2.67837 10.3202 2.77985 10.1265L7.36318 1.3765ZM8.295 2.2915L4.36643 9.7915H9.16683C9.36064 9.7915 9.54349 9.88142 9.66182 10.0349C9.78015 10.1884 9.82058 10.3881 9.77125 10.5756L8.32668 16.0649L15.656 8.12484H10.8335C10.5942 8.12484 10.376 7.98824 10.2714 7.77305C10.1668 7.55786 10.1942 7.30184 10.342 7.1137L14.1309 2.2915H8.295Z"
      fill="#606266"
    />
  </svg>
);

export const PrivateIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33333 9.7915C3.21827 9.7915 3.125 9.88478 3.125 9.99984V17.4998C3.125 17.6149 3.21827 17.7082 3.33333 17.7082H16.6667C16.7817 17.7082 16.875 17.6149 16.875 17.4998V9.99984C16.875 9.88478 16.7817 9.7915 16.6667 9.7915H3.33333ZM1.875 9.99984C1.875 9.19442 2.52792 8.5415 3.33333 8.5415H16.6667C17.4721 8.5415 18.125 9.19442 18.125 9.99984V17.4998C18.125 18.3053 17.4721 18.9582 16.6667 18.9582H3.33333C2.52792 18.9582 1.875 18.3053 1.875 17.4998V9.99984Z"
      fill="#606266"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0002 2.2915C8.04417 2.2915 6.4585 3.87716 6.4585 5.83317V9.1665C6.4585 9.51168 6.17867 9.7915 5.8335 9.7915C5.48832 9.7915 5.2085 9.51168 5.2085 9.1665V5.83317C5.2085 3.1868 7.35382 1.0415 10.0002 1.0415C12.6465 1.0415 14.7918 3.1868 14.7918 5.83317V9.1665C14.7918 9.51168 14.512 9.7915 14.1668 9.7915C13.8217 9.7915 13.5418 9.51168 13.5418 9.1665V5.83317C13.5418 3.87716 11.9562 2.2915 10.0002 2.2915Z"
      fill="#606266"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 11.875C10.3452 11.875 10.625 12.1548 10.625 12.5V15C10.625 15.3452 10.3452 15.625 10 15.625C9.65482 15.625 9.375 15.3452 9.375 15V12.5C9.375 12.1548 9.65482 11.875 10 11.875Z"
      fill="#606266"
    />
  </svg>
);

export const SecureIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.83219 1.04503C9.94425 1.01232 10.0633 1.01234 10.1754 1.04507L17.5188 3.19023C17.7799 3.2665 17.9594 3.5059 17.9594 3.77791V8.17712C17.9594 13.0646 14.8316 17.4035 10.1948 18.9485C10.0692 18.9904 9.93339 18.9904 9.80777 18.9485C5.16975 17.4036 2.04102 13.0637 2.04102 8.17508V3.77791C2.04102 3.50584 2.22056 3.26641 2.48174 3.19018L9.83219 1.04503ZM3.26551 4.23702V8.17508C3.26551 12.4682 5.97006 16.287 10.0012 17.7202C14.0312 16.287 16.7349 12.4691 16.7349 8.17712V4.2369L10.0036 2.27056L3.26551 4.23702Z"
      fill="#606266"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5146 6.91419C14.7537 7.15328 14.7537 7.54093 14.5146 7.78003L9.61667 12.678C9.37757 12.9171 8.98992 12.9171 8.75082 12.678L5.89368 9.82085C5.65458 9.58175 5.65458 9.1941 5.89368 8.955C6.13277 8.71591 6.52043 8.71591 6.75952 8.955L9.18374 11.3792L13.6488 6.91419C13.8879 6.67509 14.2755 6.67509 14.5146 6.91419Z"
      fill="#606266"
    />
  </svg>
);

export const SetupIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.60493 1.3655C7.89108 1.28629 8.19347 1.41933 8.3284 1.68382C8.63928 2.29318 9.2717 2.70826 9.99996 2.70826C10.7282 2.70826 11.3606 2.29318 11.6715 1.68382C11.8064 1.41933 12.1088 1.28629 12.395 1.3655C13.7987 1.75406 15.0632 2.47526 16.0986 3.43804C16.3008 3.62606 16.3557 3.92449 16.2336 4.17214C16.1109 4.42105 16.0416 4.70151 16.0416 4.99992C16.0416 6.03545 16.8811 6.87492 17.9166 6.87492L17.9428 6.87474C18.2191 6.87079 18.4652 7.04875 18.548 7.31238C18.8147 8.16157 18.9583 9.06457 18.9583 9.99992C18.9583 10.6173 18.8957 11.2207 18.7764 11.8039C18.7123 12.1175 18.4216 12.332 18.103 12.3007C18.0419 12.2947 17.9798 12.2916 17.9166 12.2916C16.8811 12.2916 16.0416 13.1311 16.0416 14.1666C16.0416 14.6275 16.2071 15.0482 16.4827 15.3748C16.6891 15.6194 16.6773 15.9805 16.4553 16.2112C15.3981 17.3098 14.0621 18.1397 12.5601 18.5869C12.2339 18.684 11.89 18.5024 11.7864 18.1782C11.5445 17.4216 10.8353 16.8749 9.99996 16.8749C9.16466 16.8749 8.45541 17.4216 8.21353 18.1782C8.10992 18.5024 7.76602 18.684 7.43987 18.5869C5.93784 18.1397 4.60187 17.3098 3.54457 16.2112C3.32259 15.9805 3.31078 15.6194 3.51722 15.3748C3.79278 15.0482 3.95829 14.6275 3.95829 14.1666C3.95829 13.1311 3.11883 12.2916 2.08329 12.2916C2.02015 12.2916 1.95798 12.2947 1.89691 12.3007C1.57834 12.332 1.28762 12.1175 1.22347 11.8039C1.10417 11.2207 1.04163 10.6173 1.04163 9.99992C1.04163 9.06457 1.18519 8.16157 1.45193 7.31237C1.53474 7.04875 1.78083 6.87079 2.05713 6.87474L2.08329 6.87492C3.11883 6.87492 3.95829 6.03545 3.95829 4.99992C3.95829 4.70151 3.88903 4.42105 3.76631 4.17214C3.64421 3.92449 3.69908 3.62606 3.90128 3.43804C4.93672 2.47526 6.20124 1.75406 7.60493 1.3655ZM5.06893 4.07485C5.15956 4.36762 5.20829 4.67845 5.20829 4.99992C5.20829 6.57446 4.0438 7.87703 2.52906 8.09337C2.37411 8.70257 2.29163 9.34122 2.29163 9.99992C2.29163 10.3577 2.31596 10.7096 2.36301 11.0539C3.95786 11.1954 5.20829 12.535 5.20829 14.1666C5.20829 14.7224 5.06279 15.245 4.80806 15.6976C5.522 16.3486 6.35831 16.8669 7.27798 17.2141C7.81418 16.2657 8.83166 15.6249 9.99996 15.6249C11.1683 15.6249 12.1857 16.2657 12.7219 17.2141C13.6416 16.8669 14.4779 16.3486 15.1919 15.6976C14.9371 15.245 14.7916 14.7224 14.7916 14.1666C14.7916 12.535 16.0421 11.1954 17.6369 11.0539C17.684 10.7096 17.7083 10.3577 17.7083 9.99992C17.7083 9.34123 17.6258 8.70258 17.4708 8.09337C15.9561 7.87703 14.7916 6.57446 14.7916 4.99992C14.7916 4.67846 14.8404 4.36762 14.931 4.07485C14.2181 3.48084 13.3968 3.01337 12.5015 2.70638C11.932 3.46573 11.0239 3.95826 9.99996 3.95826C8.97607 3.95826 8.06795 3.46573 7.49846 2.70638C6.60314 3.01337 5.78182 3.48084 5.06893 4.07485Z"
      fill="#7E8085"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.45837 10.0002C6.45837 8.04415 8.04403 6.4585 10 6.4585C11.9561 6.4585 13.5417 8.04415 13.5417 10.0002C13.5417 11.9562 11.9561 13.5418 10 13.5418C8.04403 13.5418 6.45837 11.9562 6.45837 10.0002ZM10 7.7085C8.73439 7.7085 7.70837 8.73451 7.70837 10.0002C7.70837 11.2658 8.73439 12.2918 10 12.2918C11.2657 12.2918 12.2917 11.2658 12.2917 10.0002C12.2917 8.73451 11.2657 7.7085 10 7.7085Z"
      fill="#7E8085"
    />
  </svg>
);

export const FairFreeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.05975 0.22271C5.66775 0.571911 2.68635 2.64391 1.19755 5.68291C0.840751 6.40451 0.671951 6.86491 0.483951 7.60151C0.249751 8.52251 0.199951 8.96371 0.199951 10.0037C0.199951 11.0435 0.249751 11.4849 0.483951 12.4057C0.671951 13.1425 0.840751 13.6029 1.19775 14.3243C2.14555 16.2621 3.74175 17.8583 5.67955 18.8099C6.38175 19.1515 6.92655 19.3547 7.64035 19.5313C8.53035 19.7537 8.97935 19.8037 9.99995 19.8037C11.0398 19.8037 11.4812 19.7537 12.402 19.5197C13.1386 19.3317 13.5992 19.1629 14.3206 18.8099C16.2584 17.8583 17.8546 16.2621 18.8024 14.3243C19.1592 13.6029 19.328 13.1425 19.516 12.4057C19.75 11.4847 19.8 11.0435 19.8 10.0037C19.8 8.98311 19.75 8.53411 19.5274 7.64391C19.0172 5.59091 17.82 3.71851 16.1624 2.37151C15.4104 1.75751 14.2746 1.11291 13.3614 0.775311C12.8626 0.59111 11.9378 0.357111 11.3814 0.27651C10.8634 0.199711 9.56255 0.169109 9.05975 0.22271ZM11.2662 1.50451C15.0266 2.09531 17.9236 5.00391 18.5068 8.77571C18.5988 9.38191 18.5988 10.6213 18.5068 11.2315C17.9774 14.6849 15.4792 17.4553 12.1104 18.3263C11.3698 18.5181 10.8786 18.5757 9.99995 18.5757C8.59935 18.5757 7.42135 18.3071 6.23195 17.7123C3.65715 16.4269 1.95735 14.1093 1.49295 11.2507C1.40095 10.6597 1.40095 9.34751 1.49295 8.75651C2.14135 4.75831 5.30315 1.79591 9.30915 1.43151C9.67755 1.39691 10.8786 1.44291 11.2662 1.50451Z"
      fill="#7E8085"
    />
    <path
      d="M6.46975 4.53927C6.03995 4.62747 5.61015 4.87307 5.27635 5.20307C4.77375 5.70567 4.55115 6.23907 4.55115 6.93367C4.55115 7.62827 4.77375 8.16147 5.27635 8.66427C5.94795 9.33567 6.89195 9.55447 7.78215 9.24747C8.39615 9.03647 8.91415 8.57607 9.19035 8.00047C9.37835 7.59747 9.43975 7.34427 9.43975 6.93367C9.43595 6.51547 9.37835 6.26607 9.18655 5.85927C9.05615 5.59067 8.97555 5.47547 8.69915 5.20687C8.46895 4.97667 8.29235 4.84227 8.11215 4.75407C7.58635 4.49707 7.01475 4.42047 6.46975 4.53927ZM7.52115 5.83627C8.43815 6.28527 8.43435 7.58207 7.51355 8.03507C7.32935 8.12707 7.24495 8.14247 6.98795 8.14247C6.73095 8.14247 6.64635 8.12707 6.46235 8.03507C6.05935 7.83927 5.81775 7.47487 5.78695 7.02967C5.76775 6.70347 5.81755 6.50007 5.98255 6.25847C6.33155 5.74027 6.96855 5.56767 7.52115 5.83627Z"
      fill="#7E8085"
    />
    <path
      d="M14.6811 4.52013C14.5659 4.56613 4.6853 14.4275 4.6049 14.5771C4.5129 14.7575 4.5359 15.0337 4.6625 15.2063C4.7201 15.2869 4.8083 15.3867 4.8505 15.4289C4.9617 15.5287 5.2381 15.5517 5.3839 15.4787C5.5335 15.4019 15.3681 5.51753 15.4601 5.34873C15.5101 5.26433 15.5253 5.17213 15.5139 5.04553C15.4793 4.63913 15.0571 4.37433 14.6811 4.52013Z"
      fill="#7E8085"
    />
    <path
      d="M12.6092 10.6751C12.1756 10.7711 11.7458 11.0127 11.4158 11.3427C10.9132 11.8453 10.6906 12.3787 10.6906 13.0733C10.6906 13.7679 10.9132 14.3011 11.4158 14.8039C12.0874 15.4753 13.0312 15.6941 13.9214 15.3871C14.3242 15.2451 14.6082 15.0609 14.9268 14.7233C15.1992 14.4317 15.441 13.9865 15.5292 13.6105C15.7902 12.4709 15.0266 11.1471 13.8716 10.7441C13.5186 10.6213 12.9738 10.5907 12.6092 10.6751ZM13.6146 11.9529C14.1442 12.1869 14.4512 12.7701 14.313 13.2921C14.1518 13.9061 13.6108 14.3357 13.0468 14.2897C12.5978 14.2551 12.241 14.0135 12.0338 13.6029C11.8188 13.1655 11.8918 12.6359 12.2218 12.2561C12.5594 11.8723 13.1464 11.7457 13.6146 11.9529Z"
      fill="#7E8085"
    />
  </svg>
);

export const DateCalenderIcon = ({
  width = "16",
  height = "16",
  strokeWidth = "1.5",
  strokeColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6666 1.33334V4.00001"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33333 1.33334V4.00001"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.99999H14"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6667 2.66666H3.33333C2.59667 2.66666 2 3.26332 2 3.99999V12.6667C2 13.4033 2.59667 14 3.33333 14H12.6667C13.4033 14 14 13.4033 14 12.6667V3.99999C14 3.26332 13.4033 2.66666 12.6667 2.66666Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67532 8.486C4.58332 8.486 4.50865 8.56067 4.50932 8.65267C4.50932 8.74467 4.58399 8.81934 4.67599 8.81934C4.76799 8.81934 4.84265 8.74467 4.84265 8.65267C4.84265 8.56067 4.76799 8.486 4.67532 8.486"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00869 8.486C7.91669 8.486 7.84203 8.56067 7.84269 8.65267C7.84269 8.74467 7.91736 8.81934 8.00936 8.81934C8.10136 8.81934 8.17603 8.74467 8.17603 8.65267C8.17603 8.56067 8.10136 8.486 8.00869 8.486"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.342 8.486C11.25 8.486 11.1753 8.56067 11.176 8.65267C11.176 8.74467 11.2507 8.81934 11.3427 8.81934C11.4347 8.81934 11.5093 8.74467 11.5093 8.65267C11.5093 8.56067 11.4347 8.486 11.342 8.486"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67532 11.1527C4.58332 11.1527 4.50865 11.2273 4.50932 11.3193C4.50932 11.4113 4.58399 11.486 4.67599 11.486C4.76799 11.486 4.84265 11.4113 4.84265 11.3193C4.84265 11.2273 4.76799 11.1527 4.67532 11.1527"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00869 11.1527C7.91669 11.1527 7.84203 11.2273 7.84269 11.3193C7.84269 11.4113 7.91736 11.486 8.00936 11.486C8.10136 11.486 8.17603 11.4113 8.17603 11.3193C8.17603 11.2273 8.10136 11.1527 8.00869 11.1527"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseStatusIcon = ({
  width = "24",
  height = "24",
  strokeColor = "currentColor",
  fillColor = "currentColor",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89136 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89136 17.1086 2.75 12 2.75Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.2"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3588 8.64118C15.6517 8.93407 15.6517 9.40895 15.3588 9.70184L9.70193 15.3587C9.40904 15.6516 8.93416 15.6516 8.64127 15.3587C8.34838 15.0658 8.34838 14.5909 8.64127 14.298L14.2981 8.64118C14.591 8.34829 15.0659 8.34829 15.3588 8.64118Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.64127 8.64118C8.93416 8.34829 9.40904 8.34829 9.70193 8.64118L15.3588 14.298C15.6517 14.5909 15.6517 15.0658 15.3588 15.3587C15.0659 15.6516 14.591 15.6516 14.2981 15.3587L8.64127 9.70184C8.34838 9.40895 8.34838 8.93407 8.64127 8.64118Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeIcon = ({
  width = "24",
  height = "24",
  strokeColor = "currentColor",
  fillColor = "currentColor",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89136 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89136 17.1086 2.75 12 2.75Z"
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="0.2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0042 5.25C12.4184 5.25004 12.7542 5.58586 12.7541 6.00008L12.7536 11.6938L16.7736 15.7138C17.0665 16.0067 17.0665 16.4815 16.7736 16.7744C16.4807 17.0673 16.0058 17.0673 15.7129 16.7744L11.4732 12.5347C11.3325 12.3941 11.2535 12.2033 11.2535 12.0043L11.2541 5.99992C11.2542 5.58571 11.59 5.24996 12.0042 5.25Z"
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoneIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.3986 4.3986C6.34317 2.45406 9.0317 1.25 12 1.25C14.9683 1.25 17.6568 2.45406 19.6014 4.3986L19.0711 4.92893L19.6014 4.3986C21.5459 6.34317 22.75 9.0317 22.75 12C22.75 14.9683 21.5459 17.6568 19.6014 19.6014C17.6568 21.5459 14.9683 22.75 12 22.75C9.0317 22.75 6.34317 21.5459 4.3986 19.6014L4.92893 19.0711L4.3986 19.6014C2.45406 17.6568 1.25 14.9683 1.25 12C1.25 9.0317 2.45406 6.34317 4.3986 4.3986L4.3986 4.3986ZM12 2.75C9.4455 2.75 7.13403 3.78452 5.45926 5.45926C3.78451 7.13404 2.75 9.4455 2.75 12C2.75 14.5545 3.78452 16.866 5.45926 18.5407C7.13403 20.2155 9.4455 21.25 12 21.25C14.5545 21.25 16.866 20.2155 18.5407 18.5407C20.2155 16.866 21.25 14.5545 21.25 12C21.25 9.4455 20.2155 7.13403 18.5407 5.45926C16.866 3.78452 14.5545 2.75 12 2.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5303 8.46967C17.8232 8.76256 17.8232 9.23744 17.5303 9.53033L11.5303 15.5303C11.2374 15.8232 10.7626 15.8232 10.4697 15.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697C7.76256 11.1768 8.23744 11.1768 8.53033 11.4697L11 13.9393L16.4697 8.46967C16.7626 8.17678 17.2374 8.17678 17.5303 8.46967Z"
      fill="currentColor"
    />
  </svg>
);

export const ErrorWarningIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM7.2 12V10.4H8.8V12H7.2ZM7.2 4V8.8H8.8V4H7.2Z"
      fill="#A4233F"
    />
  </svg>
);
export const AvatarIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#726AFF"
    />
  </svg>
);

export const DolarCurcleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10.6667 9.38867C10.6667 7.95867 9.17867 7.56067 8.038 7.02467C7.34533 6.66467 7.43267 5.80533 8.42533 5.74733C8.976 5.714 9.542 5.87733 10.054 6.05733L10.2953 4.95933C9.69067 4.77533 9.14933 4.69133 8.66667 4.67867V4H8V4.71133C6.70333 4.88933 6.01067 5.70267 6.01067 6.61133C6.01067 8.23667 7.90867 8.48467 8.52933 8.77333C9.376 9.152 9.21933 9.94 8.45333 10.114C7.78867 10.2647 6.94067 10.002 6.30333 9.754L6 10.85C6.596 11.158 7.31 11.322 8 11.3347V12H8.66667V11.298C9.77133 11.1433 10.668 10.534 10.6667 9.38867V9.38867Z"
      fill="currentColor"
    />
  </svg>
);
export const NotificationIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99992 14C8.99992 15.0653 8.07192 16 7.01925 16C5.96659 16 4.99992 15.0653 4.99992 14H8.99992ZM9.09125 2.63C8.66192 2.38067 8.39658 1.91667 8.39725 1.41667V1.41467C8.39792 0.633333 7.77192 0 6.99992 0C6.22792 0 5.60192 0.633333 5.60192 1.41467V1.41667C5.60258 1.91733 5.33792 2.38067 4.90792 2.63C1.79592 4.436 3.58458 10.44 0.333252 11.5007V12.6667H13.6666V11.5007C10.4153 10.44 12.2046 4.43533 9.09125 2.63ZM6.99992 0.666667C7.36792 0.666667 7.66658 0.966 7.66658 1.33333C7.66658 1.70133 7.36792 2 6.99992 2C6.63192 2 6.33325 1.70133 6.33325 1.33333C6.33325 0.966 6.63192 0.666667 6.99992 0.666667ZM2.69925 11.3333C3.49192 10.222 3.76925 8.73933 4.00858 7.45667C4.30659 5.86333 4.58792 4.358 5.57792 3.784C6.49792 3.25 7.54858 3.27733 8.42258 3.784C9.41258 4.358 9.69392 5.86333 9.99192 7.45667C10.2313 8.73933 10.5086 10.222 11.3013 11.3333H2.69925Z"
      fill="currentColor"
    />
  </svg>
);

export const CustomerIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.08325 3.86426C6.20305 3.86426 5.4895 4.57781 5.4895 5.45801V5.63509H11.8645V5.45801C11.8645 4.57781 11.151 3.86426 10.2708 3.86426H7.08325ZM4.427 5.45801C4.427 3.991 5.61625 2.80176 7.08325 2.80176H10.2708C11.7378 2.80176 12.927 3.991 12.927 5.45801V6.16634C12.927 6.45974 12.6892 6.69759 12.3958 6.69759H4.95825C4.66485 6.69759 4.427 6.45974 4.427 6.16634V5.45801Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.08981 8.93576C1.21875 8.83509 1.38689 8.79943 1.54559 8.83911L8.45712 10.567C8.48526 10.574 8.51479 10.5741 8.54293 10.567L15.4546 8.83911C15.6133 8.79943 15.7814 8.83509 15.9104 8.93576C16.0393 9.03644 16.1147 9.19091 16.1147 9.3545V13.9587C16.1147 14.6433 15.5597 15.1982 14.8751 15.1982H2.12508C1.44048 15.1982 0.885498 14.6433 0.885498 13.9587V9.3545C0.885498 9.19091 0.960867 9.03644 1.08981 8.93576ZM1.948 10.0349V13.9587C1.948 14.0565 2.02728 14.1357 2.12508 14.1357H14.8751C14.9729 14.1357 15.0522 14.0565 15.0522 13.9587V10.0349L8.80085 11.5977C8.80081 11.5977 8.80089 11.5977 8.80085 11.5977C8.60345 11.6471 8.39683 11.6471 8.19943 11.5978C8.19939 11.5977 8.19947 11.5978 8.19943 11.5978L1.948 10.0349Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.885498 6.87533C0.885498 6.19071 1.44048 5.63574 2.12508 5.63574H14.8751C15.5597 5.63574 16.1147 6.19071 16.1147 6.87533V10.0628C16.1147 10.3562 15.8768 10.5941 15.5834 10.5941C15.29 10.5941 15.0522 10.3562 15.0522 10.0628V6.87533C15.0522 6.77751 14.9729 6.69824 14.8751 6.69824H2.12508C2.02728 6.69824 1.948 6.77752 1.948 6.87533V10.0628C1.948 10.3562 1.71015 10.5941 1.41675 10.5941C1.12335 10.5941 0.885498 10.3562 0.885498 10.0628V6.87533Z"
      fill="currentColor"
    />
    <path
      d="M9.38534 8.64616C9.38534 9.13516 8.98892 9.53158 8.49992 9.53158C8.01092 9.53158 7.6145 9.13516 7.6145 8.64616C7.6145 8.15716 8.01092 7.76074 8.49992 7.76074C8.98892 7.76074 9.38534 8.15716 9.38534 8.64616Z"
      fill="currentColor"
    />
  </svg>
);

export const WorldIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C12.4153 0 16 3.58467 16 8C16 12.4153 12.4153 16 8 16C3.58467 16 0 12.4153 0 8C0 3.58467 3.58467 0 8 0ZM9.70467 10.6667H6.29467C6.65867 12.3067 7.25533 13.4093 8 14.496C8.796 13.3353 9.36067 12.2227 9.70467 10.6667ZM4.93333 10.6667H1.88867C2.71267 12.55 4.358 13.9813 6.392 14.4773C5.69333 13.322 5.20333 12.0387 4.93333 10.6667ZM14.1113 10.6667H11.0667C10.806 11.992 10.3367 13.258 9.61667 14.4627C11.6247 13.954 13.2947 12.5327 14.1113 10.6667ZM4.77467 6.66667H1.46667C1.28867 7.542 1.28867 8.45667 1.46667 9.33333H4.74333C4.664 8.44733 4.676 7.552 4.77467 6.66667ZM9.882 6.66667H6.11733C6.00733 7.55067 5.994 8.448 6.082 9.33333H9.91733C10.006 8.448 9.99133 7.55133 9.882 6.66667ZM14.5333 6.66667H11.2247C11.3233 7.552 11.3353 8.44733 11.2567 9.33333H14.5333C14.7067 8.47667 14.7153 7.568 14.5333 6.66667ZM6.42933 1.514C4.378 2.002 2.718 3.438 1.88867 5.33333H4.99067C5.28067 3.972 5.776 2.67667 6.42933 1.514ZM7.99933 1.482C7.27333 2.662 6.726 3.784 6.35733 5.33333H9.642C9.286 3.836 8.75067 2.70133 7.99933 1.482ZM9.578 1.528C10.2533 2.736 10.7333 4.03467 11.0087 5.33333H14.1113C13.29 3.456 11.6033 2.028 9.578 1.528Z"
      fill="currentColor"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.66667V4C10 1.79133 8.20867 0 6 0C3.79133 0 2 1.79133 2 4V6.66667H0V16H12V6.66667H10ZM3.33333 4C3.33333 2.52933 4.52933 1.33333 6 1.33333C7.47067 1.33333 8.66667 2.52933 8.66667 4V6.66667H3.33333V4ZM10.6667 14.6667H1.33333V8H10.6667V14.6667Z"
      fill="#606266"
    />
  </svg>
);

export const PictureIcon = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33333 3.66667C3.33333 3.11467 3.78133 2.66667 4.33333 2.66667C4.88533 2.66667 5.33333 3.11467 5.33333 3.66667C5.33333 4.21933 4.88533 4.66667 4.33333 4.66667C3.78133 4.66667 3.33333 4.21933 3.33333 3.66667ZM9.33333 4L7.654 6.66667L6 5.36L3.33333 9.33333H12.6667L9.33333 4ZM14.6667 1.33333V10.6667H1.33333V1.33333H14.6667ZM16 0H0V12H16V0Z"
      fill="currentColor"
    />
  </svg>
);

export const ReferalIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2335_6871)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83325 6.66699C1.83325 6.39085 2.05711 6.16699 2.33325 6.16699H13.6666C13.9427 6.16699 14.1666 6.39085 14.1666 6.66699V14.667C14.1666 14.9431 13.9427 15.167 13.6666 15.167H2.33325C2.05711 15.167 1.83325 14.9431 1.83325 14.667V6.66699ZM2.83325 7.16699V14.167H13.1666V7.16699H2.83325Z"
        fill="#606266"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6.16699C8.27614 6.16699 8.5 6.39085 8.5 6.66699V14.667C8.5 14.9431 8.27614 15.167 8 15.167C7.72386 15.167 7.5 14.9431 7.5 14.667V6.66699C7.5 6.39085 7.72386 6.16699 8 6.16699Z"
        fill="#606266"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83325 14.667C1.83325 14.3908 2.05711 14.167 2.33325 14.167H13.6666C13.9427 14.167 14.1666 14.3908 14.1666 14.667C14.1666 14.9431 13.9427 15.167 13.6666 15.167H2.33325C2.05711 15.167 1.83325 14.9431 1.83325 14.667Z"
        fill="#606266"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833252 4C0.833252 3.72386 1.05711 3.5 1.33325 3.5H14.6666C14.9427 3.5 15.1666 3.72386 15.1666 4V6.66667C15.1666 6.94281 14.9427 7.16667 14.6666 7.16667H1.33325C1.05711 7.16667 0.833252 6.94281 0.833252 6.66667V4ZM1.83325 4.5V6.16667H14.1666V4.5H1.83325Z"
        fill="#606266"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.9797 0.979454C5.17496 0.784192 5.49154 0.784192 5.68681 0.979454L7.99992 3.29257L10.313 0.979454C10.5083 0.784192 10.8249 0.784192 11.0201 0.979454C11.2154 1.17472 11.2154 1.4913 11.0201 1.68656L8.35347 4.35323C8.15821 4.54849 7.84163 4.54849 7.64636 4.35323L4.9797 1.68656C4.78444 1.4913 4.78444 1.17472 4.9797 0.979454Z"
        fill="#606266"
      />
    </g>
    <defs>
      <clipPath id="clip0_2335_6871">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadFileIcon = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 16H0V0H9.1L13 4V16ZM8.45 0.666667H0.65V15.3333H12.35V4.66667H8.45V0.666667ZM10.4 10.6667V11.3333H2.6V10.6667H10.4ZM10.4 8.66667V9.33333H2.6V8.66667H10.4ZM10.4 6.66667V7.33333H2.6V6.66667H10.4ZM9.1 4H12.0809L9.1 0.942667V4Z"
      fill="currentColor"
    />
  </svg>
);
export const LogoutIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 2C1.5 1.72386 1.72386 1.5 2 1.5H7.99723C8.27338 1.5 8.49723 1.72386 8.49723 2C8.49723 2.27614 8.27338 2.5 7.99723 2.5H2.5V13.5H8C8.27614 13.5 8.5 13.7239 8.5 14C8.5 14.2761 8.27614 14.5 8 14.5H2C1.72386 14.5 1.5 14.2761 1.5 14V2Z"
      fill="#387C88"
      stroke="#387C88"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645L14.3536 7.64645C14.5488 7.84171 14.5488 8.15829 14.3536 8.35355L11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536C10.4512 11.1583 10.4512 10.8417 10.6464 10.6464L13.2929 8L10.6464 5.35355C10.4512 5.15829 10.4512 4.84171 10.6464 4.64645Z"
      fill="#387C88"
      stroke="#387C88"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.83325 7.99707C4.83325 7.72093 5.05711 7.49707 5.33325 7.49707H13.9999C14.2761 7.49707 14.4999 7.72093 14.4999 7.99707C14.4999 8.27321 14.2761 8.49707 13.9999 8.49707H5.33325C5.05711 8.49707 4.83325 8.27321 4.83325 7.99707Z"
      fill="#387C88"
      stroke="#387C88"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockedIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52381 6.66667V4C9.52381 1.79133 7.81778 0 5.71429 0C3.61079 0 1.90476 1.79133 1.90476 4V6.66667H0V16H11.4286V6.66667H9.52381ZM3.1746 6.66667V4C3.1746 2.52933 4.31365 1.33333 5.71429 1.33333C7.11492 1.33333 8.25397 2.52933 8.25397 4V6.66667H3.1746Z"
      fill="#606266"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2438 0.10394C10.4558 0.017747 10.6989 0.0685822 10.8586 0.232505L16.9029 6.43699C17.1117 6.65124 17.1162 6.99137 16.9133 7.21112L10.8689 13.7566C10.7118 13.9268 10.4665 13.9832 10.2508 13.8989C10.0351 13.8145 9.89319 13.6066 9.89319 13.375V9.85406C8.82139 9.73514 7.69306 9.79879 6.50512 10.0508C5.28114 10.3105 3.75675 11.4464 1.93515 13.67C1.77789 13.862 1.51341 13.9282 1.28424 13.833C1.05507 13.7378 0.915353 13.5037 0.940387 13.2568C1.20787 10.6188 2.22002 8.39205 3.98357 6.60492L4.38396 7.00002L3.98357 6.60492C5.62394 4.9426 7.60219 4.03593 9.89319 3.89444V0.625018C9.89319 0.396169 10.0318 0.190132 10.2438 0.10394ZM11.0182 2.00853V4.43764C11.0182 4.74657 10.7691 4.99768 10.4601 5.00013C8.22787 5.01778 6.3465 5.81204 4.78434 7.39511L4.41922 7.03482L4.78434 7.39511C3.65832 8.53619 2.87162 9.87795 2.42672 11.4308C3.7715 10.0656 5.0527 9.20897 6.27162 8.95034C7.75604 8.63538 9.18259 8.58519 10.5466 8.80853C10.8185 8.85307 11.0182 9.08806 11.0182 9.36364V11.9367L15.7248 6.83986L11.0182 2.00853Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.29175 8.33325C2.29175 7.98807 2.57157 7.70825 2.91675 7.70825H17.0834C17.4286 7.70825 17.7084 7.98807 17.7084 8.33325V18.3333C17.7084 18.6784 17.4286 18.9583 17.0834 18.9583H2.91675C2.57157 18.9583 2.29175 18.6784 2.29175 18.3333V8.33325ZM3.54175 8.95825V17.7083H16.4584V8.95825H3.54175Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.70825C10.3452 7.70825 10.625 7.98807 10.625 8.33325V18.3333C10.625 18.6784 10.3452 18.9583 10 18.9583C9.65482 18.9583 9.375 18.6784 9.375 18.3333V8.33325C9.375 7.98807 9.65482 7.70825 10 7.70825Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.29175 18.3333C2.29175 17.9881 2.57157 17.7083 2.91675 17.7083H17.0834C17.4286 17.7083 17.7084 17.9881 17.7084 18.3333C17.7084 18.6784 17.4286 18.9583 17.0834 18.9583H2.91675C2.57157 18.9583 2.29175 18.6784 2.29175 18.3333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.04175 5C1.04175 4.65482 1.32157 4.375 1.66675 4.375H18.3334C18.6786 4.375 18.9584 4.65482 18.9584 5V8.33333C18.9584 8.67851 18.6786 8.95833 18.3334 8.95833H1.66675C1.32157 8.95833 1.04175 8.67851 1.04175 8.33333V5ZM2.29175 5.625V7.70833H17.7084V5.625H2.29175Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.22481 1.22481C6.46888 0.980729 6.86461 0.980729 7.10869 1.22481L10.0001 4.1162L12.8915 1.22481C13.1355 0.980729 13.5313 0.980729 13.7754 1.22481C14.0194 1.46888 14.0194 1.86461 13.7754 2.10869L10.442 5.44202C10.1979 5.6861 9.80222 5.6861 9.55814 5.44202L6.22481 2.10869C5.98073 1.86461 5.98073 1.46888 6.22481 1.22481Z"
      fill="currentColor"
    />
  </svg>
);

export const ConfirmIcon = () => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 39.0005C31.6127 39.0005 39 31.6132 39 22.5005C39 13.3878 31.6127 6.00049 22.5 6.00049C13.3873 6.00049 6 13.3878 6 22.5005C6 31.6132 13.3873 39.0005 22.5 39.0005Z"
      fill="currentColor"
    />
    <path
      d="M19.4923 30.0608L14.5274 23.5894L17.4147 21.3131L19.7656 24.3771L27.708 15.8788L30.364 18.4293L19.4923 30.0608Z"
      fill="white"
    />
    <circle
      cx="22.5"
      cy="22.5"
      r="21.5"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_4092)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1875 2.91667C2.1875 2.67505 2.38338 2.47917 2.625 2.47917H11.375C11.6166 2.47917 11.8125 2.67505 11.8125 2.91667V12.8333C11.8125 13.075 11.6166 13.2708 11.375 13.2708H2.625C2.38338 13.2708 2.1875 13.075 2.1875 12.8333V2.91667ZM3.0625 3.35417V12.3958H10.9375V3.35417H3.0625Z"
        fill="#387C88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83325 5.39583C6.07488 5.39583 6.27075 5.5917 6.27075 5.83333V9.62499C6.27075 9.86662 6.07488 10.0625 5.83325 10.0625C5.59163 10.0625 5.39575 9.86662 5.39575 9.62499V5.83333C5.39575 5.5917 5.59163 5.39583 5.83325 5.39583Z"
        fill="#387C88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16675 5.39583C8.40837 5.39583 8.60425 5.5917 8.60425 5.83333V9.62499C8.60425 9.86662 8.40837 10.0625 8.16675 10.0625C7.92512 10.0625 7.72925 9.86662 7.72925 9.62499V5.83333C7.72925 5.5917 7.92512 5.39583 8.16675 5.39583Z"
        fill="#387C88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.729248 2.91667C0.729248 2.67505 0.925123 2.47917 1.16675 2.47917H12.8334C13.075 2.47917 13.2709 2.67505 13.2709 2.91667C13.2709 3.1583 13.075 3.35417 12.8334 3.35417H1.16675C0.925123 3.35417 0.729248 3.1583 0.729248 2.91667Z"
        fill="#387C88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2424 0.956373C5.3192 0.816268 5.46627 0.729172 5.62604 0.729172H8.3934C8.55451 0.729172 8.70258 0.817716 8.77882 0.959645L9.71883 2.70964C9.79166 2.84523 9.78789 3.00911 9.7089 3.14121C9.62991 3.2733 9.48732 3.35417 9.33341 3.35417H4.66675C4.51218 3.35417 4.36907 3.27261 4.29031 3.13961C4.21154 3.00661 4.20881 2.84192 4.28311 2.70637L5.2424 0.956373ZM5.88514 1.60417L5.40549 2.47917H8.60179L8.13178 1.60417H5.88514Z"
        fill="#387C88"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_4092">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HomeIdentityIcon = () => (
  <svg
    width="70"
    height="60"
    viewBox="0 0 74 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8346 56.5488L22.8135 58.8196C22.8135 58.8196 37.312 48.0258 39.6696 43.2584C42.0273 38.4911 37.5893 26.6982 37.5893 26.6982L27.7425 31.591L18.8346 56.5488Z"
      fill="#C5AB9C"
    />
    <path
      d="M47.8521 23.436L50.7645 23.6869C50.7645 23.6869 52.2901 26.6979 47.5747 26.9488L47.8521 23.436Z"
      fill="#C5AB9C"
    />
    <path
      d="M47.8521 28.0781L50.7645 28.329C50.7645 28.329 52.2901 31.34 47.5747 31.5909L47.8521 28.0781Z"
      fill="#C5AB9C"
    />
    <path
      d="M47.8521 33.0962L50.7645 33.3471C50.7645 33.3471 52.2901 36.358 47.5747 36.609L47.8521 33.0962Z"
      fill="#C5AB9C"
    />
    <path
      d="M47.0201 38.1143L49.9326 38.3652C49.9326 38.3652 51.4581 41.3761 46.7428 41.627L47.0201 38.1143Z"
      fill="#C5AB9C"
    />
    <g filter="url(#filter0_dd_451_21245)">
      <path
        d="M49.27 24.6459H49.049V19.1696C49.049 18.7533 48.9584 18.3412 48.7823 17.9566C48.6062 17.5721 48.3481 17.2227 48.0228 16.9283C47.6974 16.634 47.3111 16.4006 46.886 16.2413C46.4609 16.082 46.0053 16 45.5452 16H32.7192C32.259 16 31.8034 16.082 31.3783 16.2413C30.9532 16.4005 30.567 16.634 30.2416 16.9283C29.9162 17.2227 29.6581 17.5721 29.4821 17.9566C29.306 18.3412 29.2153 18.7533 29.2153 19.1695V49.2131C29.2153 49.6293 29.306 50.0415 29.482 50.426C29.6581 50.8106 29.9162 51.16 30.2416 51.4543C30.5669 51.7486 30.9532 51.9821 31.3783 52.1414C31.8034 52.3007 32.259 52.3827 32.7192 52.3827H45.5452C46.4744 52.3827 47.3656 52.0487 48.0227 51.4543C48.6798 50.8599 49.049 50.0537 49.049 49.2131V28.544H49.27V24.6459Z"
        fill="#E6E6E6"
      />
    </g>
    <path
      d="M45.6865 16.8247H44.0123C44.0893 16.9955 44.1186 17.1807 44.0978 17.3642C44.077 17.5476 44.0067 17.7236 43.893 17.8767C43.7793 18.0297 43.6257 18.1552 43.4458 18.2419C43.2659 18.3286 43.0651 18.374 42.8613 18.374H35.5134C35.3096 18.374 35.1088 18.3286 34.9289 18.2419C34.749 18.1552 34.5954 18.0297 34.4817 17.8767C34.368 17.7236 34.2977 17.5476 34.2769 17.3642C34.2561 17.1807 34.2854 16.9955 34.3624 16.8247H32.7987C32.1047 16.8247 31.4392 17.0741 30.9485 17.518C30.4578 17.9619 30.1821 18.5639 30.1821 19.1917V49.1912C30.1821 49.502 30.2498 49.8098 30.3813 50.097C30.5128 50.3842 30.7055 50.6451 30.9485 50.8649C31.1915 51.0847 31.4799 51.259 31.7974 51.378C32.1148 51.4969 32.4551 51.5582 32.7987 51.5582H45.6865C46.0301 51.5582 46.3704 51.4969 46.6878 51.378C47.0053 51.259 47.2937 51.0847 47.5367 50.8649C47.7797 50.6451 47.9724 50.3842 48.1039 50.097C48.2354 49.8098 48.3031 49.502 48.3031 49.1912V19.1917C48.3031 18.8809 48.2354 18.5731 48.1039 18.2859C47.9724 17.9987 47.7797 17.7378 47.5367 17.518C47.2937 17.2982 47.0053 17.1238 46.6878 17.0049C46.3704 16.8859 46.0301 16.8247 45.6865 16.8247Z"
      fill="white"
    />
    <path
      d="M36.2185 30.4087H42.2667V31.6142H36.2185V30.4087Z"
      fill="#EDECFF"
    />
    <path d="M32.4931 32.9985H45.9921V34.204H32.4931V32.9985Z" fill="#EDECFF" />
    <path
      d="M32.4931 35.5879H45.9921V36.7934H32.4931V35.5879Z"
      fill="#EDECFF"
    />
    <path
      d="M14.4024 52.5059L21.2937 44.5757L21.8484 34.2883L27.6733 25.5064L29.3375 21.7427C29.3375 21.7427 33.2208 22.119 30.031 29.27L28.7135 33.0964C29.9011 35.4104 30.5164 37.9309 30.5164 40.4821V49.2503C30.5164 51.3149 23.1145 57.6487 21.8484 59.3666L14.4024 52.5059Z"
      fill="#C5AB9C"
    />
    <path
      opacity="0.2"
      d="M28.8807 26.2504L27.7227 25.7356L27.7622 25.6629L28.8321 26.1386L30.4472 22.3081L30.5308 22.337L28.8807 26.2504Z"
      fill="#141518"
    />
    <path
      opacity="0.2"
      d="M50.7491 23.6495L50.7799 23.7251L49.0653 24.2964L49.0345 24.2208L50.7491 23.6495Z"
      fill="#141518"
    />
    <path
      opacity="0.2"
      d="M50.7491 28.3443L50.7799 28.4199L49.0653 28.9913L49.0345 28.9156L50.7491 28.3443Z"
      fill="#141518"
    />
    <path
      opacity="0.2"
      d="M50.7491 33.3628L50.7799 33.4385L49.0653 34.0098L49.0345 33.9342L50.7491 33.3628Z"
      fill="#141518"
    />
    <path
      opacity="0.2"
      d="M49.8503 38.3829L49.8889 38.4556L49.0544 38.8179L49.0158 38.7452L49.8503 38.3829Z"
      fill="#141518"
    />
    <g filter="url(#filter1_dd_451_21245)">
      <rect
        width="14.6654"
        height="8.22734"
        rx="4"
        transform="matrix(-0.710765 -0.70343 -0.770682 0.637221 27.7643 56.7573)"
        fill="#EDECFF"
      />
    </g>
    <g filter="url(#filter2_d_451_21245)">
      <path
        d="M39.3821 49.462C36.6534 49.462 34.4412 47.4878 34.4412 45.0526C34.4412 42.6173 36.6534 40.6431 39.3821 40.6431C42.1109 40.6431 44.3231 42.6173 44.3231 45.0526C44.3231 47.4878 42.1109 49.462 39.3821 49.462Z"
        fill="#FFBC21"
      />
    </g>
    <path
      d="M41.8939 46.6548L39.424 42.6685C39.3885 42.6112 39.2485 42.5757 39.2485 42.5757C39.2485 42.5757 39.1086 42.6112 39.0733 42.6685L36.6034 46.6548C36.5863 46.6826 36.5778 46.713 36.5778 46.7435C36.5778 46.8365 36.6603 46.9244 36.7786 46.9244C36.8969 46.9244 41.7185 46.9244 41.7185 46.9244C41.7185 46.9244 41.9193 46.8374 41.9193 46.7435C41.9193 46.713 41.911 46.6826 41.8939 46.6548ZM41.3771 46.562H37.1202L39.2488 43.1268L41.3771 46.562ZM39.248 44.9924C39.3586 44.9924 39.4483 45.0736 39.4483 45.1736V46.0192C39.4483 46.1192 39.3586 46.2004 39.248 46.2004C39.1374 46.2004 39.0477 46.1192 39.0477 46.0192V45.1736C39.0477 45.0736 39.1374 44.9924 39.248 44.9924ZM39.2485 44.2676C39.1011 44.2676 38.9815 44.3758 38.9815 44.5092C38.9815 44.6425 39.1011 44.7508 39.2485 44.7508C39.396 44.7508 39.5156 44.6425 39.5156 44.5092C39.5156 44.3758 39.396 44.2676 39.2485 44.2676Z"
      fill="#3C4257"
    />
    <path
      d="M39.2276 20.591C40.0237 20.591 40.802 20.8046 41.464 21.2048C42.1261 21.605 42.6422 22.1738 42.947 22.8392C43.2519 23.5047 43.3319 24.2369 43.1768 24.9434C43.0217 25.6498 42.6385 26.2987 42.0758 26.808C41.513 27.3173 40.7959 27.6641 40.0152 27.8046C39.2344 27.9451 38.4251 27.873 37.6895 27.5973C36.9539 27.3216 36.3251 26.8548 35.8826 26.2559C35.4402 25.657 35.2039 24.9529 35.2036 24.2327L35.2036 24.2325C35.2035 23.7542 35.3075 23.2807 35.5096 22.8388C35.7118 22.397 36.0082 21.9956 36.3819 21.6574C36.7556 21.3193 37.1992 21.0511 37.6875 20.8681C38.1758 20.6851 38.6992 20.591 39.2278 20.591L39.2276 20.591ZM39.2279 21.6834C38.9891 21.6834 38.7556 21.7475 38.5571 21.8675C38.3586 21.9875 38.2039 22.1581 38.1125 22.3577C38.0212 22.5573 37.9973 22.777 38.044 22.9889C38.0906 23.2008 38.2057 23.3955 38.3746 23.5483C38.5435 23.7011 38.7587 23.8051 38.9929 23.8473C39.2271 23.8895 39.4699 23.8679 39.6905 23.7852C39.9111 23.7025 40.0996 23.5625 40.2323 23.3829C40.3649 23.2032 40.4357 22.992 40.4356 22.776C40.4355 22.4862 40.3082 22.2084 40.0817 22.0035C39.8553 21.7986 39.5481 21.6835 39.2279 21.6834ZM39.2293 26.9429C39.7063 26.941 40.1756 26.8338 40.5964 26.6306C41.0172 26.4274 41.3768 26.1344 41.644 25.777C41.6245 25.0486 40.0337 24.6476 39.2287 24.6475C38.4236 24.6475 36.8331 25.0483 36.8139 25.7766C37.0816 26.1338 37.4415 26.4267 37.8623 26.6299C38.2831 26.8331 38.7523 26.9405 39.2293 26.9429Z"
      fill="#EDECFF"
    />
    <defs>
      <filter
        id="filter0_dd_451_21245"
        x="5.21533"
        y="0"
        width="68.0547"
        height="84.3828"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_451_21245"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_451_21245"
          result="effect2_dropShadow_451_21245"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_451_21245"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_451_21245"
        x="0.732147"
        y="40.0073"
        width="37.3"
        height="36.4268"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_451_21245"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_451_21245"
          result="effect2_dropShadow_451_21245"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_451_21245"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_451_21245"
        x="30.4413"
        y="40.6431"
        width="17.8818"
        height="16.8188"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_451_21245"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_451_21245"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const HomeLinkBankIcon = () => (
  <svg
    width="70"
    height="55"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M23 25.9313H23.2692V19.0074C23.2692 18.4811 23.3796 17.96 23.5941 17.4738C23.8085 16.9876 24.1229 16.5459 24.5192 16.1737C24.9155 15.8016 25.386 15.5064 25.9038 15.305C26.4216 15.1037 26.9766 15 27.5371 15H43.1601C43.7206 15 44.2756 15.1037 44.7934 15.305C45.3112 15.5064 45.7817 15.8016 46.178 16.1737C46.5743 16.5458 46.8887 16.9876 47.1032 17.4738C47.3176 17.96 47.428 18.4811 47.428 19.0074V56.9926C47.428 57.5189 47.3176 58.04 47.1032 58.5262C46.8887 59.0124 46.5743 59.4541 46.178 59.8263C45.7817 60.1984 45.3112 60.4936 44.7934 60.695C44.2756 60.8963 43.7206 61 43.1601 61H27.5371C26.4052 61 25.3196 60.5778 24.5192 59.8263C23.7188 59.0747 23.2692 58.0555 23.2692 56.9926V30.8599H23V25.9313Z"
      fill="#E8EAED"
    />
    <g filter="url(#filter0_dd_451_21268)">
      <path
        d="M27.3649 16.0425H29.4043C29.3105 16.2584 29.2747 16.4926 29.3 16.7245C29.3254 16.9565 29.4111 17.179 29.5496 17.3725C29.6881 17.566 29.8751 17.7246 30.0943 17.8343C30.3134 17.9439 30.5579 18.0013 30.8062 18.0013H39.7565C40.0048 18.0013 40.2493 17.9439 40.4684 17.8343C40.6876 17.7246 40.8746 17.5661 41.0132 17.3725C41.1517 17.179 41.2374 16.9565 41.2627 16.7245C41.288 16.4926 41.2522 16.2584 41.1585 16.0425H43.0632C43.9085 16.0425 44.7192 16.3578 45.3169 16.919C45.9146 17.4802 46.2504 18.2414 46.2504 19.0351V56.9646C46.2504 57.3577 46.168 57.7468 46.0078 58.1099C45.8476 58.473 45.6129 58.8029 45.3169 59.0808C45.0209 59.3587 44.6696 59.5791 44.2829 59.7295C43.8962 59.8799 43.4817 59.9573 43.0632 59.9573H27.3649C26.9464 59.9573 26.5319 59.8799 26.1452 59.7295C25.7585 59.5791 25.4072 59.3587 25.1112 59.0808C24.8153 58.8029 24.5805 58.473 24.4203 58.1099C24.2601 57.7468 24.1777 57.3577 24.1777 56.9647V19.0351C24.1777 18.6421 24.2601 18.253 24.4203 17.8899C24.5805 17.5268 24.8153 17.1969 25.1112 16.919C25.4072 16.6411 25.7585 16.4207 26.1452 16.2703C26.5319 16.1199 26.9464 16.0425 27.3649 16.0425Z"
        fill="white"
      />
    </g>
    <path
      d="M37.815 26.6685H32.6125C32.1916 26.6685 31.8505 27.0096 31.8505 27.4305C31.8505 27.8514 32.1916 28.1926 32.6125 28.1926H37.815C38.2359 28.1926 38.5771 27.8514 38.5771 27.4305C38.5771 27.0096 38.2359 26.6685 37.815 26.6685Z"
      fill="#8C86FF"
    />
    <path
      d="M38.1353 29.4653H32.2923C31.8715 29.4653 31.5303 29.8065 31.5303 30.2274C31.5303 30.6483 31.8715 30.9894 32.2923 30.9894H38.1353C38.5562 30.9894 38.8974 30.6483 38.8974 30.2274C38.8974 29.8065 38.5562 29.4653 38.1353 29.4653Z"
      fill="#EDECFF"
    />
    <path
      d="M42.6734 32.7397H27.7548C27.334 32.7397 26.9928 33.0809 26.9928 33.5018C26.9928 33.9227 27.334 34.2639 27.7548 34.2639H42.6734C43.0943 34.2639 43.4355 33.9227 43.4355 33.5018C43.4355 33.0809 43.0943 32.7397 42.6734 32.7397Z"
      fill="#EDECFF"
    />
    <path
      d="M42.6734 36.0132H27.7548C27.334 36.0132 26.9928 36.3544 26.9928 36.7752C26.9928 37.1961 27.334 37.5373 27.7548 37.5373H42.6734C43.0943 37.5373 43.4355 37.1961 43.4355 36.7752C43.4355 36.3544 43.0943 36.0132 42.6734 36.0132Z"
      fill="#EDECFF"
    />
    <g filter="url(#filter1_dd_451_21268)">
      <path
        d="M35.2459 57C39.6642 57 43.2459 53.4183 43.2459 49C43.2459 44.5817 39.6642 41 35.2459 41C30.8276 41 27.2459 44.5817 27.2459 49C27.2459 53.4183 30.8276 57 35.2459 57Z"
        fill="#726AFF"
      />
    </g>
    <mask
      id="mask0_451_21268"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="31"
      y="45"
      width="9"
      height="8"
    >
      <rect x="31.2459" y="45" width="8" height="8" fill="url(#pattern0)" />
    </mask>
    <g mask="url(#mask0_451_21268)">
      <rect x="31.2459" y="45" width="8" height="8" fill="#F8F9FA" />
    </g>
    <defs>
      <filter
        id="filter0_dd_451_21268"
        x="0.177704"
        y="0.0424805"
        width="70.0727"
        height="91.915"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_451_21268"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_451_21268"
          result="effect2_dropShadow_451_21268"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_451_21268"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_451_21268"
        x="11.2459"
        y="31"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_451_21268"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_451_21268"
          result="effect2_dropShadow_451_21268"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_451_21268"
          result="shape"
        />
      </filter>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_451_21268" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_451_21268"
        width="512"
        height="512"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const AddIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 5.33333H0.5C0.224 5.33333 0 5.55733 0 5.83333C0 6.10933 0.224 6.33333 0.5 6.33333H5.33333V11.1667C5.33333 11.4427 5.55733 11.6667 5.83333 11.6667C6.10933 11.6667 6.33333 11.4427 6.33333 11.1667V6.33333H11.1667C11.4427 6.33333 11.6667 6.10933 11.6667 5.83333C11.6667 5.55733 11.4427 5.33333 11.1667 5.33333H6.33333V0.5C6.33333 0.224 6.10933 0 5.83333 0C5.55733 0 5.33333 0.224 5.33333 0.5V5.33333Z"
      fill="#387C88"
    />
  </svg>
);
export const BankAccountIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <mask
      id="mask0_2123_6771"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="14"
    >
      <rect width="14" height="14" fill="url(#pattern0)" />
    </mask>
    <g mask="url(#mask0_2123_6771)">
      <rect width="14" height="14" fill="#141518" />
    </g>
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_2123_6771" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_2123_6771"
        width="512"
        height="512"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 18.5002V14.0002C6.5 12.6192 7.619 11.5002 9 11.5002C10.381 11.5002 11.5 12.6192 11.5 14.0002V18.5002H17V9.91425C17 9.38425 16.789 8.87525 16.414 8.50025L9.707 1.79325C9.316 1.40225 8.683 1.40225 8.293 1.79325L1.586 8.50025C1.211 8.87525 1 9.38425 1 9.91425V18.5002H6.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InvoicesIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 19H3C1.895 19 1 18.105 1 17V3C1 1.895 1.895 1 3 1H14C15.105 1 16 1.895 16 3V17C16 18.105 15.105 19 14 19Z"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5.5H12.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 8.5H12.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 13H12.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 16H12.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4.75V4"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.25V10"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.698 8.714C4.892 9.032 5.224 9.252 5.625 9.252H6H6.447C7.029 9.252 7.5 8.78 7.5 8.199C7.5 7.716 7.171 7.295 6.703 7.177L5.297 6.825C4.829 6.707 4.5 6.286 4.5 5.803C4.5 5.222 4.972 4.75 5.553 4.75H6H6.375C6.775 4.75 7.106 4.969 7.3 5.286"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 8.22167C9.46833 8.22167 8.2225 9.46833 8.2225 11C8.2225 12.5317 9.46833 13.7775 11 13.7775C12.5317 13.7775 13.7775 12.5317 13.7775 11C13.7775 9.46833 12.5317 8.22167 11 8.22167ZM11 14.6108C9.00833 14.6108 7.38917 12.9917 7.38917 11C7.38917 9.00833 9.00833 7.38833 11 7.38833C12.9917 7.38833 14.6108 9.00833 14.6108 11C14.6108 12.9917 12.9917 14.6108 11 14.6108ZM10.0058 20.1667H11.9942C12.31 19.2467 12.5508 18.1242 13.75 17.625C14.9967 17.1108 15.9717 17.7883 16.7792 18.185L18.1842 16.7783C17.7608 15.9058 17.1292 14.9458 17.6267 13.7442C18.0992 12.6033 19.0758 12.3583 20.1667 11.995V10.005C19.1375 9.65417 18.1075 9.415 17.6275 8.25667C17.1508 7.10667 17.675 6.26083 18.185 5.22083L16.7792 3.81583C15.8483 4.27167 14.9283 4.86333 13.7442 4.3725C12.5992 3.89667 12.3642 2.9275 11.9942 1.83333H10.0058C9.6525 2.85917 9.41917 3.89 8.25667 4.37167C7.9525 4.49917 7.65833 4.56 7.35917 4.56C6.65667 4.56 6.07667 4.23333 5.22083 3.81583L3.815 5.22083C4.29333 6.2 4.8575 7.085 4.3725 8.25667C3.89667 9.4025 2.9275 9.635 1.83333 10.005V11.995C2.855 12.3433 3.89 12.5825 4.3725 13.7433C4.85667 14.9125 4.31 15.77 3.815 16.7792L5.22083 18.185C6.42917 17.5808 7.18333 17.1817 8.25583 17.6275C9.40417 18.1042 9.635 19.0758 10.0058 20.1667ZM12.5842 21H9.415C8.8475 19.4017 8.76083 18.7392 7.9375 18.3975C7.1 18.0483 6.495 18.5075 5.04917 19.1908L2.80833 16.95C3.53583 15.4192 3.9475 14.8958 3.6025 14.0625C3.25917 13.2367 2.60917 13.1567 1 12.585V9.415C2.58833 8.85 3.26 8.76333 3.6025 7.9375C3.945 7.11167 3.54333 6.59333 2.80833 5.04917L5.04917 2.80917C6.5 3.49917 7.10417 3.94667 7.93667 3.60333C8.76333 3.26 8.83833 2.61583 9.41583 1H12.5842C13.1525 2.59833 13.2408 3.26167 14.0625 3.6025C14.8967 3.94917 15.4867 3.50333 16.9517 2.80917L19.1908 5.04917C18.4592 6.58833 18.0567 7.11333 18.3975 7.93667C18.74 8.76333 19.3908 8.8425 21 9.415V12.5858C19.4117 13.15 18.7392 13.2375 18.3967 14.0633C18.0608 14.8758 18.4333 15.3642 19.1917 16.95L16.9517 19.1908C15.5117 18.5075 14.8958 18.0492 14.0717 18.395C13.2483 18.7367 13.1717 19.35 12.5842 21Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.4"
    />
  </svg>
);

export const LargeDollarIcon = () => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49992 1V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.49992 17V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 12.0067V12.0067C1.5 13.664 2.84267 15.0067 4.5 15.0067H6.69067C8.24133 15.0067 9.5 13.7493 9.5 12.1973V12.1973C9.5 10.9093 8.624 9.78667 7.37467 9.47333L3.62533 8.53333C2.376 8.22 1.5 7.09733 1.5 5.80933V5.80933C1.5 4.25733 2.75733 3 4.30933 3H6.5C8.15733 3 9.5 4.34267 9.5 6V6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const USAflag = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8017 2.75879H1.19828C0.536469 2.75879 0 3.29526 0 3.95707V12.0433C0 12.7051 0.536469 13.2416 1.19828 13.2416H14.8017C15.4635 13.2416 16 12.7051 16 12.0433V3.95707C16 3.29526 15.4635 2.75879 14.8017 2.75879Z"
      fill="#F5F5F5"
    />
    <path
      d="M0.065918 3.56516H15.9341C15.7717 3.09588 15.3262 2.75879 14.8017 2.75879H1.19829C0.673793 2.75879 0.228324 3.09588 0.065918 3.56516Z"
      fill="#FF4B55"
    />
    <path d="M16 5.98438H0V6.79072H16V5.98438Z" fill="#FF4B55" />
    <path d="M16 4.37109H0V5.17744H16V4.37109Z" fill="#FF4B55" />
    <path
      d="M0 8.12718C0 8.27952 0.123531 8.40305 0.275875 8.40305H16V7.59668H0V8.12718Z"
      fill="#FF4B55"
    />
    <path d="M16 10.8223H0V11.6286H16V10.8223Z" fill="#FF4B55" />
    <path
      d="M15.9341 12.4355H0.065918C0.228324 12.9048 0.673824 13.2419 1.19829 13.2419H14.8017C15.3262 13.2419 15.7717 12.9048 15.9341 12.4355Z"
      fill="#FF4B55"
    />
    <path d="M16 9.20996H0V10.0163H16V9.20996Z" fill="#FF4B55" />
    <path
      d="M0.275875 8.40338H7.17244C7.32478 8.40338 7.44831 8.27985 7.44831 8.12751V3.03466C7.44831 2.88229 7.32478 2.75879 7.17244 2.75879H1.19828C0.536469 2.75882 0 3.29529 0 3.9571V8.12751C0 8.27988 0.123531 8.40338 0.275875 8.40338Z"
      fill="#41479B"
    />
    <path
      d="M0.774696 3.39181L0.835758 3.57493L1.02879 3.5764C1.05379 3.57662 1.06413 3.6085 1.04404 3.62334L0.888758 3.738L0.947008 3.92203C0.954571 3.94584 0.927415 3.96559 0.907071 3.95103L0.75004 3.83881L0.593008 3.95106C0.572665 3.96562 0.545571 3.94587 0.553071 3.92206L0.611321 3.73803L0.45604 3.62337C0.435946 3.6085 0.44629 3.57662 0.47129 3.57643L0.664321 3.57496L0.725383 3.39184C0.733258 3.36809 0.766758 3.36809 0.774696 3.39181Z"
      fill="#F5F5F5"
    />
    <path
      d="M0.774696 4.34979L0.835758 4.53292L1.02879 4.53439C1.05379 4.53461 1.06413 4.56645 1.04404 4.58132L0.888758 4.69601L0.947008 4.88004C0.954571 4.90386 0.927415 4.92361 0.907071 4.90904L0.75004 4.79682L0.593008 4.90907C0.572665 4.92361 0.545571 4.90389 0.553071 4.88007L0.611321 4.69604L0.45604 4.58136C0.435946 4.56648 0.44629 4.53464 0.47129 4.53442L0.664321 4.53295L0.725383 4.34982C0.733258 4.32611 0.766758 4.32611 0.774696 4.34979Z"
      fill="#F5F5F5"
    />
    <path
      d="M0.774696 5.30782L0.835758 5.49095L1.02879 5.49242C1.05379 5.49264 1.06413 5.52448 1.04404 5.53936L0.888758 5.65404L0.947008 5.83807C0.954571 5.86189 0.927415 5.88164 0.907071 5.86707L0.75004 5.75486L0.593008 5.86711C0.572665 5.88164 0.545571 5.86195 0.553071 5.83811L0.611321 5.65407L0.45604 5.53939C0.435946 5.52451 0.44629 5.49267 0.47129 5.49245L0.664321 5.49098L0.725383 5.30786C0.733258 5.28411 0.766758 5.28411 0.774696 5.30782Z"
      fill="#F5F5F5"
    />
    <path
      d="M0.774696 6.26583L0.835758 6.44896L1.02879 6.45043C1.05379 6.45064 1.06413 6.48252 1.04404 6.49736L0.888758 6.61205L0.947008 6.79608C0.954571 6.81989 0.927415 6.83964 0.907071 6.82508L0.75004 6.71286L0.593008 6.82511C0.572665 6.83964 0.545571 6.81993 0.553071 6.79611L0.611321 6.61208L0.45604 6.49739C0.435946 6.48258 0.44629 6.45068 0.47129 6.45046L0.664321 6.44899L0.725383 6.26586C0.733258 6.24211 0.766758 6.24211 0.774696 6.26583Z"
      fill="#F5F5F5"
    />
    <path
      d="M0.774696 7.22382L0.835758 7.40694L1.02879 7.40841C1.05379 7.40863 1.06413 7.44047 1.04404 7.45535L0.888758 7.57004L0.947008 7.75407C0.954571 7.77788 0.927415 7.79763 0.907071 7.78307L0.75004 7.67085L0.593008 7.7831C0.572665 7.79763 0.545571 7.77791 0.553071 7.7541L0.611321 7.57007L0.45604 7.45538C0.435946 7.4405 0.44629 7.40866 0.47129 7.40844L0.664321 7.40697L0.725383 7.22385C0.733258 7.20013 0.766758 7.20013 0.774696 7.22382Z"
      fill="#F5F5F5"
    />
    <path
      d="M1.51823 3.86152L1.57929 4.04464L1.77232 4.04611C1.79732 4.04633 1.80766 4.0782 1.78757 4.09305L1.63229 4.20773L1.69054 4.39177C1.6981 4.41558 1.67094 4.43533 1.6506 4.42077L1.49357 4.30852L1.33654 4.42077C1.31619 4.4353 1.2891 4.41558 1.2966 4.39177L1.35485 4.20773L1.19957 4.09305C1.17948 4.07817 1.18982 4.04633 1.21482 4.04611L1.40785 4.04464L1.46891 3.86152C1.47679 3.83783 1.51032 3.83783 1.51823 3.86152Z"
      fill="#F5F5F5"
    />
    <path
      d="M1.51823 4.81955L1.57929 5.00267L1.77232 5.00414C1.79732 5.00436 1.80766 5.03623 1.78757 5.05108L1.63229 5.16577L1.69054 5.3498C1.6981 5.37361 1.67094 5.39336 1.6506 5.3788L1.49357 5.26655L1.33654 5.3788C1.31619 5.39333 1.2891 5.37364 1.2966 5.3498L1.35485 5.16577L1.19957 5.05108C1.17948 5.03627 1.18982 5.00436 1.21482 5.00414L1.40785 5.00267L1.46891 4.81955C1.47679 4.79583 1.51032 4.79583 1.51823 4.81955Z"
      fill="#F5F5F5"
    />
    <path
      d="M1.51823 5.77755L1.57929 5.96068L1.77232 5.96215C1.79732 5.96237 1.80766 5.99421 1.78757 6.00909L1.63229 6.12377L1.69054 6.3078C1.6981 6.33162 1.67094 6.35137 1.6506 6.3368L1.49357 6.22455L1.33654 6.3368C1.31619 6.35134 1.2891 6.33162 1.2966 6.3078L1.35485 6.12377L1.19957 6.00909C1.17948 5.99421 1.18982 5.96237 1.21482 5.96215L1.40785 5.96068L1.46891 5.77755C1.47679 5.75384 1.51032 5.75384 1.51823 5.77755Z"
      fill="#F5F5F5"
    />
    <path
      d="M1.51823 6.73554L1.57929 6.91866L1.77232 6.92013C1.79732 6.92035 1.80766 6.9522 1.78757 6.96707L1.63229 7.08176L1.69054 7.26579C1.6981 7.2896 1.67094 7.30935 1.6506 7.29479L1.49357 7.18254L1.33654 7.29479C1.31619 7.30935 1.2891 7.2896 1.2966 7.26579L1.35485 7.08176L1.19957 6.96707C1.17948 6.9522 1.18982 6.92035 1.21482 6.92013L1.40785 6.91866L1.46891 6.73554C1.47679 6.71185 1.51032 6.71185 1.51823 6.73554Z"
      fill="#F5F5F5"
    />
    <path
      d="M2.26176 3.39181L2.32282 3.57494L2.51585 3.57641C2.54085 3.57662 2.55119 3.6085 2.5311 3.62334L2.37582 3.738L2.43407 3.92203C2.44163 3.94584 2.41448 3.96559 2.39413 3.95103L2.2371 3.83878L2.08007 3.95103C2.05972 3.96559 2.03263 3.94584 2.04013 3.92203L2.09838 3.738L1.9431 3.62334C1.92301 3.60847 1.93335 3.57659 1.95835 3.57641L2.15138 3.57494L2.21244 3.39181C2.22032 3.36809 2.25385 3.36809 2.26176 3.39181Z"
      fill="#F5F5F5"
    />
    <path
      d="M2.26176 4.3498L2.32282 4.53292L2.51585 4.53439C2.54085 4.53461 2.55119 4.56645 2.5311 4.58133L2.37582 4.69602L2.43407 4.88005C2.44163 4.90386 2.41448 4.92361 2.39413 4.90905L2.2371 4.7968L2.08007 4.90905C2.05972 4.92358 2.03263 4.90386 2.04013 4.88005L2.09838 4.69602L1.9431 4.58133C1.92301 4.56645 1.93335 4.53461 1.95835 4.53439L2.15138 4.53292L2.21244 4.3498C2.22032 4.32611 2.25385 4.32611 2.26176 4.3498Z"
      fill="#F5F5F5"
    />
    <path
      d="M2.26176 5.30783L2.32282 5.49095L2.51585 5.49242C2.54085 5.49264 2.55119 5.52448 2.5311 5.53936L2.37582 5.65405L2.43407 5.83808C2.44163 5.86189 2.41448 5.88164 2.39413 5.86708L2.2371 5.75483L2.08007 5.86708C2.05972 5.88161 2.03263 5.86192 2.04013 5.83808L2.09838 5.65405L1.9431 5.53936C1.92301 5.52448 1.93335 5.49264 1.95835 5.49242L2.15138 5.49095L2.21244 5.30783C2.22032 5.28411 2.25385 5.28411 2.26176 5.30783Z"
      fill="#F5F5F5"
    />
    <path
      d="M2.26176 6.26584L2.32282 6.44896L2.51585 6.45043C2.54085 6.45065 2.55119 6.48252 2.5311 6.49737L2.37582 6.61205L2.43407 6.79609C2.44163 6.8199 2.41448 6.83965 2.39413 6.82509L2.2371 6.71284L2.08007 6.82509C2.05972 6.83962 2.03263 6.8199 2.04013 6.79609L2.09838 6.61205L1.9431 6.49737C1.92301 6.48255 1.93335 6.45065 1.95835 6.45043L2.15138 6.44896L2.21244 6.26584C2.22032 6.24212 2.25385 6.24212 2.26176 6.26584Z"
      fill="#F5F5F5"
    />
    <path
      d="M2.26176 7.22382L2.32282 7.40695L2.51585 7.40841C2.54085 7.40863 2.55119 7.44048 2.5311 7.45535L2.37582 7.57004L2.43407 7.75407C2.44163 7.77788 2.41448 7.79763 2.39413 7.78307L2.2371 7.67082L2.08007 7.78307C2.05972 7.7976 2.03263 7.77788 2.04013 7.75407L2.09838 7.57004L1.9431 7.45535C1.92301 7.44048 1.93335 7.40863 1.95835 7.40841L2.15138 7.40695L2.21244 7.22382C2.22032 7.20013 2.25385 7.20013 2.26176 7.22382Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.00529 3.86152L3.06635 4.04464L3.25938 4.04611C3.28438 4.04633 3.29472 4.0782 3.27463 4.09305L3.11935 4.20773L3.1776 4.39177C3.18516 4.41558 3.15801 4.43533 3.13766 4.42077L2.98063 4.30852L2.8236 4.42077C2.80326 4.4353 2.77616 4.41558 2.78366 4.39177L2.84191 4.20773L2.68663 4.09305C2.66654 4.07817 2.67688 4.04633 2.70188 4.04611L2.89491 4.04464L2.95597 3.86152C2.96382 3.83783 2.99738 3.83783 3.00529 3.86152Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.00529 4.81955L3.06635 5.00267L3.25938 5.00414C3.28438 5.00436 3.29472 5.03623 3.27463 5.05108L3.11935 5.16577L3.1776 5.3498C3.18516 5.37361 3.15801 5.39336 3.13766 5.3788L2.98063 5.26655L2.8236 5.3788C2.80326 5.39333 2.77616 5.37364 2.78366 5.3498L2.84191 5.16577L2.68663 5.05108C2.66654 5.03627 2.67688 5.00436 2.70188 5.00414L2.89491 5.00267L2.95597 4.81955C2.96382 4.79583 2.99738 4.79583 3.00529 4.81955Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.00529 5.77755L3.06635 5.96068L3.25938 5.96215C3.28438 5.96237 3.29472 5.99421 3.27463 6.00909L3.11935 6.12377L3.1776 6.3078C3.18516 6.33162 3.15801 6.35137 3.13766 6.3368L2.98063 6.22455L2.8236 6.3368C2.80326 6.35134 2.77616 6.33162 2.78366 6.3078L2.84191 6.12377L2.68663 6.00909C2.66654 5.99421 2.67688 5.96237 2.70188 5.96215L2.89491 5.96068L2.95597 5.77755C2.96382 5.75384 2.99738 5.75384 3.00529 5.77755Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.00529 6.73554L3.06635 6.91866L3.25938 6.92013C3.28438 6.92035 3.29472 6.9522 3.27463 6.96707L3.11935 7.08176L3.1776 7.26579C3.18516 7.2896 3.15801 7.30935 3.13766 7.29479L2.98063 7.18254L2.8236 7.29479C2.80326 7.30935 2.77616 7.2896 2.78366 7.26579L2.84191 7.08176L2.68663 6.96707C2.66654 6.9522 2.67688 6.92035 2.70188 6.92013L2.89491 6.91866L2.95597 6.73554C2.96382 6.71185 2.99738 6.71185 3.00529 6.73554Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.74885 3.39181L3.80991 3.57493L4.00294 3.5764C4.02794 3.57662 4.03829 3.6085 4.01819 3.62334L3.86291 3.738L3.92116 3.92203C3.92872 3.94584 3.90157 3.96559 3.88122 3.95103L3.72416 3.83881L3.56713 3.95106C3.54679 3.96562 3.51969 3.94587 3.52719 3.92206L3.58544 3.73803L3.43016 3.62337C3.41007 3.6085 3.42041 3.57662 3.44541 3.57643L3.63844 3.57496L3.6995 3.39184C3.70741 3.36809 3.74094 3.36809 3.74885 3.39181Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.74885 4.3498L3.80991 4.53292L4.00294 4.53439C4.02794 4.53461 4.03829 4.56645 4.01819 4.58133L3.86291 4.69602L3.92116 4.88005C3.92872 4.90386 3.90157 4.92361 3.88122 4.90905L3.72416 4.7968L3.56713 4.90905C3.54679 4.92358 3.51969 4.90386 3.52719 4.88005L3.58544 4.69602L3.43016 4.58133C3.41007 4.56645 3.42041 4.53461 3.44541 4.53439L3.63844 4.53292L3.6995 4.3498C3.70741 4.32611 3.74094 4.32611 3.74885 4.3498Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.74885 5.30783L3.80991 5.49096L4.00294 5.49243C4.02794 5.49264 4.03829 5.52449 4.01819 5.53936L3.86291 5.65405L3.92116 5.83808C3.92872 5.86189 3.90157 5.88164 3.88122 5.86708L3.72416 5.7548L3.56713 5.86705C3.54679 5.88158 3.51969 5.86186 3.52719 5.83805L3.58544 5.65402L3.43016 5.53933C3.41007 5.52446 3.42041 5.49261 3.44541 5.49239L3.63844 5.49093L3.6995 5.3078C3.70741 5.28411 3.74094 5.28411 3.74885 5.30783Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.74885 6.26584L3.80991 6.44896L4.00294 6.45043C4.02794 6.45065 4.03829 6.48252 4.01819 6.49737L3.86291 6.61205L3.92116 6.79609C3.92872 6.8199 3.90157 6.83965 3.88122 6.82509L3.72416 6.71284L3.56713 6.82509C3.54679 6.83962 3.51969 6.8199 3.52719 6.79609L3.58544 6.61205L3.43016 6.49737C3.41007 6.48255 3.42041 6.45065 3.44541 6.45043L3.63844 6.44896L3.6995 6.26584C3.70741 6.24212 3.74094 6.24212 3.74885 6.26584Z"
      fill="#F5F5F5"
    />
    <path
      d="M3.74885 7.22382L3.80991 7.40695L4.00294 7.40841C4.02794 7.40863 4.03829 7.44048 4.01819 7.45535L3.86291 7.57004L3.92116 7.75407C3.92872 7.77788 3.90157 7.79763 3.88122 7.78307L3.72416 7.67082L3.56713 7.78307C3.54679 7.7976 3.51969 7.77788 3.52719 7.75407L3.58544 7.57004L3.43016 7.45535C3.41007 7.44048 3.42041 7.40863 3.44541 7.40841L3.63844 7.40695L3.6995 7.22382C3.70741 7.20013 3.74094 7.20013 3.74885 7.22382Z"
      fill="#F5F5F5"
    />
    <path
      d="M4.49235 3.86152L4.55341 4.04464L4.74644 4.04611C4.77144 4.04633 4.78178 4.0782 4.76169 4.09305L4.60641 4.20773L4.66466 4.39177C4.67222 4.41558 4.64507 4.43533 4.62472 4.42077L4.46769 4.30852L4.31066 4.42077C4.29032 4.4353 4.26322 4.41558 4.27072 4.39177L4.32897 4.20773L4.17369 4.09305C4.1536 4.07817 4.16394 4.04633 4.18894 4.04611L4.38197 4.04464L4.44303 3.86152C4.45094 3.83783 4.48444 3.83783 4.49235 3.86152Z"
      fill="#F5F5F5"
    />
    <path
      d="M4.49235 4.81955L4.55341 5.00267L4.74644 5.00414C4.77144 5.00436 4.78178 5.03623 4.76169 5.05108L4.60641 5.16577L4.66466 5.3498C4.67222 5.37361 4.64507 5.39336 4.62472 5.3788L4.46769 5.26655L4.31066 5.3788C4.29032 5.39333 4.26322 5.37364 4.27072 5.3498L4.32897 5.16577L4.17369 5.05108C4.1536 5.03627 4.16394 5.00436 4.18894 5.00414L4.38197 5.00267L4.44303 4.81955C4.45094 4.79583 4.48444 4.79583 4.49235 4.81955Z"
      fill="#F5F5F5"
    />
    <path
      d="M4.49235 5.77755L4.55341 5.96068L4.74644 5.96215C4.77144 5.96237 4.78178 5.99421 4.76169 6.00909L4.60641 6.12377L4.66466 6.3078C4.67222 6.33162 4.64507 6.35137 4.62472 6.3368L4.46769 6.22455L4.31066 6.3368C4.29032 6.35134 4.26322 6.33162 4.27072 6.3078L4.32897 6.12377L4.17369 6.00909C4.1536 5.99421 4.16394 5.96237 4.18894 5.96215L4.38197 5.96068L4.44303 5.77755C4.45094 5.75384 4.48444 5.75384 4.49235 5.77755Z"
      fill="#F5F5F5"
    />
    <path
      d="M4.49235 6.73554L4.55341 6.91866L4.74644 6.92013C4.77144 6.92035 4.78178 6.9522 4.76169 6.96707L4.60641 7.08176L4.66466 7.26579C4.67222 7.2896 4.64507 7.30935 4.62472 7.29479L4.46769 7.18254L4.31066 7.29479C4.29032 7.30935 4.26322 7.2896 4.27072 7.26579L4.32897 7.08176L4.17369 6.96707C4.1536 6.9522 4.16394 6.92035 4.18894 6.92013L4.38197 6.91866L4.44303 6.73554C4.45094 6.71185 4.48444 6.71185 4.49235 6.73554Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.236 3.39181L5.29706 3.57494L5.49009 3.57641C5.51509 3.57662 5.52544 3.6085 5.50534 3.62334L5.35006 3.738L5.40831 3.92203C5.41587 3.94584 5.38872 3.96559 5.36837 3.95103L5.21134 3.83878L5.05431 3.95103C5.03397 3.96559 5.00687 3.94584 5.01437 3.92203L5.07262 3.738L4.91734 3.62334C4.89725 3.60847 4.90759 3.57659 4.93259 3.57641L5.12562 3.57494L5.18669 3.39181C5.19453 3.36809 5.22809 3.36809 5.236 3.39181Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.236 4.3498L5.29706 4.53292L5.49009 4.53439C5.51509 4.53461 5.52544 4.56645 5.50534 4.58133L5.35006 4.69602L5.40831 4.88005C5.41587 4.90386 5.38872 4.92361 5.36837 4.90905L5.21134 4.7968L5.05431 4.90905C5.03397 4.92358 5.00687 4.90386 5.01437 4.88005L5.07262 4.69602L4.91734 4.58133C4.89725 4.56645 4.90759 4.53461 4.93259 4.53439L5.12562 4.53292L5.18669 4.3498C5.19453 4.32611 5.22809 4.32611 5.236 4.3498Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.236 5.30783L5.29706 5.49095L5.49009 5.49242C5.51509 5.49264 5.52544 5.52448 5.50534 5.53936L5.35006 5.65405L5.40831 5.83808C5.41587 5.86189 5.38872 5.88164 5.36837 5.86708L5.21134 5.75483L5.05431 5.86708C5.03397 5.88161 5.00687 5.86192 5.01437 5.83808L5.07262 5.65405L4.91734 5.53936C4.89725 5.52448 4.90759 5.49264 4.93259 5.49242L5.12562 5.49095L5.18669 5.30783C5.19453 5.28411 5.22809 5.28411 5.236 5.30783Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.236 6.26584L5.29706 6.44896L5.49009 6.45043C5.51509 6.45065 5.52544 6.48252 5.50534 6.49737L5.35006 6.61205L5.40831 6.79609C5.41587 6.8199 5.38872 6.83965 5.36837 6.82509L5.21134 6.71284L5.05431 6.82509C5.03397 6.83962 5.00687 6.8199 5.01437 6.79609L5.07262 6.61205L4.91734 6.49737C4.89725 6.48255 4.90759 6.45065 4.93259 6.45043L5.12562 6.44896L5.18669 6.26584C5.19453 6.24212 5.22809 6.24212 5.236 6.26584Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.236 7.22382L5.29706 7.40695L5.49009 7.40841C5.51509 7.40863 5.52544 7.44048 5.50534 7.45535L5.35006 7.57004L5.40831 7.75407C5.41587 7.77788 5.38872 7.79763 5.36837 7.78307L5.21134 7.67082L5.05431 7.78307C5.03397 7.7976 5.00687 7.77788 5.01437 7.75407L5.07262 7.57004L4.91734 7.45535C4.89725 7.44048 4.90759 7.40863 4.93259 7.40841L5.12562 7.40695L5.18669 7.22382C5.19453 7.20013 5.22809 7.20013 5.236 7.22382Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.97953 3.86152L6.04059 4.04464L6.23362 4.04611C6.25862 4.04633 6.26897 4.0782 6.24887 4.09305L6.09359 4.20773L6.15184 4.39177C6.1594 4.41558 6.13225 4.43533 6.1119 4.42077L5.95487 4.30852L5.79784 4.42077C5.7775 4.4353 5.7504 4.41558 5.7579 4.39177L5.81615 4.20773L5.66087 4.09305C5.64078 4.07817 5.65112 4.04633 5.67612 4.04611L5.86915 4.04464L5.93022 3.86152C5.93809 3.83783 5.97162 3.83783 5.97953 3.86152Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.97953 4.81955L6.04059 5.00267L6.23362 5.00414C6.25862 5.00436 6.26897 5.03623 6.24887 5.05108L6.09359 5.16577L6.15184 5.3498C6.1594 5.37361 6.13225 5.39336 6.1119 5.3788L5.95487 5.26655L5.79784 5.3788C5.7775 5.39333 5.7504 5.37364 5.7579 5.3498L5.81615 5.16577L5.66087 5.05108C5.64078 5.03627 5.65112 5.00436 5.67612 5.00414L5.86915 5.00267L5.93022 4.81955C5.93809 4.79583 5.97162 4.79583 5.97953 4.81955Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.97953 5.77755L6.04059 5.96068L6.23362 5.96215C6.25862 5.96237 6.26897 5.99421 6.24887 6.00909L6.09359 6.12377L6.15184 6.3078C6.1594 6.33162 6.13225 6.35137 6.1119 6.3368L5.95487 6.22455L5.79784 6.3368C5.7775 6.35134 5.7504 6.33162 5.7579 6.3078L5.81615 6.12377L5.66087 6.00909C5.64078 5.99421 5.65112 5.96237 5.67612 5.96215L5.86915 5.96068L5.93022 5.77755C5.93809 5.75384 5.97162 5.75384 5.97953 5.77755Z"
      fill="#F5F5F5"
    />
    <path
      d="M5.97953 6.73554L6.04059 6.91866L6.23362 6.92013C6.25862 6.92035 6.26897 6.9522 6.24887 6.96707L6.09359 7.08176L6.15184 7.26579C6.1594 7.2896 6.13225 7.30935 6.1119 7.29479L5.95487 7.18254L5.79784 7.29479C5.7775 7.30935 5.7504 7.2896 5.7579 7.26579L5.81615 7.08176L5.66087 6.96707C5.64078 6.9522 5.65112 6.92035 5.67612 6.92013L5.86915 6.91866L5.93022 6.73554C5.93809 6.71185 5.97162 6.71185 5.97953 6.73554Z"
      fill="#F5F5F5"
    />
    <path
      d="M6.72306 3.39181L6.78412 3.57494L6.97715 3.57641C7.00215 3.57662 7.0125 3.6085 6.9924 3.62334L6.83712 3.738L6.89537 3.92203C6.90293 3.94584 6.87578 3.96559 6.85543 3.95103L6.6984 3.83878L6.54137 3.95103C6.52103 3.96559 6.49394 3.94584 6.50144 3.92203L6.55969 3.738L6.4044 3.62334C6.38431 3.60847 6.39465 3.57659 6.41965 3.57641L6.61269 3.57494L6.67375 3.39181C6.68162 3.36809 6.71512 3.36809 6.72306 3.39181Z"
      fill="#F5F5F5"
    />
    <path
      d="M6.72306 4.3498L6.78412 4.53292L6.97715 4.53439C7.00215 4.53461 7.0125 4.56645 6.9924 4.58133L6.83712 4.69602L6.89537 4.88005C6.90293 4.90386 6.87578 4.92361 6.85543 4.90905L6.6984 4.7968L6.54137 4.90905C6.52103 4.92358 6.49394 4.90386 6.50144 4.88005L6.55969 4.69602L6.4044 4.58133C6.38431 4.56645 6.39465 4.53461 6.41965 4.53439L6.61269 4.53292L6.67375 4.3498C6.68162 4.32611 6.71512 4.32611 6.72306 4.3498Z"
      fill="#F5F5F5"
    />
    <path
      d="M6.72306 5.30783L6.78412 5.49095L6.97715 5.49242C7.00215 5.49264 7.0125 5.52448 6.9924 5.53936L6.83712 5.65405L6.89537 5.83808C6.90293 5.86189 6.87578 5.88164 6.85543 5.86708L6.6984 5.75483L6.54137 5.86708C6.52103 5.88161 6.49394 5.86192 6.50144 5.83808L6.55969 5.65405L6.4044 5.53936C6.38431 5.52448 6.39465 5.49264 6.41965 5.49242L6.61269 5.49095L6.67375 5.30783C6.68162 5.28411 6.71512 5.28411 6.72306 5.30783Z"
      fill="#F5F5F5"
    />
    <path
      d="M6.72306 6.26584L6.78412 6.44896L6.97715 6.45043C7.00215 6.45065 7.0125 6.48252 6.9924 6.49737L6.83712 6.61205L6.89537 6.79609C6.90293 6.8199 6.87578 6.83965 6.85543 6.82509L6.6984 6.71284L6.54137 6.82509C6.52103 6.83962 6.49394 6.8199 6.50144 6.79609L6.55969 6.61205L6.4044 6.49737C6.38431 6.48255 6.39465 6.45065 6.41965 6.45043L6.61269 6.44896L6.67375 6.26584C6.68162 6.24212 6.71512 6.24212 6.72306 6.26584Z"
      fill="#F5F5F5"
    />
    <path
      d="M6.72306 7.22382L6.78412 7.40695L6.97715 7.40841C7.00215 7.40863 7.0125 7.44048 6.9924 7.45535L6.83712 7.57004L6.89537 7.75407C6.90293 7.77788 6.87578 7.79763 6.85543 7.78307L6.6984 7.67082L6.54137 7.78307C6.52103 7.7976 6.49394 7.77788 6.50144 7.75407L6.55969 7.57004L6.4044 7.45535C6.38431 7.44048 6.39465 7.40863 6.41965 7.40841L6.61269 7.40695L6.67375 7.22382C6.68162 7.20013 6.71512 7.20013 6.72306 7.22382Z"
      fill="#F5F5F5"
    />
  </svg>
);

export const BankSetupIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08337 6.41699H2.91671V10.5003H4.08337V6.41699ZM7.58337 6.41699H6.41671V10.5003H7.58337V6.41699ZM12.5417 11.667H1.45837V12.8337H12.5417V11.667ZM11.0834 6.41699H9.91671V10.5003H11.0834V6.41699ZM7.00004 2.48533L10.0392 4.08366H3.96087L7.00004 2.48533ZM7.00004 1.16699L1.45837 4.08366V5.25033H12.5417V4.08366L7.00004 1.16699Z"
      fill="currentColor"
    />
  </svg>
);

export const LinedTickIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2634_6395)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.56581 2.56617C3.70014 1.43186 5.26845 0.729492 6.99996 0.729492C8.73147 0.729492 10.2998 1.43186 11.4341 2.56617L11.1247 2.87553L11.4341 2.56618C12.5684 3.70051 13.2708 5.26882 13.2708 7.00033C13.2708 8.73184 12.5684 10.3001 11.4341 11.4345C10.2998 12.5688 8.73147 13.2712 6.99996 13.2712C5.26845 13.2712 3.70014 12.5688 2.56581 11.4345L2.87517 11.1251L2.56581 11.4345C1.43149 10.3001 0.729126 8.73183 0.729126 7.00033C0.729126 5.26882 1.43149 3.70051 2.56581 2.56618L2.56581 2.56617ZM6.99996 1.60449C5.50983 1.60449 4.16147 2.20796 3.18452 3.1849C2.20759 4.16185 1.60413 5.5102 1.60413 7.00033C1.60413 8.49045 2.2076 9.83881 3.18453 10.8157C4.16148 11.7927 5.50984 12.3962 6.99996 12.3962C8.49008 12.3962 9.83844 11.7927 10.8154 10.8157C11.7923 9.83881 12.3958 8.49045 12.3958 7.00033C12.3958 5.5102 11.7923 4.16184 10.8154 3.18489C9.83844 2.20796 8.49008 1.60449 6.99996 1.60449Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.226 4.94064C10.3968 5.1115 10.3968 5.3885 10.226 5.55936L6.72599 9.05936C6.55513 9.23021 6.27812 9.23021 6.10727 9.05936L4.35727 7.30936C4.18641 7.1385 4.18641 6.8615 4.35727 6.69064C4.52812 6.51979 4.80513 6.51979 4.97599 6.69064L6.41663 8.13128L9.60727 4.94064C9.77812 4.76979 10.0551 4.76979 10.226 4.94064Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2634_6395">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MoreVerticalIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16C13.1046 16 14 16.8954 14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6Z"
      fill="currentColor"
    />
  </svg>
);

export const DownArrowIcon = () => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.827417 0.163933C1.02222 -0.0347738 1.32705 -0.0528383 1.54185 0.10974L1.60339 0.163933L6.00004 4.64894L10.3967 0.163933C10.5915 -0.0347738 10.8963 -0.0528383 11.1111 0.10974L11.1727 0.163933C11.3675 0.362639 11.3852 0.673582 11.2258 0.892695L11.1727 0.95547L6.38803 5.83607C6.19323 6.03477 5.8884 6.05284 5.67359 5.89026L5.61205 5.83607L0.827417 0.95547C0.613138 0.736893 0.613138 0.38251 0.827417 0.163933Z"
      fill="#606266"
    />
  </svg>
);
export const DelinquentInfoIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.535678 10.8323C0.149714 11.4989 0.630771 12.3333 1.4011 12.3333H12.5989C13.3692 12.3333 13.8503 11.4989 13.4643 10.8323L7.86542 1.16145C7.48025 0.49617 6.51973 0.496168 6.13456 1.16145L0.535678 10.8323ZM7.66666 9.66663C7.66666 10.0348 7.36818 10.3333 6.99999 10.3333C6.6318 10.3333 6.33332 10.0348 6.33332 9.66663C6.33332 9.29844 6.6318 8.99996 6.99999 8.99996C7.36818 8.99996 7.66666 9.29844 7.66666 9.66663ZM7.66666 6.99996C7.66666 7.36815 7.36818 7.66663 6.99999 7.66663C6.6318 7.66663 6.33332 7.36815 6.33332 6.99996V5.66663C6.33332 5.29844 6.6318 4.99996 6.99999 4.99996C7.36818 4.99996 7.66666 5.29844 7.66666 5.66663V6.99996Z"
      fill="#E49900"
    />
  </svg>
);

export const SubmittedIcon = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={isActive ? "#CDDEE1" : "#EBEEF1"} />
      <path
        d="M14.0834 10.5834H10.5834V14.0834H9.41669V10.5834H5.91669V9.41669H9.41669V5.91669H10.5834V9.41669H14.0834V10.5834Z"
        fill={isActive ? "#387C88" : "#7E8085"}
      />
    </svg>
  );
};

export const QuedIcon = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={isActive ? "#CDDEE1" : "#EBEEF1"} />
      <path
        d="M9.99419 4.16669C6.77419 4.16669 4.16669 6.78002 4.16669 10C4.16669 13.22 6.77419 15.8334 9.99419 15.8334C13.22 15.8334 15.8334 13.22 15.8334 10C15.8334 6.78002 13.22 4.16669 9.99419 4.16669ZM10 14.6667C7.42169 14.6667 5.33335 12.5784 5.33335 10C5.33335 7.42169 7.42169 5.33335 10 5.33335C12.5784 5.33335 14.6667 7.42169 14.6667 10C14.6667 12.5784 12.5784 14.6667 10 14.6667ZM10.2917 7.08335H9.41669V10.5834L12.4792 12.4209L12.9167 11.7034L10.2917 10.1459V7.08335Z"
        fill={isActive ? "#387C88" : "#7E8085"}
      />
    </svg>
  );
};

export const MaintenanceSceduledIcon = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={isActive ? "#CDDEE1" : "#EBEEF1"} />
      <g clipPath="url(#clip0_154_11893)">
        <path
          d="M16.2159 14.0773L10.9192 8.78059C11.4617 7.41559 11.1817 5.80559 10.0792 4.69726C8.73754 3.35559 6.64921 3.23309 5.16171 4.31809L7.40171 6.56393L6.57338 7.38643L4.33921 5.15226C3.25421 6.63393 3.37671 8.72809 4.71838 10.0639C5.80338 11.1489 7.38421 11.4348 8.73754 10.9273L14.0517 16.2414C14.2792 16.4689 14.6467 16.4689 14.8742 16.2414L16.2159 14.8998C16.4492 14.6781 16.4492 14.3106 16.2159 14.0773ZM14.4659 15.0106L8.94754 9.49226C8.59171 9.75476 8.19504 9.91226 7.78088 9.97059C6.98754 10.0873 6.15338 9.84809 5.54671 9.24143C4.99254 8.69309 4.73588 7.95809 4.77671 7.23476L6.57921 9.03726L9.05254 6.56393L7.25004 4.76143C7.97338 4.72059 8.70254 4.97726 9.25671 5.52559C9.88671 6.15559 10.1259 7.02476 9.98004 7.83559C9.91004 8.24976 9.73504 8.63476 9.46671 8.97893L14.9792 14.4914L14.4659 15.0106Z"
          fill={isActive ? "#387C88" : "#7E8085"}
        />
      </g>
      <defs>
        <clipPath id="clip0_154_11893">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RequestCOmpletedIcon = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={isActive ? "#CDDEE1" : "#EBEEF1"} />
      <path
        d="M8.1304 12.2604L5.6979 9.82791L4.86957 10.6504L8.1304 13.9112L15.1304 6.91125L14.3079 6.08875L8.1304 12.2604Z"
        fill={isActive ? "#387C88" : "#7E8085"}
      />
    </svg>
  );
};

export const PaymentArrivedIcon = ({ isActive = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.804 18.2129C17.299 17.7119 14.715 17.7739 12.237 18.3929L12 18.4529C9.366 19.1109 6.619 19.1769 3.957 18.6439L3.804 18.6129C3.336 18.5199 3 18.1089 3 17.6329V6.7939C3 6.1629 3.577 5.6899 4.196 5.8129C6.701 6.3139 9.285 6.2519 11.763 5.6329L12.236 5.5149C14.714 4.8959 17.299 4.8339 19.803 5.3349L20.195 5.4129C20.664 5.5069 21 5.9169 21 6.3939V17.2329C21 17.8639 20.423 18.3369 19.804 18.2129Z"
        fill={isActive ? "#CAC8FF" : "none"}
        stroke={isActive ? "#387C88" : "#C5C7CA"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.001 9.375V8.5"
        stroke={isActive ? "#387C88" : "#C5C7CA"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.001 14.625V15.5"
        stroke={isActive ? "#387C88" : "#C5C7CA"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.483 14C10.71 14.371 11.097 14.628 11.564 14.628H12.002H12.523C13.202 14.628 13.751 14.078 13.751 13.4C13.751 12.836 13.367 12.345 12.821 12.207L11.181 11.795C10.636 11.658 10.251 11.166 10.251 10.602C10.251 9.92302 10.801 9.37402 11.479 9.37402H12H12.438C12.905 9.37402 13.291 9.62902 13.518 9.99902"
        stroke={isActive ? "#387C88" : "#C5C7CA"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReplyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#EDECFF" />
      <path
        d="M10 6.49996V4.16663L7.08333 7.08329L10 9.99996V7.66663C11.9308 7.66663 13.5 9.23579 13.5 11.1666C13.5 13.0975 11.9308 14.6666 10 14.6666C8.06917 14.6666 6.5 13.0975 6.5 11.1666H5.33333C5.33333 13.745 7.42167 15.8333 10 15.8333C12.5783 15.8333 14.6667 13.745 14.6667 11.1666C14.6667 8.58829 12.5783 6.49996 10 6.49996Z"
        fill="#387C88"
      />
    </svg>
  );
};

export const AskIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.16667C10.2165 1.16667 12.8333 3.7835 12.8333 7C12.8333 10.2165 10.2165 12.8333 7 12.8333C3.7835 12.8333 1.16667 10.2165 1.16667 7C1.16667 3.7835 3.7835 1.16667 7 1.16667ZM7 0C3.13425 0 0 3.13425 0 7C0 10.8657 3.13425 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13425 10.8657 0 7 0ZM7.72917 9.91667C7.72917 10.3192 7.40308 10.6458 7 10.6458C6.59808 10.6458 6.27083 10.3192 6.27083 9.91667C6.27083 9.51417 6.59808 9.1875 7 9.1875C7.40308 9.1875 7.72917 9.51417 7.72917 9.91667ZM8.54175 4.0845C8.18708 3.72517 7.658 3.52742 7.05367 3.52742C5.782 3.52742 4.9595 4.43158 4.9595 5.83158H6.13258C6.13258 4.96475 6.61617 4.65733 7.02975 4.65733C7.39958 4.65733 7.79217 4.90292 7.82542 5.3725C7.86158 5.86658 7.59792 6.11742 7.26425 6.43475C6.44058 7.21817 6.42542 7.59733 6.42892 8.45775H7.5985C7.59092 8.07042 7.616 7.756 8.14392 7.18725C8.53883 6.76142 9.03 6.23175 9.03992 5.42442C9.04633 4.88542 8.87425 4.42167 8.54175 4.0845Z"
      fill="#387C88"
    />
  </svg>
);

export const PayupIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="21"
      height="21"
      rx="4.5"
      fill="white"
      stroke="#E8EAED"
    />
    <mask
      id="mask0_2839_12431"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="20"
      height="20"
    >
      <rect x="1" y="1" width="20" height="20" rx="4" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_2839_12431)">
      <path
        d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
        fill="#387C88"
      />
      <path
        d="M13.8996 9.77778L11.3718 7.25V7.26167H8.90234V14.7808H11.4301V12.3056H13.8996V9.77778ZM11.4321 9.77778V12.3056L8.90429 9.77778H11.4321Z"
        fill="white"
      />
    </g>
  </svg>
);

export const EditFilledIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3952 3.20951L8.79049 0.604834L8.85588 0.539445C9.57514 -0.179815 10.7413 -0.179815 11.4606 0.539445C12.1798 1.25871 12.1798 2.42486 11.4606 3.14412L11.3952 3.20951ZM10.3345 4.27017L3.38607 11.2186L0 12L0.781401 8.61393L7.72983 1.66549L10.3345 4.27017Z"
      fill="currentColor"
    />
  </svg>
);

export const DownloadCSVIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3717 8.40698L9.00007 10.7786L6.62842 8.40698"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99998 3.66431V10.7786"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3357 11.9636C14.3357 13.2735 13.2738 14.3353 11.964 14.3353H6.03621C4.72638 14.3353 3.66455 13.2735 3.66455 11.9636"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SendCSVIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 9V18C3 19.657 4.343 21 6 21H18C19.657 21 21 19.657 21 18V9.235"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.399 6.766L10.262 2.562C11.308 1.812 12.715 1.813 13.76 2.563L19.598 6.755C21.467 8.097 21.467 10.293 19.596 11.634L13.744 15.83C12.698 16.58 11.291 16.579 10.246 15.829L4.397 11.628C2.534 10.291 2.534 8.103 4.399 6.766Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.21618 8L12.0052 6L14.7842 7.996"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0002 6L12.0002 12"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WeFoundMatchIcon = () => (
  <svg
    width="124"
    height="124"
    viewBox="0 0 124 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M104 70.4V62C104 59.7722 103.115 57.6356 101.54 56.0603C99.9646 54.485 97.828 53.6 95.6002 53.6H11.6002C9.37238 53.6 7.2358 54.485 5.6605 56.0603C4.08519 57.6356 3.2002 59.7722 3.2002 62V112.4C3.2002 114.628 4.08519 116.764 5.6605 118.34C7.2358 119.915 9.37238 120.8 11.6002 120.8H95.6002C97.828 120.8 99.9646 119.915 101.54 118.34C103.115 116.764 104 114.628 104 112.4V104M104 70.4H70.4002C65.9446 70.4 61.6714 72.17 58.5208 75.3206C55.3702 78.4712 53.6002 82.7444 53.6002 87.2C53.6002 91.6556 55.3702 95.9288 58.5208 99.0794C61.6714 102.23 65.9446 104 70.4002 104H104M104 70.4C108.456 70.4 112.729 72.17 115.88 75.3206C119.03 78.4712 120.8 82.7444 120.8 87.2C120.8 91.6556 119.03 95.9288 115.88 99.0794C112.729 102.23 108.456 104 104 104M28.4002 53.6V28.4C28.4002 21.7166 31.0552 15.3068 35.7811 10.5809C40.507 5.855 46.9167 3.20001 53.6002 3.20001C60.2836 3.20001 66.6934 5.855 71.4193 10.5809C76.1452 15.3068 78.8002 21.7166 78.8002 28.4V53.6M99.8002 87.2H108.2M83.0002 87.2H91.4002M66.2002 87.2H74.6002"
      stroke="#387C88"
      strokeWidth="5"
    />
  </svg>
);

export const WeNotFoundMatch = () => (
  <svg
    width="105"
    height="121"
    viewBox="0 0 105 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.853 110.717L91.9357 98.0725L91.9348 98.0734C91.1548 97.2491 90.0612 96.7933 88.9257 96.8193C88.0197 96.8193 87.1352 97.0891 86.384 97.5934L85.2606 96.4193C89.3931 91.6865 91.5762 85.5701 91.373 79.2985C91.1696 73.0268 88.5934 67.0641 84.1633 62.6076C79.5393 57.9455 73.2301 55.3311 66.6539 55.3525C64.5723 55.3544 62.4999 55.6232 60.4875 56.1526C58.5935 55.0232 56.6061 54.0546 54.5488 53.2583L53.626 52.9253V52.9243C61.1548 49.0687 66.5384 42.0326 68.2804 33.7736C70.0224 25.5146 67.9361 16.9124 62.602 10.3587C57.2688 3.80605 49.2559 0 40.7922 0C32.3276 0 24.3149 3.80605 18.9817 10.3587C13.6475 16.9124 11.5623 25.5146 13.3033 33.7736C15.0453 42.0326 20.4289 49.069 27.9577 52.9243C21.8145 55.1219 16.3041 58.7856 11.9067 63.5948C4.14674 72.0632 -0.108028 83.1486 0.00208511 94.6196C0.00208511 96.0924 1.2001 97.2869 2.67705 97.2869C4.15498 97.2869 5.35201 96.0924 5.35201 94.6196C5.25964 84.5102 9.00008 74.7393 15.8254 67.2627C22.2065 60.1687 31.2962 56.0944 40.8529 56.0451C44.8958 56.0414 48.905 56.7829 52.6773 58.2325L54.1086 58.8195C47.8312 62.5336 43.5102 68.8127 42.2925 75.9886C41.0749 83.1646 43.0847 90.5119 47.7872 96.0783C52.4898 101.645 59.41 104.867 66.7092 104.889C72.0116 104.903 77.175 103.199 81.4224 100.033L82.8537 101.62C82.4851 102.402 82.3554 103.274 82.4823 104.128C82.6083 104.982 82.9843 105.78 83.5628 106.422L95.4944 119.067C96.2436 119.903 97.312 120.387 98.4362 120.4C99.7182 120.38 100.938 119.846 101.821 118.92L103.64 116.973C104.472 116.156 104.958 115.051 104.997 113.887C105.037 112.724 104.628 111.588 103.854 110.717L103.853 110.717ZM18.0321 27.9964C18.0321 21.9835 20.4271 16.216 24.6921 11.9634C28.9562 7.71149 34.7399 5.32235 40.771 5.32235C46.8022 5.32235 52.5861 7.71149 56.85 11.9634C61.1148 16.216 63.51 21.9835 63.51 27.9964C63.51 34.0104 61.115 39.7778 56.85 44.0304C52.5859 48.2823 46.8022 50.6715 40.771 50.6715C34.7399 50.6715 28.956 48.2823 24.6921 44.0304C20.4273 39.7778 18.0321 34.0104 18.0321 27.9964ZM66.7088 99.554C61.5566 99.5689 56.6152 97.5164 52.9979 93.8592C49.3608 90.2037 47.3196 85.2634 47.3196 80.1138C47.3196 74.9652 49.361 70.0249 52.9979 66.3694C56.6302 62.7318 61.5669 60.6858 66.7155 60.6858C71.8641 60.6858 76.7998 62.7317 80.4321 66.3694C84.0699 70.0249 86.1105 74.9652 86.1105 80.1138C86.1105 85.2634 84.0699 90.2037 80.4321 93.8592C76.811 97.5183 71.865 99.5706 66.709 99.554H66.7088ZM98.558 114.506L88.0977 103.408L88.86 102.608L99.3203 113.706L98.558 114.506Z"
      fill="#FDD570"
    />
    <path
      d="M66.7611 66.5833C64.8055 66.5861 62.9301 67.3639 61.5483 68.7436C60.1664 70.1243 59.3911 71.9952 59.3911 73.9454C59.3911 75.4191 60.5882 76.6127 62.0661 76.6127C63.5431 76.6127 64.741 75.4191 64.741 73.9454C64.7466 73.1322 65.2421 72.4019 65.9969 72.094C66.7527 71.7869 67.6185 71.9618 68.1942 72.5396C68.7689 73.1165 68.9388 73.9817 68.6253 74.7325C68.3127 75.4833 67.5765 75.9727 66.7611 75.9727C65.2831 75.9727 64.0861 77.1673 64.0861 78.64V83.3487C64.0861 84.8215 65.2832 86.0161 66.7611 86.0161C68.2381 86.0161 69.436 84.8215 69.436 83.3487V80.8143C71.5801 79.9658 73.2045 78.1694 73.8288 75.9551C74.4531 73.7417 74.0061 71.3637 72.6196 69.5262C71.2341 67.6878 69.0676 66.5993 66.7612 66.5836L66.7611 66.5833Z"
      fill="#FDD570"
    />
    <path
      d="M66.7615 88.043C65.8079 88.0374 64.9458 88.6059 64.5772 89.4832C64.2087 90.3597 64.4065 91.3719 65.0783 92.0455C65.751 92.72 66.7643 92.9229 67.646 92.561C68.5268 92.1981 69.1025 91.3412 69.1025 90.3904C69.1025 89.099 68.0565 88.0505 66.7615 88.043Z"
      fill="#FDD570"
    />
  </svg>
);

export const EmailVerifiedRequestIcon = () => (
  <svg
    width="102"
    height="103"
    viewBox="0 0 102 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M102 39V87C102 91.2435 100.314 95.3131 97.3136 98.3137C94.313 101.314 90.2433 103 85.9998 103H16.6665C12.423 103 8.35338 101.314 5.3528 98.3137C2.35221 95.3131 0.666504 91.2435 0.666504 87V39C0.666504 33.08 3.8665 27.9067 8.6665 25.1333L51.3332 0.493332L93.9998 25.1333C98.7998 27.9067 102 33.08 102 39ZM9.83984 30.84L51.3332 57.6667L92.8265 30.84L51.3332 6.62667L9.83984 30.84ZM51.3332 64.12L6.69317 35.16C6.2665 36.3333 5.99984 37.6667 5.99984 39V87C5.99984 89.829 7.12364 92.5421 9.12403 94.5425C11.1244 96.5428 13.8375 97.6667 16.6665 97.6667H85.9998C88.8288 97.6667 91.5419 96.5428 93.5423 94.5425C95.5427 92.5421 96.6665 89.829 96.6665 87V39C96.6665 37.6667 96.3998 36.3333 95.9732 35.16L51.3332 64.12Z"
      fill="#387C88"
    />
  </svg>
);

export const AccountSearchConfirmationIcon = () => (
  <svg
    width="105"
    height="121"
    viewBox="0 0 105 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.854 110.717L91.9357 98.0725L91.9348 98.0734C91.1548 97.2491 90.0612 96.7933 88.9257 96.8193C88.0197 96.8193 87.1352 97.0891 86.384 97.5934L85.2606 96.4193C89.3931 91.6865 91.5762 85.5701 91.373 79.2985C91.1696 73.0268 88.5934 67.0641 84.1633 62.6076C79.5393 57.9455 73.2301 55.3311 66.6539 55.3525C64.5723 55.3544 62.4999 55.6232 60.4875 56.1526C58.5935 55.0232 56.6061 54.0546 54.5488 53.2583L53.626 52.9253V52.9243C61.1548 49.0687 66.5384 42.0326 68.2804 33.7736C70.0224 25.5146 67.9361 16.9124 62.6021 10.3587C57.2688 3.80605 49.2559 0 40.7922 0C32.3276 0 24.3149 3.80605 18.9817 10.3587C13.6475 16.9124 11.5623 25.5146 13.3033 33.7736C15.0453 42.0326 20.4289 49.069 27.9577 52.9243C21.8145 55.1219 16.3041 58.7856 11.9067 63.5948C4.14674 72.0632 -0.108028 83.1486 0.00208511 94.6196C0.00208511 96.0924 1.2001 97.2869 2.67705 97.2869C4.15498 97.2869 5.35201 96.0923 5.35201 94.6196C5.25964 84.5102 9.00008 74.7393 15.8254 67.2627C22.2065 60.1687 31.2962 56.0944 40.8529 56.0451C44.8958 56.0414 48.905 56.7829 52.6773 58.2325L54.1086 58.8195C47.8312 62.5336 43.5102 68.8127 42.2925 75.9886C41.0749 83.1646 43.0847 90.5119 47.7872 96.0783C52.4898 101.645 59.41 104.867 66.7093 104.889C72.0116 104.903 77.175 103.199 81.4224 100.033L82.8537 101.62C82.4851 102.402 82.3554 103.274 82.4823 104.128C82.6083 104.982 82.9843 105.78 83.5628 106.422L95.4944 119.067C96.2436 119.903 97.312 120.387 98.4362 120.4C99.7182 120.38 100.938 119.846 101.821 118.92L103.64 116.973C104.472 116.156 104.958 115.051 104.997 113.887C105.037 112.724 104.628 111.588 103.854 110.717L103.854 110.717ZM18.0321 27.9964C18.0321 21.9835 20.4271 16.216 24.6921 11.9634C28.9562 7.71149 34.7399 5.32235 40.771 5.32235C46.8022 5.32235 52.5861 7.71149 56.85 11.9634C61.1148 16.216 63.51 21.9835 63.51 27.9964C63.51 34.0104 61.115 39.7778 56.85 44.0304C52.5859 48.2824 46.8022 50.6715 40.771 50.6715C34.7399 50.6715 28.956 48.2824 24.6921 44.0304C20.4273 39.7778 18.0321 34.0104 18.0321 27.9964ZM66.7088 99.554C61.5566 99.5689 56.6152 97.5164 52.9979 93.8592C49.3608 90.2037 47.3196 85.2634 47.3196 80.1138C47.3196 74.9652 49.361 70.0249 52.9979 66.3694C56.6302 62.7318 61.5669 60.6858 66.7155 60.6858C71.8641 60.6858 76.7998 62.7317 80.4321 66.3694C84.0699 70.0249 86.1105 74.9652 86.1105 80.1138C86.1105 85.2634 84.0699 90.2037 80.4321 93.8592C76.811 97.5183 71.865 99.5706 66.709 99.554H66.7088ZM98.558 114.506L88.0978 103.408L88.86 102.608L99.3203 113.706L98.558 114.506Z"
      fill="#387C88"
    />
    <path
      d="M67 70C61.48 70 57 74.48 57 80C57 85.52 61.48 90 67 90C72.52 90 77 85.52 77 80C77 74.48 72.52 70 67 70ZM65 85L60 80L61.41 78.59L65 82.17L72.59 74.58L74 76L65 85Z"
      fill="#387C88"
    />
  </svg>
);

export const MoveMoneyIcon = ({
  width = "12",
  height = "12",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.6665 3.3335L2.6665 1.3335L0.666504 3.3335"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66634 10.6668V1.3335"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33301 8.66699L9.33301 10.667L11.333 8.66699"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 1.3335V10.6668"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ManageCardIcon = ({
  width = "17",
  height = "18",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1943 10.7327L13.8865 10.9104C13.2674 11.2678 12.8861 11.9283 12.8861 12.6431V12.9986C12.886 13.7134 12.5047 14.3739 11.8856 14.7313C11.2666 15.0887 10.5039 15.0887 9.88486 14.7313L9.57698 14.5536C8.95793 14.1962 8.19523 14.1962 7.57619 14.5536L7.26831 14.7313C6.64926 15.0887 5.88658 15.0887 5.26754 14.7313C4.6485 14.3739 4.26714 13.7134 4.26712 12.9986V12.6431C4.2671 11.9283 3.88574 11.2678 3.2667 10.9104L2.95887 10.7327C2.33983 10.3753 1.9585 9.71474 1.9585 8.99993C1.9585 8.28511 2.33983 7.6246 2.95887 7.26718L3.26673 7.08944C3.88577 6.73204 4.26712 6.07153 4.26714 5.35672V5.00124C4.26717 4.28644 4.64853 3.62594 5.26757 3.26854C5.88661 2.91115 6.64929 2.91114 7.26834 3.26852L7.57621 3.44627C8.19526 3.80367 8.95796 3.80367 9.57701 3.44627L9.88488 3.26852C10.5039 2.91114 11.2666 2.91115 11.8857 3.26854C12.5047 3.62594 12.8861 4.28644 12.8861 5.00124V5.35672C12.8861 6.07153 13.2675 6.73204 13.8865 7.08944L14.1944 7.26718C14.8134 7.6246 15.1947 8.28512 15.1947 8.99993C15.1947 9.71475 14.8134 10.3753 14.1943 10.7327Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="8.49986"
      cy="8.99986"
      r="2.00083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyClipBoardIcon = ({
  width = "12",
  height = "12",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.02098 11.251H6.53064C7.09422 11.251 7.55162 10.7936 7.55162 10.2301V4.82908C7.55162 4.2655 7.09422 3.80811 6.53064 3.80811H2.02098C1.4574 3.80811 1 4.2655 1 4.82908V10.2311C1 10.7947 1.45638 11.251 2.02098 11.251Z"
      stroke="currentColor"
      strokeWidth="1.22518"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.80762 3.80769V2.02098C3.80762 1.4574 4.26502 1 4.8286 1H9.37195C9.93553 1 10.3929 1.4574 10.3929 2.02098V7.42298C10.3929 7.98656 9.93553 8.44396 9.37195 8.44396H7.55053"
      stroke="currentColor"
      strokeWidth="1.22518"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardBGImg = () => (
  <svg
    width="98"
    height="146"
    viewBox="0 0 98 146"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="card_bg_img"
  >
    <path
      d="M121.806 54.6667L60.4203 -6.34863L60.4203 -6.06702L0.451172 -6.06702L0.45119 175.43H61.8369L61.8369 115.682H121.806L121.806 54.6667ZM61.8841 54.6667L61.8841 115.682L0.498399 54.6667H61.8841Z"
      fill="white"
      fillOpacity="0.07"
    />
  </svg>
);

export const CardPayupLogo = ({
  width = "50",
  height = "16",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="card_logo_img"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4531 5.88571V11.1714C11.4531 11.3143 11.3386 11.4286 11.1954 11.4286H5.72654V15.7429C5.72654 15.8857 5.61201 16 5.46885 16H0.257694C0.114531 16 0 15.8857 0 15.7429V0.257143C0 0.114286 0.114531 0 0.257694 0H5.55475C5.66928 0 5.75517 0.0571429 5.84107 0.114286L11.3386 5.6C11.4245 5.68571 11.4531 5.77143 11.4531 5.88571ZM5.72654 11.4286L0 5.71432H5.72654V11.4286Z"
      fill="white"
    />
    <path
      d="M21.7607 4.28711C22.1329 4.28711 22.4765 4.34425 22.7915 4.45854C23.1064 4.57282 23.3641 4.74425 23.5645 4.94425C23.765 5.14425 23.9368 5.40139 24.0513 5.68711C24.1658 5.97282 24.2231 6.25854 24.2231 6.57282C24.2231 6.88711 24.1658 7.20139 24.0513 7.45854C23.9368 7.74425 23.765 7.97282 23.5645 8.17282C23.3641 8.37282 23.1064 8.54425 22.7915 8.62997C22.4765 8.74425 22.1329 8.80139 21.7607 8.80139H18.7256V11.43H17.1794V4.28711H21.7607ZM22.4479 7.37282C22.6483 7.17282 22.7628 6.91568 22.7628 6.54425C22.7628 6.20139 22.6483 5.94425 22.4479 5.74425C22.2474 5.54425 21.9325 5.42997 21.5316 5.42997H18.7256V7.65854H21.5316C21.9325 7.65854 22.2474 7.57282 22.4479 7.37282Z"
      fill="white"
    />
    <path
      d="M30.0069 10.4866C30.1214 10.4866 30.236 10.4866 30.3791 10.458V11.4866C30.0355 11.5438 29.7492 11.5723 29.5201 11.5723C29.2911 11.5723 29.1193 11.5438 28.9761 11.5152C28.833 11.4866 28.6898 11.4009 28.6039 11.3152C28.518 11.2295 28.4321 11.1152 28.3748 10.9723C28.3176 10.8581 28.2889 10.6866 28.2603 10.4866C28.1744 10.6581 28.0885 10.8009 27.9453 10.9152C27.8308 11.0295 27.6876 11.1723 27.5158 11.2581C27.3441 11.3723 27.1723 11.4295 26.9432 11.4866C26.7141 11.5438 26.4851 11.5723 26.2274 11.5723C26.0269 11.5723 25.8552 11.5723 25.6834 11.5152C25.5116 11.4866 25.3398 11.4295 25.1966 11.3723C25.0534 11.3152 24.9103 11.2009 24.7957 11.1152C24.6812 11.0009 24.5953 10.8866 24.538 10.7152C24.4808 10.5438 24.4521 10.3723 24.4521 10.1723C24.4521 9.65805 24.6812 9.22948 25.1107 8.91519C25.5402 8.60091 26.1987 8.40091 27.0577 8.31519C27.3727 8.28662 27.6876 8.25805 28.0599 8.25805V7.97234C28.0599 7.82948 28.0312 7.71519 27.974 7.62948C27.9167 7.51519 27.8308 7.45805 27.7163 7.40091C27.6017 7.34376 27.4872 7.31519 27.3727 7.28662C27.2582 7.25805 27.115 7.25805 26.9718 7.25805C26.8287 7.25805 26.6569 7.25805 26.5423 7.31519C26.3992 7.34376 26.2846 7.40091 26.1701 7.45805C26.0556 7.51519 25.9697 7.60091 25.9124 7.71519C25.8552 7.74376 25.8265 7.85805 25.8265 8.00091H24.4808C24.5094 7.74376 24.5667 7.51519 24.6812 7.31519C24.7671 7.11519 24.9103 6.94376 25.0534 6.82948C25.1966 6.68662 25.3684 6.60091 25.5975 6.51519C25.7979 6.42948 26.0269 6.37234 26.2846 6.34376C26.5137 6.31519 26.8 6.28662 27.0864 6.28662C28.6898 6.28662 29.4629 6.88662 29.4629 8.11519V9.71519C29.4629 9.80091 29.4629 9.91519 29.4629 9.97234C29.4629 10.0581 29.4915 10.1152 29.5201 10.2009C29.5488 10.2581 29.5774 10.3152 29.606 10.3723C29.6347 10.4295 29.6919 10.4581 29.7492 10.4866C29.8351 10.4581 29.921 10.4866 30.0069 10.4866ZM26.7428 10.7438C27.0291 10.7438 27.2868 10.6581 27.4872 10.4866C27.6876 10.3438 27.8594 10.1152 27.9453 9.82948C28.0312 9.54376 28.0885 9.22948 28.0885 8.85805C27.7163 8.85805 27.4013 8.88662 27.1436 8.94376C26.7141 9.00091 26.3705 9.11519 26.1415 9.31519C25.941 9.48662 25.8265 9.71519 25.8265 10.0009C25.8265 10.2295 25.9124 10.4295 26.0842 10.5438C26.2274 10.6866 26.4564 10.7438 26.7428 10.7438Z"
      fill="white"
    />
    <path
      d="M35.4475 6.34376L33.1282 11.8866C33.0137 12.1438 32.9278 12.3438 32.8419 12.4866C32.756 12.658 32.6415 12.8009 32.5556 12.9152C32.4411 13.058 32.3265 13.1438 32.2406 13.2295C32.1261 13.3152 32.0116 13.3723 31.8398 13.4009C31.6966 13.458 31.5248 13.4866 31.353 13.4866C31.1812 13.5152 30.9808 13.5152 30.7231 13.5152H30.1791V12.458H30.6372C30.7804 12.458 30.8949 12.458 31.0094 12.4295C31.0953 12.4295 31.2098 12.4009 31.2957 12.3723C31.3816 12.3438 31.4675 12.2866 31.5248 12.2295C31.5821 12.1723 31.6393 12.0866 31.6966 11.9723C31.7539 11.8866 31.8111 11.7723 31.8684 11.6009L31.897 11.5438L29.7209 6.28662H31.3244L32.5556 10.058L33.9586 6.28662H35.4475V6.34376Z"
      fill="white"
    />
    <path
      d="M39.4844 11.5157C39.1981 11.5157 38.9404 11.5157 38.6827 11.4871C38.425 11.4585 38.196 11.43 37.9669 11.3728C37.7378 11.3157 37.5088 11.23 37.337 11.1443C37.1366 11.0585 36.9648 10.9443 36.8216 10.8014C36.6784 10.6585 36.5353 10.4871 36.4207 10.3157C36.3062 10.1443 36.2203 9.91568 36.163 9.65854C36.1058 9.40139 36.0771 9.14425 36.0771 8.85854V4.28711H37.5947V8.65854C37.5947 8.91568 37.6233 9.14425 37.6806 9.34425C37.7378 9.54425 37.8237 9.68711 37.9383 9.82997C38.0528 9.94425 38.196 10.0585 38.3391 10.1443C38.4823 10.23 38.6827 10.2871 38.8545 10.3157C39.0263 10.3443 39.2554 10.3728 39.4844 10.3728C39.6849 10.3728 39.8567 10.3728 39.9998 10.3443C40.1716 10.3157 40.3148 10.2871 40.458 10.23C40.6011 10.1728 40.7443 10.1157 40.8588 10.03C40.9733 9.94425 41.0592 9.82997 41.1451 9.71568C41.231 9.60139 41.2883 9.45854 41.3456 9.28711C41.3742 9.11568 41.4028 8.91568 41.4028 8.71568V4.28711H42.9204V8.82997C42.9204 9.11568 42.8917 9.40139 42.8345 9.62997C42.7772 9.88711 42.6913 10.0871 42.5768 10.2871C42.4622 10.4585 42.3477 10.63 42.1759 10.7728C42.0041 10.9157 41.8323 11.03 41.6605 11.1157C41.4601 11.2014 41.2597 11.2871 41.0306 11.3443C40.8015 11.4014 40.5439 11.4585 40.3148 11.4585C40.0571 11.5157 39.7708 11.5157 39.4844 11.5157Z"
      fill="white"
    />
    <path
      d="M46.758 6.25879C47.5311 6.25879 48.1324 6.48736 48.5619 6.97307C48.9914 7.43022 49.2204 8.08736 49.2204 8.91593C49.2204 9.7445 48.9914 10.4016 48.5619 10.8588C48.1324 11.3159 47.5311 11.5731 46.758 11.5731C46.4144 11.5731 46.0995 11.5159 45.8418 11.3445C45.5841 11.2016 45.355 11.0016 45.1832 10.7731V13.5731H43.6943V6.3445H44.8969L45.0687 7.17308C45.2119 6.91593 45.4409 6.68736 45.7273 6.51593C46.0136 6.3445 46.3858 6.25879 46.758 6.25879ZM47.4166 10.0302C47.6456 9.77307 47.7602 9.37307 47.7602 8.88736C47.7602 8.40165 47.6456 8.03022 47.4166 7.7445C47.1875 7.48736 46.8439 7.3445 46.3858 7.3445C45.985 7.3445 45.6414 7.48736 45.3837 7.77308C45.126 8.05879 45.0114 8.43022 45.0114 8.88736C45.0114 9.3445 45.126 9.71593 45.3837 10.0016C45.6414 10.2874 45.9563 10.4302 46.3858 10.4302C46.8439 10.4302 47.1875 10.3159 47.4166 10.0302Z"
      fill="white"
    />
  </svg>
);

export const CardDotsIcon = () => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="card_dots_img"
  >
    <path
      d="M0.557617 2.2793C0.557617 1.87565 0.697591 1.53548 0.977539 1.25879C1.25749 0.978841 1.60091 0.838867 2.00781 0.838867C2.41146 0.838867 2.75326 0.978841 3.0332 1.25879C3.31641 1.53874 3.45801 1.87891 3.45801 2.2793C3.45801 2.68294 3.31641 3.02637 3.0332 3.30957C2.75 3.58952 2.40495 3.72949 1.99805 3.72949C1.5944 3.72949 1.2526 3.59115 0.972656 3.31445C0.695964 3.03451 0.557617 2.68945 0.557617 2.2793ZM6.58301 2.2793C6.58301 1.87565 6.72298 1.53548 7.00293 1.25879C7.28288 0.978841 7.6263 0.838867 8.0332 0.838867C8.43685 0.838867 8.77865 0.978841 9.05859 1.25879C9.3418 1.53874 9.4834 1.87891 9.4834 2.2793C9.4834 2.68294 9.3418 3.02637 9.05859 3.30957C8.77539 3.58952 8.43034 3.72949 8.02344 3.72949C7.61979 3.72949 7.27799 3.59115 6.99805 3.31445C6.72135 3.03451 6.58301 2.68945 6.58301 2.2793ZM12.6084 2.2793C12.6084 1.87565 12.7484 1.53548 13.0283 1.25879C13.3083 0.978841 13.6517 0.838867 14.0586 0.838867C14.4622 0.838867 14.804 0.978841 15.084 1.25879C15.3672 1.53874 15.5088 1.87891 15.5088 2.2793C15.5088 2.68294 15.3672 3.02637 15.084 3.30957C14.8008 3.58952 14.4557 3.72949 14.0488 3.72949C13.6452 3.72949 13.3034 3.59115 13.0234 3.31445C12.7467 3.03451 12.6084 2.68945 12.6084 2.2793Z"
      fill="white"
    />
  </svg>
);

export const SpentOrEarnIndicator = ({
  width = "14",
  height = "14",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00001 0.00681591C6.04378 0.00681591 5.14362 0.189744 4.29953 0.555602C3.45539 0.921413 2.71079 1.42672 2.06572 2.07153C1.4206 2.71628 0.915043 3.46053 0.549053 4.30425C0.183018 5.14793 0 6.04765 0 7.00341C0 7.95916 0.183018 8.85888 0.549053 9.70259C0.915043 10.5463 1.4206 11.2905 2.06572 11.9353C2.71079 12.5801 3.45654 13.0854 4.30297 13.4512C5.14936 13.8171 6.05066 14 7.00687 14C7.96308 14 8.86324 13.8171 9.70736 13.4512C10.5515 13.0854 11.2949 12.5801 11.9377 11.9353C12.5806 11.2905 13.085 10.5463 13.451 9.70259C13.817 8.85888 14 7.95916 14 7.00341C14 6.04765 13.817 5.14793 13.451 4.30425C13.085 3.46053 12.5794 2.71628 11.9343 2.07153C11.2892 1.42672 10.5446 0.921413 9.7005 0.555602C8.85638 0.189744 7.95622 0.00681591 7.00001 0.00681591Z"
      fill="currentColor"
    />
    <path
      d="M3.36278 7.01726C3.36278 6.87552 3.4314 6.73604 3.56862 6.59884L5.95001 4.20491C6.05069 4.10428 6.1765 4.05397 6.32745 4.05397C6.47386 4.05397 6.59625 4.10428 6.69464 4.20491C6.79302 4.3055 6.84221 4.42896 6.84221 4.57529C6.84221 4.72621 6.7873 4.85426 6.67749 4.95943L5.79906 5.82374L4.94122 6.54398L6.44411 6.48224H10.1157C10.2713 6.48224 10.3994 6.53253 10.5 6.63312C10.6007 6.73375 10.651 6.86179 10.651 7.01726C10.651 7.17273 10.6007 7.30078 10.5 7.40138C10.3994 7.50199 10.2713 7.55229 10.1157 7.55229H6.44411L4.94803 7.49056L5.79906 8.20394L6.67749 9.07508C6.7873 9.1894 6.84221 9.31515 6.84221 9.45234C6.84221 9.59868 6.79302 9.721 6.69464 9.81932C6.59625 9.91764 6.47386 9.9668 6.32745 9.9668C6.17191 9.9668 6.0461 9.91878 5.95001 9.82275L3.56862 7.42882C3.4314 7.29163 3.36278 7.15444 3.36278 7.01726Z"
      fill="white"
    />
  </svg>
);

export const LimitsIcon = ({
  width = "26",
  height = "26",
  strokeColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99634 8.99826H22.0038"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4991 13.0002H7.99805"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9993 19.0024H6.99759C5.34004 19.0024 3.99634 17.6587 3.99634 16.0012V7.99783C3.99634 6.34029 5.34004 4.99658 6.99759 4.99658H19.0026C20.6601 4.99658 22.0038 6.34029 22.0038 7.99783V11.9995"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0022 22.0038C15.7921 22.0038 14.0005 20.2122 14.0005 18.0022C14.0005 15.7921 15.7921 14.0005 18.0022 14.0005C20.2122 14.0005 22.0038 15.7921 22.0038 18.0022C22.0038 20.2122 20.2122 22.0038 18.0022 22.0038"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8318 20.8318L18.0022 18.0023V14.0068"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddToAppleWalletIcon = ({
  width = "26",
  height = "26",
  strokeColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99634 13H6.99759C7.75737 13 8.47595 13.3454 8.95058 13.9387L9.59975 14.7501C9.97945 15.2247 10.5543 15.501 11.1621 15.501H14.838C15.4459 15.501 16.0207 15.2247 16.4004 14.7501L17.0496 13.9387C17.5242 13.3454 18.2428 13 19.0026 13H22.0038"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0038 11.9995V11.4993C22.0038 9.84175 20.6601 8.49805 19.0026 8.49805H6.99759C5.34004 8.49805 3.99634 9.84175 3.99634 11.4993V11.9995"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3.99634"
      y="3.99658"
      width="18.0075"
      height="18.0075"
      rx="3"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OrderPhysicalCardIcon = ({
  width = "21",
  height = "16",
  fillColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.79383 9.94964V11.7005C6.79383 11.7479 6.7559 11.7857 6.70847 11.7857H4.89692V13.2148C4.89692 13.2621 4.85898 13.3 4.81156 13.3H3.08536C3.03794 13.3 3 13.2621 3 13.2148V8.08518C3 8.03786 3.03794 8 3.08536 8H4.84001C4.87795 8 4.9064 8.01893 4.93486 8.03786L6.7559 9.855C6.78435 9.88339 6.79383 9.91179 6.79383 9.94964ZM4.89692 11.7851L3 9.89227H4.89692V11.7851Z"
      fill={fillColor}
    />
    <path
      d="M0.723831 5.85478H20.2852V3.72832H0.723831V5.85478ZM2.80596 16H18.194C19.1294 16 19.8309 15.758 20.2985 15.2739C20.7662 14.79 21 14.0671 21 13.1054V2.90397C21 1.94223 20.7662 1.21779 20.2985 0.730677C19.8309 0.243559 19.1294 0 18.194 0H2.80596C1.87064 0 1.16915 0.241998 0.70149 0.725994C0.23383 1.20999 0 1.93598 0 2.90397V13.1054C0 14.0671 0.23383 14.79 0.70149 15.2739C1.16915 15.758 1.87064 16 2.80596 16ZM2.82383 14.4918C2.37703 14.4918 2.03447 14.3684 1.79617 14.1217C1.55788 13.875 1.43873 13.5082 1.43873 13.0211V2.98828C1.43873 2.50116 1.55788 2.1327 1.79617 1.8829C2.03447 1.63309 2.37703 1.50819 2.82383 1.50819H18.1762C18.617 1.50819 18.9581 1.63309 19.1993 1.8829C19.4407 2.1327 19.5613 2.50116 19.5613 2.98828V13.0211C19.5613 13.5082 19.4407 13.875 19.1993 14.1217C18.9581 14.3684 18.617 14.4918 18.1762 14.4918H2.82383Z"
      fill={fillColor}
    />
  </svg>
);

export const SetUpPinCodeIcon = ({
  width = "24",
  height = "24",
  strokeColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    style={{ marginTop: "1px" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 21H7C5.895 21 5 20.105 5 19V11C5 9.895 5.895 9 7 9H17C18.105 9 19 9.895 19 11V19C19 20.105 18.105 21 17 21Z"
      stroke={strokeColor}
      strokeWidth="1.4655"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 9V7C16 4.791 14.209 3 12 3V3C9.791 3 8 4.791 8 7V9"
      stroke={strokeColor}
      strokeWidth="1.4031"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.998 14.5C11.722 14.5 11.498 14.724 11.5 15C11.5 15.276 11.724 15.5 12 15.5C12.276 15.5 12.5 15.276 12.5 15C12.5 14.724 12.276 14.5 11.998 14.5"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FreezeCardcon = ({
  width = "24",
  height = "24",
  strokeColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    style={{ marginTop: "2px" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.364 5.63574L5.63599 18.3637L18.364 5.63574Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3V3C7.029 3 3 7.029 3 12V12C3 16.971 7.029 21 12 21V21C16.971 21 21 16.971 21 12V12C21 7.029 16.971 3 12 3Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CancelAccountIcon = ({
  width = "20",
  height = "20",
  fillColor = "#A4233F",
  strokeColor = "#A4233F",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "-2px" }}
  >
    <path
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM1.42451 10C1.42451 14.7361 5.26389 18.5755 10 18.5755C14.7361 18.5755 18.5755 14.7361 18.5755 10C18.5755 5.26389 14.7361 1.42451 10 1.42451C5.26389 1.42451 1.42451 5.26389 1.42451 10Z"
      fill={fillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6464 6.64645C12.8417 6.45118 13.1583 6.45118 13.3536 6.64645C13.5488 6.84171 13.5488 7.15829 13.3536 7.35355L10.7071 10L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L10 10.7071L7.35355 13.3536C7.15829 13.5488 6.84171 13.5488 6.64645 13.3536C6.45118 13.1583 6.45118 12.8417 6.64645 12.6464L9.29289 10L6.64645 7.35355C6.45118 7.15829 6.45118 6.84171 6.64645 6.64645C6.84171 6.45118 7.15829 6.45118 7.35355 6.64645L10 9.29289L12.6464 6.64645Z"
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CardSpendingsIcon = ({
  width = "16",
  height = "12",
  strokeColor = "#7E8085",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 3.75H14.75"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1775 6.75H4.25"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 11.25H3.5C2.25725 11.25 1.25 10.2428 1.25 9V3C1.25 1.75725 2.25725 0.75 3.5 0.75H12.5C13.7428 0.75 14.75 1.75725 14.75 3V9C14.75 10.2428 13.7428 11.25 12.5 11.25Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AtmWithdrawalsIcon = ({
  width = "20",
  height = "20",
  strokeColor = "#7E8085",
  strokeWidth = "1.5",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7517 12.251H15.2523C16.0811 12.251 16.7529 11.5791 16.7529 10.7504V5.49818C16.7529 4.66941 16.0811 3.99756 15.2523 3.99756H4.74794C3.91917 3.99756 3.24731 4.66941 3.24731 5.49818V10.7504C3.24731 11.5791 3.91917 12.251 4.74794 12.251H6.24856"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24854 8.49902H13.7517V14.5015C13.7517 15.3303 13.0798 16.0021 12.251 16.0021H7.74916C6.92039 16.0021 6.24854 15.3303 6.24854 14.5015V8.49902Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7504 8.49902V16.0021"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7516 6.2482H12.251"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InstantPaymentsIcon = ({
  width = "16",
  height = "18",
  fillColor = "#387C88",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.87671 0.576787C10.0012 0.642759 10.0989 0.746523 10.1543 0.871528C10.2096 0.996533 10.2194 1.13558 10.182 1.26648L8.4881 7.17823H14.6684C14.7927 7.17824 14.9143 7.21282 15.0182 7.27772C15.1221 7.34262 15.2038 7.43501 15.2534 7.54354C15.3029 7.65206 15.318 7.772 15.2968 7.88859C15.2757 8.00518 15.2192 8.11336 15.1344 8.19982L6.20577 17.3067C6.10853 17.4061 5.97907 17.4715 5.83811 17.4926C5.69715 17.5137 5.55283 17.4892 5.42823 17.423C5.30364 17.3568 5.20596 17.2527 5.15083 17.1274C5.0957 17.0022 5.0863 16.8629 5.12414 16.7319L6.81802 10.821H0.637718C0.513431 10.821 0.391854 10.7864 0.287933 10.7215C0.184012 10.6566 0.102276 10.5642 0.0527718 10.4557C0.00326801 10.3471 -0.011846 10.2272 0.00928799 10.1106C0.0304219 9.99401 0.0868826 9.88584 0.17173 9.79938L9.10035 0.692545C9.1976 0.5935 9.32688 0.528293 9.46758 0.507314C9.60828 0.486335 9.75231 0.510792 9.87671 0.576787Z"
      fill={fillColor}
    />
  </svg>
);

export const MenuIconRequests = ({
  width = "25",
  height = "25",
  strokeColor = "currentColor",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5004 9.99899H17.502"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4991 22.0038H8.4983C5.73572 22.0038 3.49622 19.7643 3.49622 17.0018V8.99842C3.49622 6.23585 5.73572 3.99634 8.4983 3.99634H16.5016C19.2642 3.99634 21.5037 6.23585 21.5037 8.99842V10.9993"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49792 9.72482L8.41731 10.5532L10.2681 8.88647"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49792 14.7268L8.41731 15.5551L10.2681 13.8884"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5009 22.504V22.0978C14.5042 20.9422 15.4401 20.0062 16.5957 20.0029H19.4089C20.5645 20.0062 21.5005 20.9422 21.5038 22.0978V22.504C21.5038 22.7802 21.2798 23.0042 21.0036 23.0042H15.0011C14.8684 23.0042 14.7412 22.9515 14.6474 22.8577C14.5536 22.7639 14.5009 22.6366 14.5009 22.504Z"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="18.0023"
        cy="15.7513"
        r="2.00083"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIconAccount = ({
  width = "21",
  height = "20",
  strokeColor = "currentColor",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.263 16.91L15.913 16.031C15.736 15.585 15.461 15.185 15.109 14.859L15.045 14.8C14.491 14.286 13.763 14 13.007 14H7.99296C7.23696 14 6.50896 14.286 5.95396 14.799L5.88996 14.859C5.53796 15.185 5.26396 15.585 5.08596 16.031L4.73596 16.91"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9749 5.44725C14.3417 6.81409 14.3417 9.03016 12.9749 10.397C11.608 11.7638 9.39197 11.7638 8.02513 10.397C6.65829 9.03016 6.65829 6.81409 8.02513 5.44725C9.39197 4.08041 11.608 4.08041 12.9749 5.44725"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8639 3.63604C20.3787 7.15076 20.3787 12.8492 16.8639 16.3639C13.3492 19.8787 7.65074 19.8787 4.13604 16.3639C0.62132 12.8492 0.62132 7.15074 4.13604 3.63604C7.65076 0.12132 13.3492 0.12132 16.8639 3.63604"
        stroke={strokeColor}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MaintenanceRequestIcon = ({
  width = "20",
  height = "20",
  fillColor = "white",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.074 15.5573L13.6574 11.1406H12.8324L10.7157 13.2573V14.0823L15.1324 18.499C15.4574 18.824 15.9824 18.824 16.3074 18.499L18.074 16.7323C18.399 16.4156 18.399 15.8823 18.074 15.5573ZM15.7157 16.7406L12.1824 13.2073L12.774 12.6156L16.3074 16.149L15.7157 16.7406Z"
        fill={fillColor}
      />
      <path
        d="M14.4657 8.9073L15.6407 7.7323L17.4074 9.49896C18.3824 8.52396 18.3824 6.94063 17.4074 5.96563L14.4574 3.01563L13.2824 4.19063V1.84063L12.699 1.24896L9.74904 4.19896L10.3407 4.79063H12.699L11.524 5.96563L12.4074 6.84896L9.99904 9.2573L6.55737 5.81563V4.6323L4.04071 2.11563L1.68237 4.47396L4.20737 6.99896H5.38237L8.82404 10.4406L8.11571 11.149H6.34904L1.93237 15.5656C1.60737 15.8906 1.60737 16.4156 1.93237 16.7406L3.69904 18.5073C4.02404 18.8323 4.54904 18.8323 4.87404 18.5073L9.29071 14.0906V12.324L13.5824 8.0323L14.4657 8.9073ZM7.81571 13.199L4.28237 16.7323L3.69071 16.1406L7.22404 12.6073L7.81571 13.199Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const GuestAccessIcon = ({
  width = "20",
  height = "20",
  fillColor = "white",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7064 5.83333C17.7064 4.68333 16.7731 3.75 15.6231 3.75C15.4814 3.75 15.3398 3.76667 15.2064 3.79167V3.33333C15.2064 2.18333 14.2731 1.25 13.1231 1.25C12.9314 1.25 12.7398 1.275 12.5648 1.325C12.2564 0.55 11.5064 0 10.6231 0C9.59811 0 8.74811 0.741667 8.57311 1.71667C8.43144 1.68333 8.28144 1.66667 8.12311 1.66667C6.97311 1.66667 6.03977 2.6 6.03977 3.75V8.65833C5.75644 8.4 5.40644 8.20833 5.02311 8.10833L4.38144 7.93333C3.68977 7.74167 2.96477 8.00833 2.55644 8.625C2.23977 9.1 2.22311 9.71667 2.43144 10.25L4.56477 15.6083C5.61477 18.2583 8.18144 20 11.0398 20C14.7231 20 17.7064 17.0167 17.7064 13.3333V5.83333ZM16.0398 13.3333C16.0398 16.0917 13.7981 18.3333 11.0398 18.3333C8.86477 18.3333 6.91477 17.0083 6.11477 14.9917L3.94811 9.54167L4.38977 9.65833C4.77311 9.75833 5.08144 10.0417 5.22311 10.4083L6.03977 12.5H7.70644V3.75C7.70644 3.51667 7.88977 3.33333 8.12311 3.33333C8.35644 3.33333 8.53977 3.51667 8.53977 3.75V10H10.2064V2.08333C10.2064 1.85 10.3898 1.66667 10.6231 1.66667C10.8564 1.66667 11.0398 1.85 11.0398 2.08333V10H12.7064V3.33333C12.7064 3.1 12.8898 2.91667 13.1231 2.91667C13.3564 2.91667 13.5398 3.1 13.5398 3.33333V10H15.2064V5.83333C15.2064 5.6 15.3898 5.41667 15.6231 5.41667C15.8564 5.41667 16.0398 5.6 16.0398 5.83333V13.3333Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const UpdateRoomMateIcon = ({
  width = "20",
  height = "20",
  fillColor = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 7.49998V4.99998H14.9999V7.49998H12.4999V9.16665H14.9999V11.6666H16.6666V9.16665H19.1666V7.49998H16.6666ZM7.49992 9.99998C9.34158 9.99998 10.8333 8.50831 10.8333 6.66665C10.8333 4.82498 9.34158 3.33331 7.49992 3.33331C5.65825 3.33331 4.16658 4.82498 4.16658 6.66665C4.16658 8.50831 5.65825 9.99998 7.49992 9.99998ZM7.49992 4.99998C8.41658 4.99998 9.16658 5.74998 9.16658 6.66665C9.16658 7.58331 8.41658 8.33331 7.49992 8.33331C6.58325 8.33331 5.83325 7.58331 5.83325 6.66665C5.83325 5.74998 6.58325 4.99998 7.49992 4.99998ZM12.8249 12.1333C11.4249 11.4166 9.60825 10.8333 7.49992 10.8333C5.39158 10.8333 3.57492 11.4166 2.17492 12.1333C1.34159 12.5583 0.833252 13.4166 0.833252 14.35V16.6666H14.1666V14.35C14.1666 13.4166 13.6583 12.5583 12.8249 12.1333ZM12.4999 15H2.49992V14.35C2.49992 14.0333 2.66659 13.75 2.93325 13.6166C3.92492 13.1083 5.52492 12.5 7.49992 12.5C9.47492 12.5 11.0749 13.1083 12.0666 13.6166C12.3333 13.75 12.4999 14.0333 12.4999 14.35V15Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const UpdatePetsIcon = ({
  width = "20",
  height = "20",
  fillColor = "white",
}: IconValuesProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75008 9.58148C4.90067 9.58148 5.83342 8.64874 5.83342 7.49815C5.83342 6.34756 4.90067 5.41482 3.75008 5.41482C2.59949 5.41482 1.66675 6.34756 1.66675 7.49815C1.66675 8.64874 2.59949 9.58148 3.75008 9.58148Z"
        fill={fillColor}
      />
      <path
        d="M7.50008 6.24815C8.65068 6.24815 9.58342 5.31541 9.58342 4.16482C9.58342 3.01422 8.65068 2.08148 7.50008 2.08148C6.34949 2.08148 5.41675 3.01422 5.41675 4.16482C5.41675 5.31541 6.34949 6.24815 7.50008 6.24815Z"
        fill={fillColor}
      />
      <path
        d="M12.5001 6.24815C13.6507 6.24815 14.5834 5.31541 14.5834 4.16482C14.5834 3.01422 13.6507 2.08148 12.5001 2.08148C11.3495 2.08148 10.4167 3.01422 10.4167 4.16482C10.4167 5.31541 11.3495 6.24815 12.5001 6.24815Z"
        fill={fillColor}
      />
      <path
        d="M16.2501 9.58148C17.4007 9.58148 18.3334 8.64874 18.3334 7.49815C18.3334 6.34756 17.4007 5.41482 16.2501 5.41482C15.0995 5.41482 14.1667 6.34756 14.1667 7.49815C14.1667 8.64874 15.0995 9.58148 16.2501 9.58148Z"
        fill={fillColor}
      />
      <path
        d="M14.4501 11.9648C13.7251 11.1148 13.1167 10.3898 12.3834 9.53981C12.0001 9.08982 11.5084 8.63982 10.9251 8.43982C10.8334 8.40648 10.7417 8.38148 10.6501 8.36482C10.4417 8.33148 10.2167 8.33148 10.0001 8.33148C9.78341 8.33148 9.55841 8.33148 9.34175 8.37315C9.25008 8.38982 9.15842 8.41482 9.06675 8.44815C8.48342 8.64815 8.00008 9.09815 7.60842 9.54815C6.88342 10.3981 6.27508 11.1231 5.54175 11.9731C4.45008 13.0648 3.10841 14.2731 3.35842 15.9648C3.60008 16.8148 4.20842 17.6565 5.30008 17.8981C5.90841 18.0231 7.85008 17.5315 9.91675 17.5315H10.0667C12.1334 17.5315 14.0751 18.0148 14.6834 17.8981C15.7751 17.6565 16.3834 16.8065 16.6251 15.9648C16.8834 14.2648 15.5417 13.0565 14.4501 11.9648Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Paymenticon = ({
  width = "18",
  height = "18",
  fillColor = "white",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00002 0.666687C4.40002 0.666687 0.666687 4.40002 0.666687 9.00002C0.666687 13.6 4.40002 17.3334 9.00002 17.3334C13.6 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6 0.666687 9.00002 0.666687ZM9.00002 15.6667C5.32502 15.6667 2.33335 12.675 2.33335 9.00002C2.33335 5.32502 5.32502 2.33335 9.00002 2.33335C12.675 2.33335 15.6667 5.32502 15.6667 9.00002C15.6667 12.675 12.675 15.6667 9.00002 15.6667ZM9.74169 8.25002C8.25835 7.75835 7.54169 7.45002 7.54169 6.66669C7.54169 5.81669 8.46669 5.50835 9.05002 5.50835C10.1417 5.50835 10.5417 6.33335 10.6334 6.62502L11.95 6.06669C11.825 5.70002 11.2667 4.47502 9.73335 4.20835V3.16669H8.27502V4.21669C6.10835 4.68335 6.09169 6.59169 6.09169 6.68335C6.09169 8.57502 7.96669 9.10835 8.88335 9.44169C10.2 9.90835 10.7834 10.3334 10.7834 11.1334C10.7834 12.075 9.90835 12.475 9.13335 12.475C7.61669 12.475 7.18335 10.9167 7.13335 10.7334L5.75002 11.2917C6.27502 13.1167 7.65002 13.6084 8.26669 13.7584V14.8334H9.72502V13.8C10.1584 13.725 12.2417 13.3084 12.2417 11.1167C12.25 9.95835 11.7417 8.94169 9.74169 8.25002Z"
      fill={fillColor}
    />
  </svg>
);

export const BankIcon = ({
  width = "18",
  height = "18",
  fillColor = "white",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.83331 8.16669H2.16665V14H3.83331V8.16669ZM8.83331 8.16669H7.16665V14H8.83331V8.16669ZM15.9166 15.6667H0.083313V17.3334H15.9166V15.6667ZM13.8333 8.16669H12.1666V14H13.8333V8.16669ZM7.99998 2.55002L12.3416 4.83335H3.65831L7.99998 2.55002ZM7.99998 0.666687L0.083313 4.83335V6.50002H15.9166V4.83335L7.99998 0.666687Z"
      fill={fillColor}
    />
  </svg>
);

export const TimerIcon = ({
  width = "18",
  height = "18",
  fillColor = "white",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.25 0.5C6.10833 0.5 2.75 3.85833 2.75 8H0.25L3.49167 11.2417L3.55 11.3583L6.91667 8H4.41667C4.41667 4.775 7.025 2.16667 10.25 2.16667C13.475 2.16667 16.0833 4.775 16.0833 8C16.0833 11.225 13.475 13.8333 10.25 13.8333C8.64167 13.8333 7.18333 13.175 6.13333 12.1167L4.95 13.3C6.30833 14.6583 8.175 15.5 10.25 15.5C14.3917 15.5 17.75 12.1417 17.75 8C17.75 3.85833 14.3917 0.5 10.25 0.5ZM9.41667 4.66667V8.83333L12.9583 10.9333L13.6 9.86667L10.6667 8.125V4.66667H9.41667Z"
      fill={fillColor}
    />
  </svg>
);

export const ReportingIcon = ({
  width = "20",
  height = "20",
  fillColor = "white",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6666 1.66666H4.99998C4.08331 1.66666 3.33331 2.41666 3.33331 3.33332V16.6667C3.33331 17.5833 4.08331 18.3333 4.99998 18.3333H15C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V6.66666L11.6666 1.66666ZM4.99998 16.6667V3.33332H10.8333V6.66666H15V16.6667H4.99998ZM9.16665 15.8333H10.8333V15H11.6666C12.125 15 12.5 14.625 12.5 14.1667V11.6667C12.5 11.2083 12.125 10.8333 11.6666 10.8333H9.16665V9.99999H12.5V8.33332H10.8333V7.49999H9.16665V8.33332H8.33331C7.87498 8.33332 7.49998 8.70832 7.49998 9.16666V11.6667C7.49998 12.125 7.87498 12.5 8.33331 12.5H10.8333V13.3333H7.49998V15H9.16665V15.8333Z"
      fill={fillColor}
    />
  </svg>
);

export const CardIcon = ({
  width = "14",
  height = "12",
  fillColor = "black",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3333 0.666687L1.66668 0.666687C0.926677 0.666687 0.34001 1.26002 0.34001 2.00002L0.333344 10C0.333344 10.74 0.926677 11.3334 1.66668 11.3334H12.3333C13.0733 11.3334 13.6667 10.74 13.6667 10V2.00002C13.6667 1.26002 13.0733 0.666687 12.3333 0.666687ZM12.3333 10H1.66668L1.66668 6.00002L12.3333 6.00002V10ZM12.3333 3.33335L1.66668 3.33335L1.66668 2.00002L12.3333 2.00002V3.33335Z"
      fill={fillColor}
    />
  </svg>
);

export const ValidTickIcon = ({
  width = "16",
  height = "14",
  strokeColor = "#469721",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2L5.42857 12L2 8"
      stroke={strokeColor}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PayNowIcon = ({
  width = "14",
  height = "12",
  strokeColor = "#EBF2F3",
  strokeWidth = "1.5",
}: IconValuesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3.33333H13"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 9.99999H3C1.89543 9.99999 1 9.10456 1 7.99999V2.66666C1 1.56209 1.89543 0.666656 3 0.666656H11C12.1046 0.666656 13 1.56209 13 2.66666V6.66666"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 11.3333L13 9.99999L11.6667 8.66666"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.66669 9.99999H13"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.99998 5.99999H3.33331"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
